var _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg74165494786(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 3000 2000",
    style: {
      enableBackground: "new 0 0 3000 2000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.001,
    fill: "none",
    width: 3000,
    height: 2000
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 274.2119,
    y1: 990.0966,
    x2: 2838.2336,
    y2: 990.0966
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9DABE0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F7F8FC"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    d: "M274.212,1771.959v-618.362c0,0,60.267-406.351,516.018-304.385 c0,0,50.307-301.59,399.635-321.942c349.328-20.353,459.276-101.788,634.2-245.92c174.923-144.132,486.262-81.739,519.432,245.92 c26.172,258.536,381.856,112.777,460.959,211.923c169.243,212.13-352.53,1026.649-352.53,1026.649L274.212,1771.959z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D9DAE6"
    },
    d: "M2451.925,1765.842c0,0,90.418-141.148,183.767-321.232v-297.001h-50.889v-56.26h-90.354v56.26 h-44.228v618.237L2451.925,1765.842z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1363.765,785.806c-11.358-7.508-24.866-11.887-39.239-12.129 c-13.329-31.719-44.405-52.89-79.724-52.89c-21.194,0-41.292,7.86-56.789,21.338c-17.246-39.415-56.857-66.961-101.738-66.961 c-29.484,0-57.447,11.64-78.172,32.244c-2.967-0.47-5.965-0.708-8.968-0.708c-32.116,0-58.241,26.128-58.241,58.244 c0,7.212,1.335,14.266,3.877,20.861H1363.765z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2783.17,1081.344c-7.654-5.06-16.758-8.011-26.444-8.173 c-8.983-21.377-29.927-35.646-53.729-35.646c-14.283,0-27.828,5.298-38.271,14.381c-11.623-26.563-38.318-45.128-68.566-45.128 c-19.869,0-38.715,7.844-52.683,21.73c-1.999-0.316-4.021-0.477-6.044-0.477c-21.645,0-39.251,17.608-39.251,39.253 c0,4.86,0.899,9.614,2.612,14.059H2783.17z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M932.559,1091.904c-11.358-7.508-24.866-11.887-39.239-12.128 c-13.329-31.72-44.405-52.891-79.724-52.891c-21.194,0-41.292,7.86-56.789,21.338c-17.246-39.415-56.857-66.961-101.738-66.961 c-29.483,0-57.447,11.64-78.172,32.244c-2.966-0.471-5.964-0.708-8.968-0.708c-32.116,0-58.241,26.128-58.241,58.244 c0,7.212,1.335,14.266,3.877,20.861H932.559z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2321.051,453.936c-10.895-7.201-23.85-11.401-37.636-11.632 c-12.784-30.423-42.591-50.729-76.466-50.729c-20.328,0-39.605,7.539-54.469,20.466c-16.541-37.805-54.534-64.225-97.581-64.225 c-28.279,0-55.101,11.164-74.978,30.927c-2.846-0.451-5.722-0.679-8.603-0.679c-30.804,0-55.861,25.06-55.861,55.864 c0,6.918,1.28,13.683,3.719,20.009H2321.051z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 655.852,
    y: 1227.055,
    style: {
      fill: "#B2B0BE"
    },
    width: 612.092,
    height: 534.646
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B2B0BE"
    },
    d: "M2055.861,849.472h1.477v-1.759l0.213-0.254l-0.213-0.179v-2.96h-53.145v5.151h1.169 l22.656,26.525l-21.07,25.114h-2.042v5.151h51.718v-5.151h-1.526l-21.471-25.138L2055.861,849.472z M2010.99,849.472h39.283 l-19.466,23.201L2010.99,849.472z M2049.47,901.11h-36.933l18.301-21.813L2049.47,901.11z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B2B0BE"
    },
    d: "M2055.861,906.521h1.477v-1.759l0.213-0.254l-0.213-0.179v-2.959h-53.145v5.151h1.169 l22.656,26.525l-21.07,25.114h-2.042v5.151h51.718v-5.151h-1.526l-21.471-25.137L2055.861,906.521z M2010.99,906.521h39.283 l-19.466,23.201L2010.99,906.521z M2049.47,958.16h-36.933l18.301-21.813L2049.47,958.16z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B2B0BE"
    },
    d: "M2055.861,963.57h1.477v-1.759l0.213-0.254l-0.213-0.179v-2.96h-53.145v5.151h1.169 l22.656,26.525l-21.07,25.113h-2.042v5.151h51.718v-5.151h-1.526l-21.471-25.138L2055.861,963.57z M2010.99,963.57h39.283 l-19.466,23.201L2010.99,963.57z M2049.47,1015.209h-36.933l18.301-21.813L2049.47,1015.209z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B2B0BE"
    },
    d: "M2055.861,1020.62h1.477v-1.76l0.213-0.254l-0.213-0.178v-2.96h-53.145v5.151h1.169 l22.656,26.524l-21.07,25.114h-2.042v5.15h51.718v-5.15h-1.526l-21.471-25.138L2055.861,1020.62z M2010.99,1020.62h39.283 l-19.466,23.2L2010.99,1020.62z M2049.47,1072.259h-36.933l18.301-21.813L2049.47,1072.259z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B2B0BE"
    },
    d: "M2055.861,1077.669h1.477v-1.759l0.213-0.254l-0.213-0.179v-2.959h-53.145v5.15h1.169 l22.656,26.525l-21.07,25.113h-2.042v5.15h51.718v-5.15h-1.526l-21.471-25.137L2055.861,1077.669z M2010.99,1077.669h39.283 l-19.466,23.201L2010.99,1077.669z M2049.47,1129.308h-36.933l18.301-21.813L2049.47,1129.308z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B2B0BE"
    },
    d: "M2055.861,1134.718h1.477v-1.758l0.213-0.254l-0.213-0.18v-2.959h-53.145v5.15h1.169 l22.656,26.525l-21.07,25.114h-2.042v5.15h51.718v-5.15h-1.526l-21.471-25.138L2055.861,1134.718z M2010.99,1134.718h39.283 l-19.466,23.201L2010.99,1134.718z M2049.47,1186.357h-36.933l18.301-21.813L2049.47,1186.357z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B2B0BE"
    },
    d: "M2055.861,1191.768h1.477v-1.759l0.213-0.254l-0.213-0.179v-2.959h-53.145v5.15h1.169 l22.656,26.525l-21.07,25.113h-2.042v5.151h51.718v-5.151h-1.526l-21.471-25.138L2055.861,1191.768z M2010.99,1191.768h39.283 l-19.466,23.201L2010.99,1191.768z M2049.47,1243.406h-36.933l18.301-21.813L2049.47,1243.406z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B2B0BE"
    },
    d: "M2055.861,1248.817h1.477v-1.759l0.213-0.254l-0.213-0.179v-2.96h-53.145v5.151h1.169 l22.656,26.525l-21.07,25.113h-2.042v5.15h51.718v-5.15h-1.526l-21.471-25.138L2055.861,1248.817z M2010.99,1248.817h39.283 l-19.466,23.201L2010.99,1248.817z M2049.47,1300.456h-36.933l18.301-21.813L2049.47,1300.456z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B2B0BE"
    },
    d: "M2055.861,1305.866h1.477v-1.758l0.213-0.254l-0.213-0.18v-2.959h-53.145v5.15h1.169 l22.656,26.525l-21.07,25.113h-2.042v5.151h51.718v-5.151h-1.526l-21.471-25.137L2055.861,1305.866z M2010.99,1305.866h39.283 l-19.466,23.201L2010.99,1305.866z M2049.47,1357.505h-36.933l18.301-21.813L2049.47,1357.505z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B2B0BE"
    },
    d: "M2055.861,1362.916h1.477v-1.759l0.213-0.254l-0.213-0.179v-2.96h-53.145v5.151h1.169 l22.656,26.525l-21.07,25.113h-2.042v5.151h51.718v-5.151h-1.526l-21.471-25.138L2055.861,1362.916z M2010.99,1362.916h39.283 l-19.466,23.2L2010.99,1362.916z M2049.47,1414.555h-36.933l18.301-21.813L2049.47,1414.555z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B2B0BE"
    },
    d: "M2055.861,1419.966h1.477v-1.759l0.213-0.254l-0.213-0.179v-2.96h-53.145v5.151h1.169 l22.656,26.525l-21.07,25.113h-2.042v5.15h51.718v-5.15h-1.526l-21.471-25.138L2055.861,1419.966z M2010.99,1419.966h39.283 l-19.466,23.2L2010.99,1419.966z M2049.47,1471.604h-36.933l18.301-21.813L2049.47,1471.604z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B2B0BE"
    },
    d: "M2055.861,1477.015h1.477v-1.758l0.213-0.255l-0.213-0.179v-2.959h-53.145v5.15h1.169 l22.656,26.525l-21.07,25.113h-2.042v5.151h51.718v-5.151h-1.526l-21.471-25.137L2055.861,1477.015z M2010.99,1477.015h39.283 l-19.466,23.201L2010.99,1477.015z M2049.47,1528.653h-36.933l18.301-21.813L2049.47,1528.653z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B2B0BE"
    },
    d: "M2055.861,1534.064h1.477v-1.759l0.213-0.254l-0.213-0.18v-2.959h-53.145v5.151h1.169 l22.656,26.525l-21.07,25.113h-2.042v5.151h51.718v-5.151h-1.526l-21.471-25.137L2055.861,1534.064z M2010.99,1534.064h39.283 l-19.466,23.201L2010.99,1534.064z M2049.47,1585.703h-36.933l18.301-21.813L2049.47,1585.703z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B2B0BE"
    },
    d: "M2055.861,1591.113h1.477v-1.758l0.213-0.254l-0.213-0.18v-2.959h-53.145v5.15h1.169 l22.656,26.525l-21.07,25.114h-2.042v5.15h51.718v-5.15h-1.526l-21.471-25.138L2055.861,1591.113z M2010.99,1591.113h39.283 l-19.466,23.201L2010.99,1591.113z M2049.47,1642.753h-36.933l18.301-21.813L2049.47,1642.753z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B2B0BE"
    },
    d: "M1821.149,719.199h2.976v-4.815c0-5.178,4.212-9.391,9.391-9.391s9.391,4.213,9.391,9.391 v4.815h2.977v-4.815c0-6.818-5.549-12.366-12.367-12.366s-12.366,5.548-12.366,12.366V719.199z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B2B0BE"
    },
    d: "M1824.064,685.059v-71.803c0-5.599,4.48-10.154,9.986-10.154s9.987,4.555,9.987,10.154v71.803 c0,5.599-4.481,10.154-9.987,10.154S1824.064,690.658,1824.064,685.059z M1826.918,613.256v71.803 c0,3.999,3.199,7.253,7.133,7.253s7.134-3.254,7.134-7.253v-71.803c0-3.999-3.2-7.253-7.134-7.253 S1826.918,609.257,1826.918,613.256z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1830.484,
    y: 682.283,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 3667.2109 1390.4253)",
    style: {
      fill: "#B2B0BE"
    },
    width: 6.242,
    height: 25.859
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B2B0BE"
    },
    d: "M1829.038,622.719h22.628c2.682,0,4.855-2.174,4.855-4.854v-73.277 c0-2.681-2.174-4.854-4.855-4.854h-22.628c-2.682,0-4.855,2.173-4.855,4.854v73.277 C1824.183,620.545,1826.356,622.719,1829.038,622.719z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B2B0BE"
    },
    d: "M2003.218,496.734h54.689v1193.973h-54.689V496.734z M2053.627,501.014h-46.129v1185.414h46.129 V501.014z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B2B0BE"
    },
    d: "M2028.116,590.726l-21.472,25.138h-1.525v5.151h51.718v-5.151h-2.042l-21.07-25.114 l22.657-26.525h1.169v-5.151h-53.145v2.96l-0.213,0.179l0.213,0.254v1.759h1.476L2028.116,590.726z M2030.936,587.425 l-19.466-23.201h39.283L2030.936,587.425z M2030.906,594.05l18.301,21.813h-36.934L2030.906,594.05z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B2B0BE"
    },
    d: "M2028.116,647.775l-21.472,25.137h-1.525v5.151h51.718v-5.151h-2.042l-21.07-25.114 l22.657-26.525h1.169v-5.15h-53.145v2.959l-0.213,0.179l0.213,0.254v1.758h1.476L2028.116,647.775z M2030.936,644.475 l-19.466-23.201h39.283L2030.936,644.475z M2030.906,651.1l18.301,21.813h-36.934L2030.906,651.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B2B0BE"
    },
    d: "M2028.116,704.824l-21.472,25.138h-1.525v5.151h51.718v-5.151h-2.042l-21.07-25.113 l22.657-26.525h1.169v-5.151h-53.145v2.959l-0.213,0.179l0.213,0.254v1.759h1.476L2028.116,704.824z M2030.936,701.524 l-19.466-23.201h39.283L2030.936,701.524z M2030.906,708.149l18.301,21.813h-36.934L2030.906,708.149z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B2B0BE"
    },
    d: "M2028.116,761.874l-21.472,25.138h-1.525v5.15h51.718v-5.15h-2.042l-21.07-25.114l22.657-26.525 h1.169v-5.151h-53.145v2.96l-0.213,0.179l0.213,0.254v1.758h1.476L2028.116,761.874z M2030.936,758.573l-19.466-23.201h39.283 L2030.936,758.573z M2030.906,765.198l18.301,21.814h-36.934L2030.906,765.198z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B2B0BE"
    },
    d: "M2028.116,818.923l-21.472,25.138h-1.525v5.151h51.718v-5.151h-2.042l-21.07-25.114 l22.657-26.525h1.169v-5.151h-53.145v2.96l-0.213,0.179l0.213,0.254v1.758h1.476L2028.116,818.923z M2030.936,815.623 l-19.466-23.201h39.283L2030.936,815.623z M2030.906,822.248l18.301,21.813h-36.934L2030.906,822.248z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B2B0BE"
    },
    d: "M2050.773,366.151h-15.219c-2.363,0-4.279,1.917-4.279,4.28v126.303 c0,2.364,1.916,4.28,4.279,4.28h15.219c2.364,0,4.28-1.916,4.28-4.28V370.431 C2055.054,368.068,2053.138,366.151,2050.773,366.151z M2039.835,370.431h6.659c2.363,0,4.279,1.917,4.279,4.28v34.954 c0,2.364-1.916,4.28-4.279,4.28h-6.659c-2.363,0-4.28-1.916-4.28-4.28v-34.954 C2035.555,372.348,2037.472,370.431,2039.835,370.431z M2039.835,418.939h6.659c2.363,0,4.279,1.917,4.279,4.28v20.687 c0,2.364-1.916,4.28-4.279,4.28h-6.659c-2.363,0-4.28-1.917-4.28-4.28v-20.687 C2035.555,420.855,2037.472,418.939,2039.835,418.939z M2046.494,496.734h-6.659c-2.363,0-4.28-1.917-4.28-4.28V457.46 c0-2.364,1.917-4.28,4.28-4.28h6.659c2.363,0,4.279,1.916,4.279,4.28v34.994 C2050.773,494.818,2048.857,496.734,2046.494,496.734z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B2B0BE"
    },
    d: "M1700.521,546.976v-39.413c0-6.294,5.12-11.415,11.415-11.415h360.109 c0.813,0,1.63,0.088,2.422,0.261l164.197,35.668c5.211,1.132,8.993,5.822,8.993,11.154v3.745 c0,6.294-5.12,11.415-11.415,11.415h-524.307C1705.641,558.391,1700.521,553.269,1700.521,546.976z M1711.936,503.281 c-2.36,0-4.281,1.921-4.281,4.282v39.413c0,2.361,1.921,4.282,4.281,4.282h524.307c2.36,0,4.281-1.92,4.281-4.282v-3.745 c0-1.999-1.418-3.759-3.373-4.184l-164.197-35.668c-0.299-0.064-0.604-0.098-0.908-0.098H1711.936z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B2B0BE"
    },
    d: "M1700.521,507.556v39.419c0,6.292,5.122,11.414,11.413,11.414h524.311 c6.291,0,11.413-5.122,11.413-11.414v-3.738c0-5.336-3.78-10.03-8.988-11.157c-0.271-0.059-163.979-35.62-164.198-35.668 c-2.415-0.518,20.631-0.166-362.537-0.271C1705.643,496.143,1700.521,501.264,1700.521,507.556z M1707.654,543.747 c0.041-38.157-0.102-36.247,0.112-37.161l11.14,17.684C1721.132,527.801,1716.959,529.627,1707.654,543.747z M2080.329,505.131 l12.062,19.131c2.228,3.589-1.692,4.917-14.121,23.471l-12.057-19.139c-0.773-1.228-0.726-2.803,0.121-3.982L2080.329,505.131z  M2072.058,551.256h-24.864l10.157-14.139c1.477-2.056,4.565-1.961,5.914,0.18L2072.058,551.256z M1767.571,528.594 c-2.243-3.563,1.723-4.956,14.118-23.465l12.057,19.141c0.774,1.229,0.727,2.803-0.12,3.982l-13.997,19.483L1767.571,528.594z  M1765.279,515.746c-1.477,2.056-4.565,1.961-5.914-0.18l-7.742-12.29h22.615L1765.279,515.746z M1788.953,503.276h22.615 l-8.959,12.47c-1.477,2.056-4.565,1.961-5.914-0.18L1788.953,503.276z M1804.901,528.594c-0.773-1.228-0.726-2.803,0.122-3.982 l13.996-19.483l12.057,19.141c0.774,1.229,0.727,2.803-0.12,3.982l-13.997,19.483L1804.901,528.594z M1826.283,503.276h22.615 l-8.959,12.47c-1.477,2.056-4.565,1.961-5.914-0.18L1826.283,503.276z M1842.232,528.594 c-2.244-3.563,1.723-4.956,14.117-23.465l12.058,19.141c2.244,3.563-1.723,4.956-14.118,23.465L1842.232,528.594z  M1863.613,503.276h22.615l-8.959,12.47c-1.477,2.056-4.564,1.961-5.914-0.18L1863.613,503.276z M1879.563,528.594 c-2.244-3.563,1.723-4.956,14.117-23.465l12.058,19.141c0.773,1.229,0.726,2.803-0.121,3.982l-13.997,19.483L1879.563,528.594z  M1900.943,503.276h22.615l-8.959,12.47c-1.477,2.056-4.564,1.961-5.914-0.18L1900.943,503.276z M1916.893,528.594 c-0.773-1.228-0.726-2.803,0.121-3.982l13.996-19.483l12.059,19.141c0.773,1.229,0.725,2.803-0.122,3.982l-13.997,19.483 L1916.893,528.594z M1938.273,503.276h22.615l-8.959,12.47c-1.477,2.056-4.564,1.961-5.914-0.18L1938.273,503.276z  M1954.223,528.594c-0.773-1.228-0.726-2.803,0.121-3.982l13.996-19.483l12.059,19.141c0.773,1.229,0.725,2.803-0.122,3.982 l-13.996,19.483L1954.223,528.594z M1975.604,503.276h22.615l-8.959,12.47c-1.477,2.056-4.564,1.961-5.914-0.18 L1975.604,503.276z M1991.553,528.594c-0.773-1.228-0.726-2.803,0.121-3.982l13.996-19.483l12.059,19.141 c2.243,3.563-1.723,4.956-14.118,23.465L1991.553,528.594z M2012.934,503.276h22.615l-8.958,12.47 c-1.478,2.056-4.565,1.961-5.915-0.18L2012.934,503.276z M2055.059,524.269c0.773,1.229,0.726,2.803-0.121,3.982 l-13.997,19.483l-12.058-19.14c-0.773-1.228-0.726-2.803,0.121-3.982L2043,505.129L2055.059,524.269z M2034.728,551.256 h-24.864l10.157-14.139c1.477-2.056,4.565-1.961,5.914,0.18L2034.728,551.256z M1997.397,551.256h-24.864l10.157-14.139 c1.477-2.056,4.565-1.961,5.914,0.18L1997.397,551.256z M1960.067,551.256h-24.864l10.157-14.139 c1.477-2.056,4.565-1.961,5.914,0.18L1960.067,551.256z M1922.737,551.256h-24.864l10.157-14.139 c1.477-2.056,4.565-1.961,5.914,0.18L1922.737,551.256z M1885.406,551.256h-24.863l10.156-14.139 c1.477-2.056,4.565-1.961,5.914,0.18L1885.406,551.256z M1848.076,551.256h-24.863l10.156-14.139 c1.477-2.056,4.565-1.961,5.914,0.18L1848.076,551.256z M1810.746,551.256h-24.863l10.156-14.139 c1.477-2.056,4.565-1.961,5.914,0.18L1810.746,551.256z M1773.416,551.256h-24.863l10.156-14.139 c1.477-2.056,4.565-1.961,5.914,0.18L1773.416,551.256z M1730.183,524.612l14.093-19.617 c10.539,18.083,14.472,19.842,12.021,23.256l-14.093,19.616C1731.664,529.785,1727.73,528.025,1730.183,524.612z  M1727.77,515.746c-1.477,2.056-4.565,1.961-5.914-0.18l-7.742-12.29h22.615L1727.77,515.746z M2072.825,503.352l-8.904,12.395 c-1.477,2.056-4.565,1.961-5.915-0.18l-7.741-12.29C2073.253,503.308,2071.979,503.206,2072.825,503.352z M2105.116,510.367 l-3.866,5.378c-1.469,2.054-4.565,1.969-5.906-0.186l-5.351-8.489L2105.116,510.367z M2123.464,514.347l6.249,9.915 c2.262,3.579-1.766,5.049-14.107,23.471l-12.059-19.134c-0.771-1.227-0.728-2.81,0.114-3.981l9.045-12.612L2123.464,514.347z  M2136.404,517.158c-0.971,0.2-1.998,0-2.811-0.614L2136.404,517.158z M2166.721,523.749c0.046,0.143,1.853,2.223,0.2,4.508 l-13.996,19.475l-12.056-19.132c-0.771-1.227-0.727-2.81,0.129-3.981l4.009-5.592L2166.721,523.749z M2201.988,531.41 l-11.727,16.322c-12.045-19.691-12.951-19.258-12.556-21.6L2201.988,531.41z M2236.244,551.256h-6.777 c-0.253-1.393-0.199-0.653-9.744-15.993l17.435,3.78c4.623,1.013,3.127,6.661,3.366,7.933 C2240.523,549.33,2238.598,551.256,2236.244,551.256z M2196.524,551.256l10.144-14.139c1.484-2.055,4.566-1.955,5.921,0.185 l8.789,13.953H2196.524z M2159.188,551.256l10.158-14.139c1.47-2.055,4.566-1.955,5.906,0.185l8.803,13.953H2159.188z  M2121.866,551.256l10.144-14.139c1.483-2.055,4.565-1.955,5.921,0.185l8.788,13.953H2121.866z M2084.529,551.256 l10.158-14.139c1.469-2.055,4.564-1.955,5.906,0.185l8.803,13.953H2084.529z M1711.934,551.256 c-0.285,0-0.563-0.029-0.832-0.083l10.098-14.056c1.477-2.056,4.565-1.961,5.914,0.18l8.793,13.958H1711.934z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B2B0BE"
    },
    d: "M2198.317,687.396h7.134c2.43,0,4.398-1.97,4.398-4.399V560.301 c0-2.429-1.969-4.399-4.398-4.399h-7.134c-2.429,0-4.399,1.97-4.399,4.399v122.696 C2193.918,685.426,2195.889,687.396,2198.317,687.396z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B2B0BE"
    },
    d: "M2131.145,597.989h91.783c4.071,0,7.371-3.3,7.371-7.371V577.54c0-4.071-3.3-7.371-7.371-7.371 h-91.783c-4.071,0-7.372,3.3-7.372,7.371v13.078C2123.772,594.69,2127.073,597.989,2131.145,597.989z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B2B0BE"
    },
    d: "M2131.145,630.033h91.783c4.071,0,7.371-3.3,7.371-7.371v-13.078c0-4.071-3.3-7.371-7.371-7.371 h-91.783c-4.071,0-7.372,3.3-7.372,7.371v13.078C2123.772,626.733,2127.073,630.033,2131.145,630.033z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B2B0BE"
    },
    d: "M2131.145,661.003h91.783c4.071,0,7.371-3.3,7.371-7.371v-13.078c0-4.071-3.3-7.372-7.371-7.372 h-91.783c-4.071,0-7.372,3.301-7.372,7.372v13.078C2123.772,657.703,2127.073,661.003,2131.145,661.003z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B2B0BE"
    },
    d: "M2131.145,694.517h91.783c4.071,0,7.371-3.301,7.371-7.372v-13.078 c0-4.071-3.3-7.371-7.371-7.371h-91.783c-4.071,0-7.372,3.3-7.372,7.371v13.078 C2123.772,691.216,2127.073,694.517,2131.145,694.517z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B2B0BE"
    },
    d: "M2233.389,537.831c0.986,0,1.969-0.407,2.674-1.205c1.306-1.476,1.166-3.73-0.311-5.035 l-191.949-169.634l-298.551,133.662c-1.799,0.805-2.603,2.915-1.799,4.713c0.806,1.798,2.916,2.602,4.714,1.798 l294.357-131.784l188.505,166.591C2231.707,537.536,2232.551,537.831,2233.389,537.831z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B2B0BE"
    },
    d: "M2041.322,370.55h2.854c1.083,0,1.961-0.878,1.961-1.961v-18.19 c0-1.083-0.878-1.961-1.961-1.961h-2.854c-1.084,0-1.963,0.878-1.963,1.961v18.19 C2039.359,369.672,2040.238,370.55,2041.322,370.55z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B2B0BE"
    },
    d: "M1667.795,552.127h37.094v-31.863h-37.094c-8.799,0-15.932,7.133-15.932,15.932l0,0 C1651.863,544.995,1658.996,552.127,1667.795,552.127z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B2B0BE"
    },
    d: "M1679.892,575.073h0.179c4.383,0,7.936-3.553,7.936-7.936v-23.452h-16.05v23.452 C1671.956,571.521,1675.509,575.073,1679.892,575.073z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1753.093,
    y: 504.474,
    transform: "matrix(0.3468 -0.9379 0.9379 0.3468 598.0502 2028.1886)",
    style: {
      fill: "#B2B0BE"
    },
    width: 4.28,
    height: 160.459
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1802.677,
    y: 717.743,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 3663.8477 1453.1406)",
    style: {
      fill: "#B2B0BE"
    },
    width: 58.494,
    height: 17.655
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B2B0BE"
    },
    d: "M1801.428,735.398h60.1c9.948,0,18.013,8.065,18.013,18.012v2.318h-96.124v-2.318 C1783.416,743.462,1791.48,735.398,1801.428,735.398z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B2B0BE"
    },
    d: "M1782.524,755.729v52.788h98.085v-52.788H1782.524z M1795.9,764.378 c0-2.315,1.876-4.191,4.19-4.191h61.348c2.314,0,4.19,1.876,4.19,4.191v2.675c0,2.315-1.876,4.191-4.19,4.191h-61.348 c-2.314,0-4.19-1.877-4.19-4.191V764.378z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8D7DF"
    },
    d: "M936.233,1771.959H826.009c-2.574,0-4.66-2.086-4.66-4.66V913.52 c0-3.555,3.821-5.801,6.927-4.071l110.225,61.38c1.477,0.823,2.393,2.381,2.393,4.072v792.398 C940.894,1769.873,938.808,1771.959,936.233,1771.959z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8D7DF"
    },
    d: "M1131.274,1771.959H987.107c-2.574,0-4.66-2.086-4.66-4.66V1066.23c0-2.574,2.086-4.66,4.66-4.66 h144.168c2.574,0,4.66,2.086,4.66,4.66v701.068C1135.935,1769.873,1133.848,1771.959,1131.274,1771.959z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8D7DF"
    },
    d: "M1069.927,1061.57h-65.819c-2.574,0-4.66-2.087-4.66-4.66v-71.955c0-2.574,2.086-4.66,4.66-4.66 h65.819c2.574,0,4.66,2.086,4.66,4.66v71.955C1074.587,1059.483,1072.5,1061.57,1069.927,1061.57z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8D7DF"
    },
    d: "M1241.32,1062.151h-102.913c-2.574,0-4.66-2.086-4.66-4.66v-219.27c0-2.574,2.086-4.66,4.66-4.66 h102.913c1.82,1.82,2.841,2.84,4.66,4.66v219.27C1245.98,1060.065,1243.895,1062.151,1241.32,1062.151z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8D7DF"
    },
    d: "M1577.128,639.294h-122.661c-1.82,1.819-2.84,2.84-4.66,4.66v230.341 c0,2.573-2.086,4.66-4.66,4.66h-33.481c-2.574,0-4.66-2.087-4.66-4.66V682.271c0-2.573-2.086-4.66-4.66-4.66h-78.422 c-2.574,0-4.66,2.087-4.66,4.66v1085.027c0,2.574,2.086,4.66,4.66,4.66h269.123c2.573,0,4.66-2.086,4.66-4.66V661.115 c0-1.175-0.444-2.308-1.243-3.169l-15.921-17.162C1579.662,639.834,1578.424,639.294,1577.128,639.294z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8D7DF"
    },
    d: "M1943.443,1193.266v39.104c0,2.573-2.086,4.66-4.66,4.66h-43.468c-2.573,0-4.66,2.087-4.66,4.66 v525.609c0,2.574,2.087,4.66,4.66,4.66h207.538c2.573,0,4.66-2.086,4.66-4.66v-574.033c0-2.573-2.087-4.66-4.66-4.66h-154.75 C1945.529,1188.605,1943.443,1190.692,1943.443,1193.266z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1449.807,
    y: 690.335,
    style: {
      fill: "#FFFFFF"
    },
    width: 147.901,
    height: 24.518
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1449.807,
    y: 739.116,
    style: {
      fill: "#FFFFFF"
    },
    width: 147.901,
    height: 24.518
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1449.807,
    y: 787.898,
    style: {
      fill: "#FFFFFF"
    },
    width: 147.901,
    height: 24.518
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1449.807,
    y: 836.678,
    style: {
      fill: "#FFFFFF"
    },
    width: 147.901,
    height: 24.518
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1449.807,
    y: 885.459,
    style: {
      fill: "#FFFFFF"
    },
    width: 147.901,
    height: 24.518
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1449.807,
    y: 934.24,
    style: {
      fill: "#FFFFFF"
    },
    width: 147.901,
    height: 24.519
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1449.807,
    y: 983.021,
    style: {
      fill: "#FFFFFF"
    },
    width: 147.901,
    height: 24.518
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1449.807,
    y: 1031.802,
    style: {
      fill: "#FFFFFF"
    },
    width: 147.901,
    height: 24.518
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1449.807,
    y: 1080.583,
    style: {
      fill: "#FFFFFF"
    },
    width: 147.901,
    height: 24.519
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1449.807,
    y: 1129.364,
    style: {
      fill: "#FFFFFF"
    },
    width: 147.901,
    height: 24.517
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1449.807,
    y: 1178.146,
    style: {
      fill: "#FFFFFF"
    },
    width: 147.901,
    height: 24.518
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1449.807,
    y: 1226.926,
    style: {
      fill: "#FFFFFF"
    },
    width: 147.901,
    height: 24.518
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1449.807,
    y: 1275.707,
    style: {
      fill: "#FFFFFF"
    },
    width: 147.901,
    height: 24.519
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1449.807,
    y: 1324.488,
    style: {
      fill: "#FFFFFF"
    },
    width: 147.901,
    height: 24.518
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1449.807,
    y: 1373.269,
    style: {
      fill: "#FFFFFF"
    },
    width: 147.901,
    height: 24.52
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1449.807,
    y: 1422.05,
    style: {
      fill: "#FFFFFF"
    },
    width: 147.901,
    height: 24.519
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1449.807,
    y: 1470.831,
    style: {
      fill: "#FFFFFF"
    },
    width: 147.901,
    height: 24.518
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1449.807,
    y: 1519.612,
    style: {
      fill: "#FFFFFF"
    },
    width: 147.901,
    height: 24.518
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1449.807,
    y: 1568.394,
    style: {
      fill: "#FFFFFF"
    },
    width: 147.901,
    height: 24.518
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1449.807,
    y: 1617.175,
    style: {
      fill: "#FFFFFF"
    },
    width: 147.901,
    height: 24.519
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1449.807,
    y: 1665.955,
    style: {
      fill: "#FFFFFF"
    },
    width: 147.901,
    height: 24.52
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8D7DF"
    },
    d: "M869.861,943.213h-22.067c-2.574,0-4.66-2.086-4.66-4.66v-55.516c0-2.573,2.086-4.66,4.66-4.66 h22.067c2.573,0,4.66,2.087,4.66,4.66v55.516C874.521,941.127,872.435,943.213,869.861,943.213z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D9DAE6"
    },
    points: "408.793,1153.597 408.793,1097.337 318.44,1097.337 318.44,1153.597 274.212,1153.597  274.212,1771.959 459.682,1771.959 459.682,1153.597  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#CDCCD4"
    },
    points: "1387.033,1173.396 1387.038,1075.575 1302.145,1075.575 1302.145,1201.702  1258.155,1201.702 1258.155,1052.342 1124.046,1052.342 1092.658,1077.76 1092.658,1771.959 1402.727,1771.959  1402.727,1197.658  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1569.649,
    y: 1199.969,
    style: {
      fill: "#E7E8EC"
    },
    width: 209.724,
    height: 571.99
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1630.047,
    y: 1149.519,
    style: {
      fill: "#E7E8EC"
    },
    width: 106.525,
    height: 50.45
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E7E8EC"
    },
    d: "M1711.844,1149.519h-58.02v-46.985h37.477c8.022,8.022,12.521,12.521,20.543,20.542V1149.519z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E7E8EC"
    },
    d: "M1889.508,1135.231v-19.219h-30.059l-2.756-99.746l-2.754,99.746h-30.06v19.219 c-7.745,2.597-13.194,8.777-13.194,15.988v620.739h92.017V1151.22C1902.702,1144.009,1897.254,1137.828,1889.508,1135.231z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CDCCD4"
    },
    d: "M1551.754,1771.959h-119.837v-730.173c10.529-10.529,16.433-16.433,26.962-26.961h65.913 c10.529,10.528,16.433,16.432,26.962,26.961V1771.959z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1092.658,
    y: 1093.721,
    style: {
      fill: "#9A999F"
    },
    width: 165.497,
    height: 27.86
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1092.658,
    y: 1135.588,
    style: {
      fill: "#9A999F"
    },
    width: 165.497,
    height: 27.86
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1092.658,
    y: 1177.456,
    style: {
      fill: "#9A999F"
    },
    width: 165.497,
    height: 27.859
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1092.658,
    y: 1219.323,
    style: {
      fill: "#9A999F"
    },
    width: 165.497,
    height: 27.859
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1092.658,
    y: 1261.19,
    style: {
      fill: "#9A999F"
    },
    width: 165.497,
    height: 27.859
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1092.658,
    y: 1303.058,
    style: {
      fill: "#9A999F"
    },
    width: 165.497,
    height: 27.859
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1092.658,
    y: 1344.925,
    style: {
      fill: "#9A999F"
    },
    width: 165.497,
    height: 27.859
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1092.658,
    y: 1386.792,
    style: {
      fill: "#9A999F"
    },
    width: 165.497,
    height: 27.86
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1092.658,
    y: 1428.659,
    style: {
      fill: "#9A999F"
    },
    width: 165.497,
    height: 27.86
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1092.658,
    y: 1470.526,
    style: {
      fill: "#9A999F"
    },
    width: 165.497,
    height: 27.86
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1092.658,
    y: 1512.395,
    style: {
      fill: "#9A999F"
    },
    width: 165.497,
    height: 27.859
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1092.658,
    y: 1554.262,
    style: {
      fill: "#9A999F"
    },
    width: 165.497,
    height: 27.859
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1092.658,
    y: 1596.129,
    style: {
      fill: "#9A999F"
    },
    width: 165.497,
    height: 27.86
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1092.658,
    y: 1637.996,
    style: {
      fill: "#9A999F"
    },
    width: 165.497,
    height: 27.86
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1092.658,
    y: 1679.863,
    style: {
      fill: "#9A999F"
    },
    width: 165.497,
    height: 27.86
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1092.658,
    y: 1721.731,
    style: {
      fill: "#9A999F"
    },
    width: 165.497,
    height: 27.86
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B2B0BE"
    },
    d: "M1767.192,1774.401h210.261c3.201,0,5.795-2.595,5.795-5.795v-630.471 c0-3.201-2.594-5.795-5.795-5.795h-210.261c-3.2,0-5.795,2.594-5.795,5.795v630.471 C1761.397,1771.807,1763.992,1774.401,1767.192,1774.401z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B2B0BE"
    },
    d: "M1766.376,1774.401h153.757c2.749,0,4.978-2.229,4.978-4.978v-632.105 c0-2.749-2.229-4.978-4.978-4.978h-153.757c-2.749,0-4.979,2.229-4.979,4.978v632.105 C1761.397,1772.173,1763.627,1774.401,1766.376,1774.401z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1940.315,1188.605h-162.313c-5.165,0-9.353-4.188-9.353-9.353v-8.358 c0-5.165,4.188-9.353,9.353-9.353h162.313c5.165,0,9.353,4.188,9.353,9.353v8.358 C1949.668,1184.418,1945.48,1188.605,1940.315,1188.605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1940.315,1229.866h-162.313c-5.165,0-9.353-4.188-9.353-9.353v-8.358 c0-5.166,4.188-9.353,9.353-9.353h162.313c5.165,0,9.353,4.187,9.353,9.353v8.358 C1949.668,1225.679,1945.48,1229.866,1940.315,1229.866z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1940.315,1271.126h-162.313c-5.165,0-9.353-4.187-9.353-9.352v-8.359 c0-5.165,4.188-9.352,9.353-9.352h162.313c5.165,0,9.353,4.187,9.353,9.352v8.359 C1949.668,1266.939,1945.48,1271.126,1940.315,1271.126z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1940.315,1312.387h-162.313c-5.165,0-9.353-4.187-9.353-9.353v-8.358 c0-5.165,4.188-9.353,9.353-9.353h162.313c5.165,0,9.353,4.188,9.353,9.353v8.358 C1949.668,1308.2,1945.48,1312.387,1940.315,1312.387z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1940.315,1353.647h-162.313c-5.165,0-9.353-4.188-9.353-9.353v-8.358 c0-5.165,4.188-9.353,9.353-9.353h162.313c5.165,0,9.353,4.188,9.353,9.353v8.358 C1949.668,1349.46,1945.48,1353.647,1940.315,1353.647z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1940.315,1394.908h-162.313c-5.165,0-9.353-4.188-9.353-9.353v-8.358 c0-5.165,4.188-9.353,9.353-9.353h162.313c5.165,0,9.353,4.188,9.353,9.353v8.358 C1949.668,1390.721,1945.48,1394.908,1940.315,1394.908z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1940.315,1436.169h-162.313c-5.165,0-9.353-4.188-9.353-9.354v-8.357 c0-5.166,4.188-9.354,9.353-9.354h162.313c5.165,0,9.353,4.188,9.353,9.354v8.357 C1949.668,1431.981,1945.48,1436.169,1940.315,1436.169z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1940.315,1477.429h-162.313c-5.165,0-9.353-4.188-9.353-9.353v-8.358 c0-5.165,4.188-9.352,9.353-9.352h162.313c5.165,0,9.353,4.187,9.353,9.352v8.358 C1949.668,1473.241,1945.48,1477.429,1940.315,1477.429z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1940.315,1518.689h-162.313c-5.165,0-9.353-4.188-9.353-9.353v-8.358 c0-5.165,4.188-9.353,9.353-9.353h162.313c5.165,0,9.353,4.188,9.353,9.353v8.358 C1949.668,1514.502,1945.48,1518.689,1940.315,1518.689z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1940.315,1559.95h-162.313c-5.165,0-9.353-4.188-9.353-9.353v-8.358 c0-5.166,4.188-9.353,9.353-9.353h162.313c5.165,0,9.353,4.187,9.353,9.353v8.358 C1949.668,1555.763,1945.48,1559.95,1940.315,1559.95z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1940.315,1601.211h-162.313c-5.165,0-9.353-4.188-9.353-9.353v-8.358 c0-5.166,4.188-9.353,9.353-9.353h162.313c5.165,0,9.353,4.187,9.353,9.353v8.358 C1949.668,1597.023,1945.48,1601.211,1940.315,1601.211z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1940.315,1642.471h-162.313c-5.165,0-9.353-4.187-9.353-9.352v-8.358 c0-5.165,4.188-9.353,9.353-9.353h162.313c5.165,0,9.353,4.188,9.353,9.353v8.358 C1949.668,1638.284,1945.48,1642.471,1940.315,1642.471z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1940.315,1683.731h-162.313c-5.165,0-9.353-4.187-9.353-9.353v-8.357 c0-5.166,4.188-9.354,9.353-9.354h162.313c5.165,0,9.353,4.188,9.353,9.354v8.357 C1949.668,1679.545,1945.48,1683.731,1940.315,1683.731z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1940.315,1724.992h-162.313c-5.165,0-9.353-4.188-9.353-9.353v-8.358 c0-5.165,4.188-9.353,9.353-9.353h162.313c5.165,0,9.353,4.188,9.353,9.353v8.358 C1949.668,1720.805,1945.48,1724.992,1940.315,1724.992z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1940.315,1766.253h-162.313c-5.165,0-9.353-4.188-9.353-9.353v-8.358 c0-5.165,4.188-9.353,9.353-9.353h162.313c5.165,0,9.353,4.188,9.353,9.353v8.358 C1949.668,1762.065,1945.48,1766.253,1940.315,1766.253z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C8C6D3"
    },
    d: "M776.171,1771.959H449.457c-3.546,0-6.419-2.874-6.419-6.42v-694.328 c0-3.545,2.874-6.419,6.419-6.419h326.714c3.545,0,6.419,2.874,6.419,6.419v694.328 C782.59,1769.085,779.716,1771.959,776.171,1771.959z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M483.936,1160.687h-17.835c-3.545,0-6.42-2.874-6.42-6.42v-50.128c0-3.545,2.875-6.419,6.42-6.419 h17.835c3.545,0,6.419,2.874,6.419,6.419v50.128C490.356,1157.813,487.482,1160.687,483.936,1160.687z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M536.367,1160.687h-4.281c-3.545,0-6.419-2.874-6.419-6.42v-50.128 c0-3.545,2.874-6.419,6.419-6.419h4.281c3.546,0,6.42,2.874,6.42,6.419v50.128 C542.787,1157.813,539.913,1160.687,536.367,1160.687z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M614.122,1160.687h-17.835c-3.545,0-6.419-2.874-6.419-6.42v-50.128 c0-3.545,2.874-6.419,6.419-6.419h17.835c3.545,0,6.419,2.874,6.419,6.419v50.128 C620.542,1157.813,617.667,1160.687,614.122,1160.687z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M745.378,1160.687h-17.835c-3.545,0-6.419-2.874-6.419-6.42v-50.128 c0-3.545,2.874-6.419,6.419-6.419h17.835c3.545,0,6.42,2.874,6.42,6.419v50.128 C751.797,1157.813,748.923,1160.687,745.378,1160.687z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M745.378,1233.474h-17.835c-3.545,0-6.419-2.873-6.419-6.419v-50.128 c0-3.546,2.874-6.42,6.419-6.42h17.835c3.545,0,6.42,2.874,6.42,6.42v50.128C751.797,1230.601,748.923,1233.474,745.378,1233.474 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M745.378,1306.262h-17.835c-3.545,0-6.419-2.874-6.419-6.419v-50.129 c0-3.545,2.874-6.42,6.419-6.42h17.835c3.545,0,6.42,2.875,6.42,6.42v50.129C751.797,1303.388,748.923,1306.262,745.378,1306.262 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M745.378,1379.05h-17.835c-3.545,0-6.419-2.875-6.419-6.42v-50.129 c0-3.545,2.874-6.419,6.419-6.419h17.835c3.545,0,6.42,2.874,6.42,6.419v50.129 C751.797,1376.175,748.923,1379.05,745.378,1379.05z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M745.378,1451.837h-17.835c-3.545,0-6.419-2.874-6.419-6.42v-50.128 c0-3.546,2.874-6.419,6.419-6.419h17.835c3.545,0,6.42,2.873,6.42,6.419v50.128 C751.797,1448.963,748.923,1451.837,745.378,1451.837z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M745.378,1524.624h-17.835c-3.545,0-6.419-2.874-6.419-6.419v-50.128 c0-3.546,2.874-6.42,6.419-6.42h17.835c3.545,0,6.42,2.874,6.42,6.42v50.128C751.797,1521.75,748.923,1524.624,745.378,1524.624z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M745.378,1597.412h-17.835c-3.545,0-6.419-2.874-6.419-6.42v-50.128 c0-3.545,2.874-6.42,6.419-6.42h17.835c3.545,0,6.42,2.875,6.42,6.42v50.128C751.797,1594.538,748.923,1597.412,745.378,1597.412 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M745.378,1670.199h-17.835c-3.545,0-6.419-2.873-6.419-6.419v-50.128 c0-3.545,2.874-6.42,6.419-6.42h17.835c3.545,0,6.42,2.875,6.42,6.42v50.128C751.797,1667.326,748.923,1670.199,745.378,1670.199 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M745.378,1742.987h-17.835c-3.545,0-6.419-2.874-6.419-6.419v-50.129 c0-3.545,2.874-6.419,6.419-6.419h17.835c3.545,0,6.42,2.874,6.42,6.419v50.129 C751.797,1740.113,748.923,1742.987,745.378,1742.987z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M666.553,1160.687h-4.282c-3.545,0-6.419-2.874-6.419-6.42v-50.128 c0-3.545,2.874-6.419,6.419-6.419h4.282c3.545,0,6.419,2.874,6.419,6.419v50.128 C672.973,1157.813,670.099,1160.687,666.553,1160.687z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M614.122,1233.474h-17.835c-3.545,0-6.419-2.873-6.419-6.419v-50.128 c0-3.546,2.874-6.42,6.419-6.42h17.835c3.545,0,6.419,2.874,6.419,6.42v50.128 C620.542,1230.601,617.667,1233.474,614.122,1233.474z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M666.553,1233.474h-4.282c-3.545,0-6.419-2.873-6.419-6.419v-50.128 c0-3.546,2.874-6.42,6.419-6.42h4.282c3.545,0,6.419,2.874,6.419,6.42v50.128 C672.973,1230.601,670.099,1233.474,666.553,1233.474z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M614.122,1306.262h-17.835c-3.545,0-6.419-2.874-6.419-6.419v-50.129 c0-3.545,2.874-6.42,6.419-6.42h17.835c3.545,0,6.419,2.875,6.419,6.42v50.129 C620.542,1303.388,617.667,1306.262,614.122,1306.262z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M666.553,1306.262h-4.282c-3.545,0-6.419-2.874-6.419-6.419v-50.129 c0-3.545,2.874-6.42,6.419-6.42h4.282c3.545,0,6.419,2.875,6.419,6.42v50.129 C672.973,1303.388,670.099,1306.262,666.553,1306.262z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M614.122,1379.05h-17.835c-3.545,0-6.419-2.875-6.419-6.42v-50.129 c0-3.545,2.874-6.419,6.419-6.419h17.835c3.545,0,6.419,2.874,6.419,6.419v50.129 C620.542,1376.175,617.667,1379.05,614.122,1379.05z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M666.553,1379.05h-4.282c-3.545,0-6.419-2.875-6.419-6.42v-50.129 c0-3.545,2.874-6.419,6.419-6.419h4.282c3.545,0,6.419,2.874,6.419,6.419v50.129 C672.973,1376.175,670.099,1379.05,666.553,1379.05z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M614.122,1451.837h-17.835c-3.545,0-6.419-2.874-6.419-6.42v-50.128 c0-3.546,2.874-6.419,6.419-6.419h17.835c3.545,0,6.419,2.873,6.419,6.419v50.128 C620.542,1448.963,617.667,1451.837,614.122,1451.837z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M666.553,1451.837h-4.282c-3.545,0-6.419-2.874-6.419-6.42v-50.128 c0-3.546,2.874-6.419,6.419-6.419h4.282c3.545,0,6.419,2.873,6.419,6.419v50.128 C672.973,1448.963,670.099,1451.837,666.553,1451.837z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M614.122,1524.624h-17.835c-3.545,0-6.419-2.874-6.419-6.419v-50.128 c0-3.546,2.874-6.42,6.419-6.42h17.835c3.545,0,6.419,2.874,6.419,6.42v50.128 C620.542,1521.75,617.667,1524.624,614.122,1524.624z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M666.553,1524.624h-4.282c-3.545,0-6.419-2.874-6.419-6.419v-50.128 c0-3.546,2.874-6.42,6.419-6.42h4.282c3.545,0,6.419,2.874,6.419,6.42v50.128C672.973,1521.75,670.099,1524.624,666.553,1524.624 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M614.122,1597.412h-17.835c-3.545,0-6.419-2.874-6.419-6.42v-50.128 c0-3.545,2.874-6.42,6.419-6.42h17.835c3.545,0,6.419,2.875,6.419,6.42v50.128 C620.542,1594.538,617.667,1597.412,614.122,1597.412z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M666.553,1597.412h-4.282c-3.545,0-6.419-2.874-6.419-6.42v-50.128c0-3.545,2.874-6.42,6.419-6.42 h4.282c3.545,0,6.419,2.875,6.419,6.42v50.128C672.973,1594.538,670.099,1597.412,666.553,1597.412z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M614.122,1670.199h-17.835c-3.545,0-6.419-2.873-6.419-6.419v-50.128 c0-3.545,2.874-6.42,6.419-6.42h17.835c3.545,0,6.419,2.875,6.419,6.42v50.128 C620.542,1667.326,617.667,1670.199,614.122,1670.199z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M666.553,1670.199h-4.282c-3.545,0-6.419-2.873-6.419-6.419v-50.128 c0-3.545,2.874-6.42,6.419-6.42h4.282c3.545,0,6.419,2.875,6.419,6.42v50.128 C672.973,1667.326,670.099,1670.199,666.553,1670.199z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M614.122,1742.987h-17.835c-3.545,0-6.419-2.874-6.419-6.419v-50.129 c0-3.545,2.874-6.419,6.419-6.419h17.835c3.545,0,6.419,2.874,6.419,6.419v50.129 C620.542,1740.113,617.667,1742.987,614.122,1742.987z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M666.553,1742.987h-4.282c-3.545,0-6.419-2.874-6.419-6.419v-50.129 c0-3.545,2.874-6.419,6.419-6.419h4.282c3.545,0,6.419,2.874,6.419,6.419v50.129 C672.973,1740.113,670.099,1742.987,666.553,1742.987z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M483.936,1233.474h-17.835c-3.545,0-6.42-2.873-6.42-6.419v-50.128c0-3.546,2.875-6.42,6.42-6.42 h17.835c3.545,0,6.419,2.874,6.419,6.42v50.128C490.356,1230.601,487.482,1233.474,483.936,1233.474z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M536.367,1233.474h-4.281c-3.545,0-6.419-2.873-6.419-6.419v-50.128 c0-3.546,2.874-6.42,6.419-6.42h4.281c3.546,0,6.42,2.874,6.42,6.42v50.128C542.787,1230.601,539.913,1233.474,536.367,1233.474z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M483.936,1306.262h-17.835c-3.545,0-6.42-2.874-6.42-6.419v-50.129c0-3.545,2.875-6.42,6.42-6.42 h17.835c3.545,0,6.419,2.875,6.419,6.42v50.129C490.356,1303.388,487.482,1306.262,483.936,1306.262z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M536.367,1306.262h-4.281c-3.545,0-6.419-2.874-6.419-6.419v-50.129 c0-3.545,2.874-6.42,6.419-6.42h4.281c3.546,0,6.42,2.875,6.42,6.42v50.129C542.787,1303.388,539.913,1306.262,536.367,1306.262z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M483.936,1379.05h-17.835c-3.545,0-6.42-2.875-6.42-6.42v-50.129c0-3.545,2.875-6.419,6.42-6.419 h17.835c3.545,0,6.419,2.874,6.419,6.419v50.129C490.356,1376.175,487.482,1379.05,483.936,1379.05z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M536.367,1379.05h-4.281c-3.545,0-6.419-2.875-6.419-6.42v-50.129 c0-3.545,2.874-6.419,6.419-6.419h4.281c3.546,0,6.42,2.874,6.42,6.419v50.129C542.787,1376.175,539.913,1379.05,536.367,1379.05 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M483.936,1451.837h-17.835c-3.545,0-6.42-2.874-6.42-6.42v-50.128c0-3.546,2.875-6.419,6.42-6.419 h17.835c3.545,0,6.419,2.873,6.419,6.419v50.128C490.356,1448.963,487.482,1451.837,483.936,1451.837z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M536.367,1451.837h-4.281c-3.545,0-6.419-2.874-6.419-6.42v-50.128 c0-3.546,2.874-6.419,6.419-6.419h4.281c3.546,0,6.42,2.873,6.42,6.419v50.128 C542.787,1448.963,539.913,1451.837,536.367,1451.837z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M483.936,1524.624h-17.835c-3.545,0-6.42-2.874-6.42-6.419v-50.128c0-3.546,2.875-6.42,6.42-6.42 h17.835c3.545,0,6.419,2.874,6.419,6.42v50.128C490.356,1521.75,487.482,1524.624,483.936,1524.624z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M536.367,1524.624h-4.281c-3.545,0-6.419-2.874-6.419-6.419v-50.128 c0-3.546,2.874-6.42,6.419-6.42h4.281c3.546,0,6.42,2.874,6.42,6.42v50.128C542.787,1521.75,539.913,1524.624,536.367,1524.624z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M483.936,1597.412h-17.835c-3.545,0-6.42-2.874-6.42-6.42v-50.128c0-3.545,2.875-6.42,6.42-6.42 h17.835c3.545,0,6.419,2.875,6.419,6.42v50.128C490.356,1594.538,487.482,1597.412,483.936,1597.412z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M536.367,1597.412h-4.281c-3.545,0-6.419-2.874-6.419-6.42v-50.128c0-3.545,2.874-6.42,6.419-6.42 h4.281c3.546,0,6.42,2.875,6.42,6.42v50.128C542.787,1594.538,539.913,1597.412,536.367,1597.412z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M483.936,1670.199h-17.835c-3.545,0-6.42-2.873-6.42-6.419v-50.128c0-3.545,2.875-6.42,6.42-6.42 h17.835c3.545,0,6.419,2.875,6.419,6.42v50.128C490.356,1667.326,487.482,1670.199,483.936,1670.199z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M536.367,1670.199h-4.281c-3.545,0-6.419-2.873-6.419-6.419v-50.128 c0-3.545,2.874-6.42,6.419-6.42h4.281c3.546,0,6.42,2.875,6.42,6.42v50.128C542.787,1667.326,539.913,1670.199,536.367,1670.199z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M483.936,1742.987h-17.835c-3.545,0-6.42-2.874-6.42-6.419v-50.129 c0-3.545,2.875-6.419,6.42-6.419h17.835c3.545,0,6.419,2.874,6.419,6.419v50.129 C490.356,1740.113,487.482,1742.987,483.936,1742.987z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M536.367,1742.987h-4.281c-3.545,0-6.419-2.874-6.419-6.419v-50.129 c0-3.545,2.874-6.419,6.419-6.419h4.281c3.546,0,6.42,2.874,6.42,6.419v50.129 C542.787,1740.113,539.913,1742.987,536.367,1742.987z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A09DAD"
    },
    d: "M1579.505,1774.401h205.423c3.158,0,5.717-2.56,5.717-5.717v-306.447 c0-3.158-2.559-5.717-5.717-5.717h-205.423c-3.157,0-5.718,2.559-5.718,5.717v306.447 C1573.787,1771.842,1576.348,1774.401,1579.505,1774.401z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9A999F"
    },
    d: "M1755.215,1770.583v-310.244c0-2.109-3.832-3.818-8.56-3.818h35.43c4.728,0,8.56,1.709,8.56,3.818 v310.244c0,2.108-3.832,3.818-8.56,3.818h-35.43C1751.383,1774.401,1755.215,1772.691,1755.215,1770.583z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1585.308,1498.251h25.468c2.553,0,4.624-2.071,4.624-4.625v-9.298 c0-2.554-2.071-4.625-4.624-4.625h-25.468c-2.554,0-4.624,2.071-4.624,4.625v9.298 C1580.684,1496.18,1582.754,1498.251,1585.308,1498.251z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1709.965,1498.251h25.467c2.555,0,4.625-2.071,4.625-4.625v-9.298 c0-2.554-2.07-4.625-4.625-4.625h-25.467c-2.555,0-4.625,2.071-4.625,4.625v9.298 C1705.34,1496.18,1707.41,1498.251,1709.965,1498.251z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1668.412,1498.251h25.467c2.555,0,4.625-2.071,4.625-4.625v-9.298 c0-2.554-2.07-4.625-4.625-4.625h-25.467c-2.554,0-4.624,2.071-4.624,4.625v9.298 C1663.788,1496.18,1665.858,1498.251,1668.412,1498.251z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1626.859,1498.251h25.468c2.554,0,4.624-2.071,4.624-4.625v-9.298 c0-2.554-2.07-4.625-4.624-4.625h-25.468c-2.553,0-4.624,2.071-4.624,4.625v9.298 C1622.235,1496.18,1624.307,1498.251,1626.859,1498.251z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1585.308,1546.675h25.468c2.553,0,4.624-2.071,4.624-4.625v-9.299 c0-2.553-2.071-4.624-4.624-4.624h-25.468c-2.554,0-4.624,2.071-4.624,4.624v9.299 C1580.684,1544.604,1582.754,1546.675,1585.308,1546.675z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1709.965,1546.675h25.467c2.555,0,4.625-2.071,4.625-4.625v-9.299 c0-2.553-2.07-4.624-4.625-4.624h-25.467c-2.555,0-4.625,2.071-4.625,4.624v9.299 C1705.34,1544.604,1707.41,1546.675,1709.965,1546.675z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1668.412,1546.675h25.467c2.555,0,4.625-2.071,4.625-4.625v-9.299 c0-2.553-2.07-4.624-4.625-4.624h-25.467c-2.554,0-4.624,2.071-4.624,4.624v9.299 C1663.788,1544.604,1665.858,1546.675,1668.412,1546.675z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1626.859,1546.675h25.468c2.554,0,4.624-2.071,4.624-4.625v-9.299 c0-2.553-2.07-4.624-4.624-4.624h-25.468c-2.553,0-4.624,2.071-4.624,4.624v9.299 C1622.235,1544.604,1624.307,1546.675,1626.859,1546.675z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1585.308,1595.098h25.468c2.553,0,4.624-2.07,4.624-4.624v-9.298 c0-2.555-2.071-4.625-4.624-4.625h-25.468c-2.554,0-4.624,2.07-4.624,4.625v9.298 C1580.684,1593.027,1582.754,1595.098,1585.308,1595.098z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1709.965,1595.098h25.467c2.555,0,4.625-2.07,4.625-4.624v-9.298c0-2.555-2.07-4.625-4.625-4.625 h-25.467c-2.555,0-4.625,2.07-4.625,4.625v9.298C1705.34,1593.027,1707.41,1595.098,1709.965,1595.098z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1668.412,1595.098h25.467c2.555,0,4.625-2.07,4.625-4.624v-9.298c0-2.555-2.07-4.625-4.625-4.625 h-25.467c-2.554,0-4.624,2.07-4.624,4.625v9.298C1663.788,1593.027,1665.858,1595.098,1668.412,1595.098z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1626.859,1595.098h25.468c2.554,0,4.624-2.07,4.624-4.624v-9.298c0-2.555-2.07-4.625-4.624-4.625 h-25.468c-2.553,0-4.624,2.07-4.624,4.625v9.298C1622.235,1593.027,1624.307,1595.098,1626.859,1595.098z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1585.308,1643.521h25.468c2.553,0,4.624-2.07,4.624-4.624v-9.298 c0-2.555-2.071-4.625-4.624-4.625h-25.468c-2.554,0-4.624,2.07-4.624,4.625v9.298 C1580.684,1641.451,1582.754,1643.521,1585.308,1643.521z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1709.965,1643.521h25.467c2.555,0,4.625-2.07,4.625-4.624v-9.298c0-2.555-2.07-4.625-4.625-4.625 h-25.467c-2.555,0-4.625,2.07-4.625,4.625v9.298C1705.34,1641.451,1707.41,1643.521,1709.965,1643.521z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1668.412,1643.521h25.467c2.555,0,4.625-2.07,4.625-4.624v-9.298c0-2.555-2.07-4.625-4.625-4.625 h-25.467c-2.554,0-4.624,2.07-4.624,4.625v9.298C1663.788,1641.451,1665.858,1643.521,1668.412,1643.521z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1626.859,1643.521h25.468c2.554,0,4.624-2.07,4.624-4.624v-9.298c0-2.555-2.07-4.625-4.624-4.625 h-25.468c-2.553,0-4.624,2.07-4.624,4.625v9.298C1622.235,1641.451,1624.307,1643.521,1626.859,1643.521z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1585.308,1691.945h25.468c2.553,0,4.624-2.07,4.624-4.624v-9.298 c0-2.555-2.071-4.625-4.624-4.625h-25.468c-2.554,0-4.624,2.07-4.624,4.625v9.298 C1580.684,1689.875,1582.754,1691.945,1585.308,1691.945z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1709.965,1691.945h25.467c2.555,0,4.625-2.07,4.625-4.624v-9.298c0-2.555-2.07-4.625-4.625-4.625 h-25.467c-2.555,0-4.625,2.07-4.625,4.625v9.298C1705.34,1689.875,1707.41,1691.945,1709.965,1691.945z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1668.412,1691.945h25.467c2.555,0,4.625-2.07,4.625-4.624v-9.298c0-2.555-2.07-4.625-4.625-4.625 h-25.467c-2.554,0-4.624,2.07-4.624,4.625v9.298C1663.788,1689.875,1665.858,1691.945,1668.412,1691.945z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1626.859,1691.945h25.468c2.554,0,4.624-2.07,4.624-4.624v-9.298c0-2.555-2.07-4.625-4.624-4.625 h-25.468c-2.553,0-4.624,2.07-4.624,4.625v9.298C1622.235,1689.875,1624.307,1691.945,1626.859,1691.945z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1585.308,1740.369h25.468c2.553,0,4.624-2.07,4.624-4.624v-9.298 c0-2.555-2.071-4.625-4.624-4.625h-25.468c-2.554,0-4.624,2.07-4.624,4.625v9.298 C1580.684,1738.299,1582.754,1740.369,1585.308,1740.369z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1709.965,1740.369h25.467c2.555,0,4.625-2.07,4.625-4.624v-9.298c0-2.555-2.07-4.625-4.625-4.625 h-25.467c-2.555,0-4.625,2.07-4.625,4.625v9.298C1705.34,1738.299,1707.41,1740.369,1709.965,1740.369z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1668.412,1740.369h25.467c2.555,0,4.625-2.07,4.625-4.624v-9.298c0-2.555-2.07-4.625-4.625-4.625 h-25.467c-2.554,0-4.624,2.07-4.624,4.625v9.298C1663.788,1738.299,1665.858,1740.369,1668.412,1740.369z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1626.859,1740.369h25.468c2.554,0,4.624-2.07,4.624-4.624v-9.298c0-2.555-2.07-4.625-4.624-4.625 h-25.468c-2.553,0-4.624,2.07-4.624,4.625v9.298C1622.235,1738.299,1624.307,1740.369,1626.859,1740.369z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B2B0BE"
    },
    d: "M2376.136,1774.401h-394.727c-4.331,0-7.843-3.511-7.843-7.843v-857.56 c0-4.331,3.512-7.842,7.843-7.842h394.727c4.331,0,7.843,3.511,7.843,7.842v857.56 C2383.979,1770.891,2380.467,1774.401,2376.136,1774.401z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9A999F"
    },
    d: "M2305.986,1774.401H1980.7c-3.94,0-7.134-3.193-7.134-7.134V908.29 c0-3.939,3.193-7.133,7.134-7.133h325.286c3.939,0,7.133,3.194,7.133,7.133v858.978 C2313.119,1771.208,2309.926,1774.401,2305.986,1774.401z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2275.193,1019.572h-16.407c-3.939,0-7.134-3.194-7.134-7.134v-63.487 c0-3.94,3.194-7.134,7.134-7.134h16.407c3.939,0,7.133,3.194,7.133,7.134v63.487 C2282.326,1016.378,2279.133,1019.572,2275.193,1019.572z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2275.193,1109.454h-16.407c-3.939,0-7.134-3.194-7.134-7.134v-63.487 c0-3.94,3.194-7.134,7.134-7.134h16.407c3.939,0,7.133,3.193,7.133,7.134v63.487 C2282.326,1106.26,2279.133,1109.454,2275.193,1109.454z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2275.193,1199.335h-16.407c-3.939,0-7.134-3.193-7.134-7.133v-63.488 c0-3.939,3.194-7.133,7.134-7.133h16.407c3.939,0,7.133,3.193,7.133,7.133v63.488 C2282.326,1196.142,2279.133,1199.335,2275.193,1199.335z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2275.193,1289.218h-16.407c-3.939,0-7.134-3.194-7.134-7.135v-63.487 c0-3.939,3.194-7.134,7.134-7.134h16.407c3.939,0,7.133,3.194,7.133,7.134v63.487 C2282.326,1286.023,2279.133,1289.218,2275.193,1289.218z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2275.193,1379.099h-16.407c-3.939,0-7.134-3.193-7.134-7.133v-63.488 c0-3.939,3.194-7.134,7.134-7.134h16.407c3.939,0,7.133,3.194,7.133,7.134v63.488 C2282.326,1375.905,2279.133,1379.099,2275.193,1379.099z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2275.193,1468.98h-16.407c-3.939,0-7.134-3.194-7.134-7.134v-63.487 c0-3.94,3.194-7.134,7.134-7.134h16.407c3.939,0,7.133,3.193,7.133,7.134v63.487 C2282.326,1465.786,2279.133,1468.98,2275.193,1468.98z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2275.193,1558.862h-16.407c-3.939,0-7.134-3.193-7.134-7.134v-63.487 c0-3.94,3.194-7.134,7.134-7.134h16.407c3.939,0,7.133,3.193,7.133,7.134v63.487 C2282.326,1555.669,2279.133,1558.862,2275.193,1558.862z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2275.193,1648.744h-16.407c-3.939,0-7.134-3.193-7.134-7.133v-63.488 c0-3.939,3.194-7.134,7.134-7.134h16.407c3.939,0,7.133,3.194,7.133,7.134v63.488 C2282.326,1645.551,2279.133,1648.744,2275.193,1648.744z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2275.193,1738.626h-16.407c-3.939,0-7.134-3.194-7.134-7.134v-63.488 c0-3.939,3.194-7.133,7.134-7.133h16.407c3.939,0,7.133,3.193,7.133,7.133v63.488 C2282.326,1735.432,2279.133,1738.626,2275.193,1738.626z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2196.368,1019.572h-2.854c-3.939,0-7.133-3.194-7.133-7.134v-63.487 c0-3.94,3.193-7.134,7.133-7.134h2.854c3.94,0,7.134,3.194,7.134,7.134v63.487 C2203.502,1016.378,2200.309,1019.572,2196.368,1019.572z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2143.938,1109.454h-16.407c-3.939,0-7.134-3.194-7.134-7.134v-63.487 c0-3.94,3.194-7.134,7.134-7.134h16.407c3.939,0,7.133,3.193,7.133,7.134v63.487 C2151.07,1106.26,2147.877,1109.454,2143.938,1109.454z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2196.368,1109.454h-2.854c-3.939,0-7.133-3.194-7.133-7.134v-63.487 c0-3.94,3.193-7.134,7.133-7.134h2.854c3.94,0,7.134,3.193,7.134,7.134v63.487 C2203.502,1106.26,2200.309,1109.454,2196.368,1109.454z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2143.938,1199.335h-16.407c-3.939,0-7.134-3.193-7.134-7.133v-63.488 c0-3.939,3.194-7.133,7.134-7.133h16.407c3.939,0,7.133,3.193,7.133,7.133v63.488 C2151.07,1196.142,2147.877,1199.335,2143.938,1199.335z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2196.368,1199.335h-2.854c-3.939,0-7.133-3.193-7.133-7.133v-63.488 c0-3.939,3.193-7.133,7.133-7.133h2.854c3.94,0,7.134,3.193,7.134,7.133v63.488 C2203.502,1196.142,2200.309,1199.335,2196.368,1199.335z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2143.938,1289.218h-16.407c-3.939,0-7.134-3.194-7.134-7.135v-63.487 c0-3.939,3.194-7.134,7.134-7.134h16.407c3.939,0,7.133,3.194,7.133,7.134v63.487 C2151.07,1286.023,2147.877,1289.218,2143.938,1289.218z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2196.368,1289.218h-2.854c-3.939,0-7.133-3.194-7.133-7.135v-63.487 c0-3.939,3.193-7.134,7.133-7.134h2.854c3.94,0,7.134,3.194,7.134,7.134v63.487 C2203.502,1286.023,2200.309,1289.218,2196.368,1289.218z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2143.938,1379.099h-16.407c-3.939,0-7.134-3.193-7.134-7.133v-63.488 c0-3.939,3.194-7.134,7.134-7.134h16.407c3.939,0,7.133,3.194,7.133,7.134v63.488 C2151.07,1375.905,2147.877,1379.099,2143.938,1379.099z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2196.368,1379.099h-2.854c-3.939,0-7.133-3.193-7.133-7.133v-63.488 c0-3.939,3.193-7.134,7.133-7.134h2.854c3.94,0,7.134,3.194,7.134,7.134v63.488 C2203.502,1375.905,2200.309,1379.099,2196.368,1379.099z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2143.938,1468.98h-16.407c-3.939,0-7.134-3.194-7.134-7.134v-63.487 c0-3.94,3.194-7.134,7.134-7.134h16.407c3.939,0,7.133,3.193,7.133,7.134v63.487 C2151.07,1465.786,2147.877,1468.98,2143.938,1468.98z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2196.368,1468.98h-2.854c-3.939,0-7.133-3.194-7.133-7.134v-63.487 c0-3.94,3.193-7.134,7.133-7.134h2.854c3.94,0,7.134,3.193,7.134,7.134v63.487 C2203.502,1465.786,2200.309,1468.98,2196.368,1468.98z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2143.938,1558.862h-16.407c-3.939,0-7.134-3.193-7.134-7.134v-63.487 c0-3.94,3.194-7.134,7.134-7.134h16.407c3.939,0,7.133,3.193,7.133,7.134v63.487 C2151.07,1555.669,2147.877,1558.862,2143.938,1558.862z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2196.368,1558.862h-2.854c-3.939,0-7.133-3.193-7.133-7.134v-63.487 c0-3.94,3.193-7.134,7.133-7.134h2.854c3.94,0,7.134,3.193,7.134,7.134v63.487 C2203.502,1555.669,2200.309,1558.862,2196.368,1558.862z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2143.938,1648.744h-16.407c-3.939,0-7.134-3.193-7.134-7.133v-63.488 c0-3.939,3.194-7.134,7.134-7.134h16.407c3.939,0,7.133,3.194,7.133,7.134v63.488 C2151.07,1645.551,2147.877,1648.744,2143.938,1648.744z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2196.368,1648.744h-2.854c-3.939,0-7.133-3.193-7.133-7.133v-63.488 c0-3.939,3.193-7.134,7.133-7.134h2.854c3.94,0,7.134,3.194,7.134,7.134v63.488 C2203.502,1645.551,2200.309,1648.744,2196.368,1648.744z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2143.938,1738.626h-16.407c-3.939,0-7.134-3.194-7.134-7.134v-63.488 c0-3.939,3.194-7.133,7.134-7.133h16.407c3.939,0,7.133,3.193,7.133,7.133v63.488 C2151.07,1735.432,2147.877,1738.626,2143.938,1738.626z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2196.368,1738.626h-2.854c-3.939,0-7.133-3.194-7.133-7.134v-63.488 c0-3.939,3.193-7.133,7.133-7.133h2.854c3.94,0,7.134,3.193,7.134,7.133v63.488 C2203.502,1735.432,2200.309,1738.626,2196.368,1738.626z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2013.752,1109.454h-16.407c-3.94,0-7.134-3.194-7.134-7.134v-63.487 c0-3.94,3.193-7.134,7.134-7.134h16.407c3.939,0,7.133,3.193,7.133,7.134v63.487 C2020.885,1106.26,2017.691,1109.454,2013.752,1109.454z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2066.183,1109.454h-2.854c-3.939,0-7.134-3.194-7.134-7.134v-63.487 c0-3.94,3.194-7.134,7.134-7.134h2.854c3.939,0,7.134,3.193,7.134,7.134v63.487 C2073.316,1106.26,2070.122,1109.454,2066.183,1109.454z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2013.752,1199.335h-16.407c-3.94,0-7.134-3.193-7.134-7.133v-63.488 c0-3.939,3.193-7.133,7.134-7.133h16.407c3.939,0,7.133,3.193,7.133,7.133v63.488 C2020.885,1196.142,2017.691,1199.335,2013.752,1199.335z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2066.183,1199.335h-2.854c-3.939,0-7.134-3.193-7.134-7.133v-63.488 c0-3.939,3.194-7.133,7.134-7.133h2.854c3.939,0,7.134,3.193,7.134,7.133v63.488 C2073.316,1196.142,2070.122,1199.335,2066.183,1199.335z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2013.752,1289.218h-16.407c-3.94,0-7.134-3.194-7.134-7.135v-63.487 c0-3.939,3.193-7.134,7.134-7.134h16.407c3.939,0,7.133,3.194,7.133,7.134v63.487 C2020.885,1286.023,2017.691,1289.218,2013.752,1289.218z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2066.183,1289.218h-2.854c-3.939,0-7.134-3.194-7.134-7.135v-63.487 c0-3.939,3.194-7.134,7.134-7.134h2.854c3.939,0,7.134,3.194,7.134,7.134v63.487 C2073.316,1286.023,2070.122,1289.218,2066.183,1289.218z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2013.752,1379.099h-16.407c-3.94,0-7.134-3.193-7.134-7.133v-63.488 c0-3.939,3.193-7.134,7.134-7.134h16.407c3.939,0,7.133,3.194,7.133,7.134v63.488 C2020.885,1375.905,2017.691,1379.099,2013.752,1379.099z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2066.183,1379.099h-2.854c-3.939,0-7.134-3.193-7.134-7.133v-63.488 c0-3.939,3.194-7.134,7.134-7.134h2.854c3.939,0,7.134,3.194,7.134,7.134v63.488 C2073.316,1375.905,2070.122,1379.099,2066.183,1379.099z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2013.752,1468.98h-16.407c-3.94,0-7.134-3.194-7.134-7.134v-63.487 c0-3.94,3.193-7.134,7.134-7.134h16.407c3.939,0,7.133,3.193,7.133,7.134v63.487 C2020.885,1465.786,2017.691,1468.98,2013.752,1468.98z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2066.183,1468.98h-2.854c-3.939,0-7.134-3.194-7.134-7.134v-63.487 c0-3.94,3.194-7.134,7.134-7.134h2.854c3.939,0,7.134,3.193,7.134,7.134v63.487 C2073.316,1465.786,2070.122,1468.98,2066.183,1468.98z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2013.752,1558.862h-16.407c-3.94,0-7.134-3.193-7.134-7.134v-63.487 c0-3.94,3.193-7.134,7.134-7.134h16.407c3.939,0,7.133,3.193,7.133,7.134v63.487 C2020.885,1555.669,2017.691,1558.862,2013.752,1558.862z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2066.183,1558.862h-2.854c-3.939,0-7.134-3.193-7.134-7.134v-63.487 c0-3.94,3.194-7.134,7.134-7.134h2.854c3.939,0,7.134,3.193,7.134,7.134v63.487 C2073.316,1555.669,2070.122,1558.862,2066.183,1558.862z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2013.752,1648.744h-16.407c-3.94,0-7.134-3.193-7.134-7.133v-63.488 c0-3.939,3.193-7.134,7.134-7.134h16.407c3.939,0,7.133,3.194,7.133,7.134v63.488 C2020.885,1645.551,2017.691,1648.744,2013.752,1648.744z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2066.183,1648.744h-2.854c-3.939,0-7.134-3.193-7.134-7.133v-63.488 c0-3.939,3.194-7.134,7.134-7.134h2.854c3.939,0,7.134,3.194,7.134,7.134v63.488 C2073.316,1645.551,2070.122,1648.744,2066.183,1648.744z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2013.752,1738.626h-16.407c-3.94,0-7.134-3.194-7.134-7.134v-63.488 c0-3.939,3.193-7.133,7.134-7.133h16.407c3.939,0,7.133,3.193,7.133,7.133v63.488 C2020.885,1735.432,2017.691,1738.626,2013.752,1738.626z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2066.183,1738.626h-2.854c-3.939,0-7.134-3.194-7.134-7.134v-63.488 c0-3.939,3.194-7.133,7.134-7.133h2.854c3.939,0,7.134,3.193,7.134,7.133v63.488 C2073.316,1735.432,2070.122,1738.626,2066.183,1738.626z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D7D6DD"
    },
    d: "M2243.627,1774.401h199.738c4.727,0,8.56-3.832,8.56-8.56v-695.538 c0-4.729-3.833-8.561-8.56-8.561h-199.738c-4.727,0-8.56,3.832-8.56,8.561v695.538 C2235.067,1770.569,2238.9,1774.401,2243.627,1774.401z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9A999F"
    },
    d: "M2443.365,1061.743h-40.765c4.728,0,8.56,3.832,8.56,8.561v695.538c0,4.727-3.832,8.56-8.56,8.56 h40.765c4.727,0,8.56-3.833,8.56-8.56v-695.538C2451.925,1065.575,2448.092,1061.743,2443.365,1061.743z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2246.588,1103.474h25.467c2.555,0,4.625-2.07,4.625-4.624v-9.298 c0-2.555-2.07-4.625-4.625-4.625h-25.467c-2.555,0-4.625,2.07-4.625,4.625v9.298 C2241.963,1101.403,2244.033,1103.474,2246.588,1103.474z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2371.245,1103.474h25.467c2.554,0,4.624-2.07,4.624-4.624v-9.298 c0-2.555-2.07-4.625-4.624-4.625h-25.467c-2.554,0-4.625,2.07-4.625,4.625v9.298 C2366.62,1101.403,2368.691,1103.474,2371.245,1103.474z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2329.693,1103.474h25.467c2.554,0,4.624-2.07,4.624-4.624v-9.298 c0-2.555-2.07-4.625-4.624-4.625h-25.467c-2.555,0-4.625,2.07-4.625,4.625v9.298 C2325.068,1101.403,2327.139,1103.474,2329.693,1103.474z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2288.14,1103.474h25.468c2.554,0,4.625-2.07,4.625-4.624v-9.298 c0-2.555-2.071-4.625-4.625-4.625h-25.468c-2.554,0-4.624,2.07-4.624,4.625v9.298 C2283.516,1101.403,2285.586,1103.474,2288.14,1103.474z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2246.588,1151.897h25.467c2.555,0,4.625-2.07,4.625-4.624v-9.298 c0-2.555-2.07-4.625-4.625-4.625h-25.467c-2.555,0-4.625,2.07-4.625,4.625v9.298 C2241.963,1149.827,2244.033,1151.897,2246.588,1151.897z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2371.245,1151.897h25.467c2.554,0,4.624-2.07,4.624-4.624v-9.298 c0-2.555-2.07-4.625-4.624-4.625h-25.467c-2.554,0-4.625,2.07-4.625,4.625v9.298 C2366.62,1149.827,2368.691,1151.897,2371.245,1151.897z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2329.693,1151.897h25.467c2.554,0,4.624-2.07,4.624-4.624v-9.298 c0-2.555-2.07-4.625-4.624-4.625h-25.467c-2.555,0-4.625,2.07-4.625,4.625v9.298 C2325.068,1149.827,2327.139,1151.897,2329.693,1151.897z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2288.14,1151.897h25.468c2.554,0,4.625-2.07,4.625-4.624v-9.298 c0-2.555-2.071-4.625-4.625-4.625h-25.468c-2.554,0-4.624,2.07-4.624,4.625v9.298 C2283.516,1149.827,2285.586,1151.897,2288.14,1151.897z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2246.588,1200.321h25.467c2.555,0,4.625-2.07,4.625-4.624v-9.298 c0-2.555-2.07-4.625-4.625-4.625h-25.467c-2.555,0-4.625,2.07-4.625,4.625v9.298 C2241.963,1198.251,2244.033,1200.321,2246.588,1200.321z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2371.245,1200.321h25.467c2.554,0,4.624-2.07,4.624-4.624v-9.298 c0-2.555-2.07-4.625-4.624-4.625h-25.467c-2.554,0-4.625,2.07-4.625,4.625v9.298 C2366.62,1198.251,2368.691,1200.321,2371.245,1200.321z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2329.693,1200.321h25.467c2.554,0,4.624-2.07,4.624-4.624v-9.298 c0-2.555-2.07-4.625-4.624-4.625h-25.467c-2.555,0-4.625,2.07-4.625,4.625v9.298 C2325.068,1198.251,2327.139,1200.321,2329.693,1200.321z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2288.14,1200.321h25.468c2.554,0,4.625-2.07,4.625-4.624v-9.298 c0-2.555-2.071-4.625-4.625-4.625h-25.468c-2.554,0-4.624,2.07-4.624,4.625v9.298 C2283.516,1198.251,2285.586,1200.321,2288.14,1200.321z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2246.588,1248.745h25.467c2.555,0,4.625-2.07,4.625-4.624v-9.298 c0-2.555-2.07-4.625-4.625-4.625h-25.467c-2.555,0-4.625,2.07-4.625,4.625v9.298 C2241.963,1246.675,2244.033,1248.745,2246.588,1248.745z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2371.245,1248.745h25.467c2.554,0,4.624-2.07,4.624-4.624v-9.298 c0-2.555-2.07-4.625-4.624-4.625h-25.467c-2.554,0-4.625,2.07-4.625,4.625v9.298 C2366.62,1246.675,2368.691,1248.745,2371.245,1248.745z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2329.693,1248.745h25.467c2.554,0,4.624-2.07,4.624-4.624v-9.298 c0-2.555-2.07-4.625-4.624-4.625h-25.467c-2.555,0-4.625,2.07-4.625,4.625v9.298 C2325.068,1246.675,2327.139,1248.745,2329.693,1248.745z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2288.14,1248.745h25.468c2.554,0,4.625-2.07,4.625-4.624v-9.298 c0-2.555-2.071-4.625-4.625-4.625h-25.468c-2.554,0-4.624,2.07-4.624,4.625v9.298 C2283.516,1246.675,2285.586,1248.745,2288.14,1248.745z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2246.588,1297.169h25.467c2.555,0,4.625-2.07,4.625-4.625v-9.297 c0-2.555-2.07-4.625-4.625-4.625h-25.467c-2.555,0-4.625,2.07-4.625,4.625v9.297 C2241.963,1295.099,2244.033,1297.169,2246.588,1297.169z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2371.245,1297.169h25.467c2.554,0,4.624-2.07,4.624-4.625v-9.297 c0-2.555-2.07-4.625-4.624-4.625h-25.467c-2.554,0-4.625,2.07-4.625,4.625v9.297 C2366.62,1295.099,2368.691,1297.169,2371.245,1297.169z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2329.693,1297.169h25.467c2.554,0,4.624-2.07,4.624-4.625v-9.297 c0-2.555-2.07-4.625-4.624-4.625h-25.467c-2.555,0-4.625,2.07-4.625,4.625v9.297 C2325.068,1295.099,2327.139,1297.169,2329.693,1297.169z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2288.14,1297.169h25.468c2.554,0,4.625-2.07,4.625-4.625v-9.297 c0-2.555-2.071-4.625-4.625-4.625h-25.468c-2.554,0-4.624,2.07-4.624,4.625v9.297 C2283.516,1295.099,2285.586,1297.169,2288.14,1297.169z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2246.588,1345.593h25.467c2.555,0,4.625-2.07,4.625-4.625v-9.297 c0-2.555-2.07-4.625-4.625-4.625h-25.467c-2.555,0-4.625,2.07-4.625,4.625v9.297 C2241.963,1343.522,2244.033,1345.593,2246.588,1345.593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2371.245,1345.593h25.467c2.554,0,4.624-2.07,4.624-4.625v-9.297 c0-2.555-2.07-4.625-4.624-4.625h-25.467c-2.554,0-4.625,2.07-4.625,4.625v9.297 C2366.62,1343.522,2368.691,1345.593,2371.245,1345.593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2329.693,1345.593h25.467c2.554,0,4.624-2.07,4.624-4.625v-9.297 c0-2.555-2.07-4.625-4.624-4.625h-25.467c-2.555,0-4.625,2.07-4.625,4.625v9.297 C2325.068,1343.522,2327.139,1345.593,2329.693,1345.593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2288.14,1345.593h25.468c2.554,0,4.625-2.07,4.625-4.625v-9.297 c0-2.555-2.071-4.625-4.625-4.625h-25.468c-2.554,0-4.624,2.07-4.624,4.625v9.297 C2283.516,1343.522,2285.586,1345.593,2288.14,1345.593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2246.588,1394.017h25.467c2.555,0,4.625-2.07,4.625-4.625v-9.297 c0-2.555-2.07-4.625-4.625-4.625h-25.467c-2.555,0-4.625,2.07-4.625,4.625v9.297 C2241.963,1391.946,2244.033,1394.017,2246.588,1394.017z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2371.245,1394.017h25.467c2.554,0,4.624-2.07,4.624-4.625v-9.297 c0-2.555-2.07-4.625-4.624-4.625h-25.467c-2.554,0-4.625,2.07-4.625,4.625v9.297 C2366.62,1391.946,2368.691,1394.017,2371.245,1394.017z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2329.693,1394.017h25.467c2.554,0,4.624-2.07,4.624-4.625v-9.297 c0-2.555-2.07-4.625-4.624-4.625h-25.467c-2.555,0-4.625,2.07-4.625,4.625v9.297 C2325.068,1391.946,2327.139,1394.017,2329.693,1394.017z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2288.14,1394.017h25.468c2.554,0,4.625-2.07,4.625-4.625v-9.297 c0-2.555-2.071-4.625-4.625-4.625h-25.468c-2.554,0-4.624,2.07-4.624,4.625v9.297 C2283.516,1391.946,2285.586,1394.017,2288.14,1394.017z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2246.588,1442.44h25.467c2.555,0,4.625-2.07,4.625-4.625v-9.297c0-2.555-2.07-4.625-4.625-4.625 h-25.467c-2.555,0-4.625,2.07-4.625,4.625v9.297C2241.963,1440.37,2244.033,1442.44,2246.588,1442.44z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2371.245,1442.44h25.467c2.554,0,4.624-2.07,4.624-4.625v-9.297c0-2.555-2.07-4.625-4.624-4.625 h-25.467c-2.554,0-4.625,2.07-4.625,4.625v9.297C2366.62,1440.37,2368.691,1442.44,2371.245,1442.44z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2329.693,1442.44h25.467c2.554,0,4.624-2.07,4.624-4.625v-9.297c0-2.555-2.07-4.625-4.624-4.625 h-25.467c-2.555,0-4.625,2.07-4.625,4.625v9.297C2325.068,1440.37,2327.139,1442.44,2329.693,1442.44z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2288.14,1442.44h25.468c2.554,0,4.625-2.07,4.625-4.625v-9.297c0-2.555-2.071-4.625-4.625-4.625 h-25.468c-2.554,0-4.624,2.07-4.624,4.625v9.297C2283.516,1440.37,2285.586,1442.44,2288.14,1442.44z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2246.588,1490.864h25.467c2.555,0,4.625-2.07,4.625-4.625v-9.298 c0-2.554-2.07-4.624-4.625-4.624h-25.467c-2.555,0-4.625,2.07-4.625,4.624v9.298 C2241.963,1488.794,2244.033,1490.864,2246.588,1490.864z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2371.245,1490.864h25.467c2.554,0,4.624-2.07,4.624-4.625v-9.298 c0-2.554-2.07-4.624-4.624-4.624h-25.467c-2.554,0-4.625,2.07-4.625,4.624v9.298 C2366.62,1488.794,2368.691,1490.864,2371.245,1490.864z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2329.693,1490.864h25.467c2.554,0,4.624-2.07,4.624-4.625v-9.298 c0-2.554-2.07-4.624-4.624-4.624h-25.467c-2.555,0-4.625,2.07-4.625,4.624v9.298 C2325.068,1488.794,2327.139,1490.864,2329.693,1490.864z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2288.14,1490.864h25.468c2.554,0,4.625-2.07,4.625-4.625v-9.298 c0-2.554-2.071-4.624-4.625-4.624h-25.468c-2.554,0-4.624,2.07-4.624,4.624v9.298 C2283.516,1488.794,2285.586,1490.864,2288.14,1490.864z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2246.588,1539.288h25.467c2.555,0,4.625-2.07,4.625-4.625v-9.298 c0-2.554-2.07-4.624-4.625-4.624h-25.467c-2.555,0-4.625,2.07-4.625,4.624v9.298 C2241.963,1537.218,2244.033,1539.288,2246.588,1539.288z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2371.245,1539.288h25.467c2.554,0,4.624-2.07,4.624-4.625v-9.298 c0-2.554-2.07-4.624-4.624-4.624h-25.467c-2.554,0-4.625,2.07-4.625,4.624v9.298 C2366.62,1537.218,2368.691,1539.288,2371.245,1539.288z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2329.693,1539.288h25.467c2.554,0,4.624-2.07,4.624-4.625v-9.298 c0-2.554-2.07-4.624-4.624-4.624h-25.467c-2.555,0-4.625,2.07-4.625,4.624v9.298 C2325.068,1537.218,2327.139,1539.288,2329.693,1539.288z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2288.14,1539.288h25.468c2.554,0,4.625-2.07,4.625-4.625v-9.298 c0-2.554-2.071-4.624-4.625-4.624h-25.468c-2.554,0-4.624,2.07-4.624,4.624v9.298 C2283.516,1537.218,2285.586,1539.288,2288.14,1539.288z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2246.588,1587.712h25.467c2.555,0,4.625-2.07,4.625-4.624v-9.299 c0-2.554-2.07-4.624-4.625-4.624h-25.467c-2.555,0-4.625,2.07-4.625,4.624v9.299 C2241.963,1585.642,2244.033,1587.712,2246.588,1587.712z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2371.245,1587.712h25.467c2.554,0,4.624-2.07,4.624-4.624v-9.299 c0-2.554-2.07-4.624-4.624-4.624h-25.467c-2.554,0-4.625,2.07-4.625,4.624v9.299 C2366.62,1585.642,2368.691,1587.712,2371.245,1587.712z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2329.693,1587.712h25.467c2.554,0,4.624-2.07,4.624-4.624v-9.299 c0-2.554-2.07-4.624-4.624-4.624h-25.467c-2.555,0-4.625,2.07-4.625,4.624v9.299 C2325.068,1585.642,2327.139,1587.712,2329.693,1587.712z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2288.14,1587.712h25.468c2.554,0,4.625-2.07,4.625-4.624v-9.299 c0-2.554-2.071-4.624-4.625-4.624h-25.468c-2.554,0-4.624,2.07-4.624,4.624v9.299 C2283.516,1585.642,2285.586,1587.712,2288.14,1587.712z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2246.588,1636.136h25.467c2.555,0,4.625-2.071,4.625-4.625v-9.298 c0-2.554-2.07-4.624-4.625-4.624h-25.467c-2.555,0-4.625,2.07-4.625,4.624v9.298 C2241.963,1634.064,2244.033,1636.136,2246.588,1636.136z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2371.245,1636.136h25.467c2.554,0,4.624-2.071,4.624-4.625v-9.298 c0-2.554-2.07-4.624-4.624-4.624h-25.467c-2.554,0-4.625,2.07-4.625,4.624v9.298 C2366.62,1634.064,2368.691,1636.136,2371.245,1636.136z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2329.693,1636.136h25.467c2.554,0,4.624-2.071,4.624-4.625v-9.298 c0-2.554-2.07-4.624-4.624-4.624h-25.467c-2.555,0-4.625,2.07-4.625,4.624v9.298 C2325.068,1634.064,2327.139,1636.136,2329.693,1636.136z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2288.14,1636.136h25.468c2.554,0,4.625-2.071,4.625-4.625v-9.298 c0-2.554-2.071-4.624-4.625-4.624h-25.468c-2.554,0-4.624,2.07-4.624,4.624v9.298 C2283.516,1634.064,2285.586,1636.136,2288.14,1636.136z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2246.588,1684.56h25.467c2.555,0,4.625-2.071,4.625-4.625v-9.298 c0-2.554-2.07-4.625-4.625-4.625h-25.467c-2.555,0-4.625,2.071-4.625,4.625v9.298 C2241.963,1682.488,2244.033,1684.56,2246.588,1684.56z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2371.245,1684.56h25.467c2.554,0,4.624-2.071,4.624-4.625v-9.298 c0-2.554-2.07-4.625-4.624-4.625h-25.467c-2.554,0-4.625,2.071-4.625,4.625v9.298 C2366.62,1682.488,2368.691,1684.56,2371.245,1684.56z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2329.693,1684.56h25.467c2.554,0,4.624-2.071,4.624-4.625v-9.298 c0-2.554-2.07-4.625-4.624-4.625h-25.467c-2.555,0-4.625,2.071-4.625,4.625v9.298 C2325.068,1682.488,2327.139,1684.56,2329.693,1684.56z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2288.14,1684.56h25.468c2.554,0,4.625-2.071,4.625-4.625v-9.298 c0-2.554-2.071-4.625-4.625-4.625h-25.468c-2.554,0-4.624,2.071-4.624,4.625v9.298 C2283.516,1682.488,2285.586,1684.56,2288.14,1684.56z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2246.588,1732.983h25.467c2.555,0,4.625-2.071,4.625-4.625v-9.298 c0-2.554-2.07-4.625-4.625-4.625h-25.467c-2.555,0-4.625,2.071-4.625,4.625v9.298 C2241.963,1730.912,2244.033,1732.983,2246.588,1732.983z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2371.245,1732.983h25.467c2.554,0,4.624-2.071,4.624-4.625v-9.298 c0-2.554-2.07-4.625-4.624-4.625h-25.467c-2.554,0-4.625,2.071-4.625,4.625v9.298 C2366.62,1730.912,2368.691,1732.983,2371.245,1732.983z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2329.693,1732.983h25.467c2.554,0,4.624-2.071,4.624-4.625v-9.298 c0-2.554-2.07-4.625-4.624-4.625h-25.467c-2.555,0-4.625,2.071-4.625,4.625v9.298 C2325.068,1730.912,2327.139,1732.983,2329.693,1732.983z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2288.14,1732.983h25.468c2.554,0,4.625-2.071,4.625-4.625v-9.298 c0-2.554-2.071-4.625-4.625-4.625h-25.468c-2.554,0-4.624,2.071-4.624,4.625v9.298 C2283.516,1730.912,2285.586,1732.983,2288.14,1732.983z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8475B5"
    },
    d: "M479.634,1008.375l-31.33,32.702v23.715h94.636v-56.417H479.634z M536.367,1054.095 c0,2.074-2.076,3.755-4.637,3.755h-3.686c-2.561,0-4.637-1.681-4.637-3.755v-2.984c0-2.074,2.076-3.755,4.637-3.755h3.686 c2.561,0,4.637,1.681,4.637,3.755V1054.095z M536.367,1038.075c0,2.074-2.076,3.756-4.637,3.756h-3.686 c-2.561,0-4.637-1.682-4.637-3.756v-2.984c0-2.073,2.076-3.755,4.637-3.755h3.686c2.561,0,4.637,1.682,4.637,3.755V1038.075z  M537.903,1022.621c0,2.757-2.77,4.999-6.173,4.999h-3.685c-3.404,0-6.174-2.242-6.174-4.999v-2.985 c0-2.756,2.77-4.999,6.174-4.999h3.685c3.404,0,6.173,2.243,6.173,4.999V1022.621z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A28FDE"
    },
    d: "M612.614,978.185l-26.293,33.889v25.664h79.996v-59.553H612.614z M646.604,1011.132 c0,1.849-1.504,3.354-3.354,3.354h-46.598c-1.265,0-2.408-0.699-2.985-1.825c-0.576-1.126-0.476-2.463,0.265-3.489l1.304-1.813 c0.629-0.872,1.647-1.394,2.723-1.394h45.292c1.85,0,3.354,1.505,3.354,3.354V1011.132z M659.678,1025.666 c0,2.097-1.699,3.796-3.796,3.796h-3.017c-2.097,0-3.796-1.699-3.796-3.796v-3.018c0-2.097,1.699-3.796,3.796-3.796h3.017 c2.097,0,3.796,1.699,3.796,3.796V1025.666z M659.678,1009.471c0,2.097-1.699,3.796-3.796,3.796h-3.017 c-2.097,0-3.796-1.699-3.796-3.796v-3.018c0-2.097,1.699-3.796,3.796-3.796h3.017c2.097,0,3.796,1.699,3.796,3.796V1009.471z  M659.678,993.847c0,2.096-1.699,3.796-3.796,3.796h-3.017c-2.097,0-3.796-1.7-3.796-3.796v-3.018 c0-2.097,1.699-3.796,3.796-3.796h3.017c2.097,0,3.796,1.7,3.796,3.796V993.847z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A28FDE"
    },
    d: "M640.288,978.712h-2.436v-3.942c0-4.239-3.448-7.688-7.688-7.688s-7.688,3.449-7.688,7.688 v3.942h-2.436v-3.942c0-5.583,4.542-10.125,10.124-10.125c5.583,0,10.125,4.542,10.125,10.125V978.712z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A28FDE"
    },
    d: "M629.726,959.074c-4.508,0-8.177-3.729-8.177-8.313v-58.786c0-4.584,3.669-8.313,8.177-8.313 s8.176,3.729,8.176,8.313v58.786C637.902,955.345,634.233,959.074,629.726,959.074z M629.726,886.037 c-3.22,0-5.84,2.664-5.84,5.938v58.786c0,3.274,2.62,5.938,5.84,5.938c3.22,0,5.84-2.664,5.84-5.938v-58.786 C635.566,888.701,632.945,886.037,629.726,886.037z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A28FDE"
    },
    d: "M632.221,957.417h-4.992c-2.903,0-5.264-2.362-5.264-5.265v-20.76 c0-2.903,2.361-5.265,5.264-5.265h4.992c2.903,0,5.264,2.362,5.264,5.265v20.76 C637.485,955.056,635.124,957.417,632.221,957.417z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 627.535,
    y: 948.489,
    style: {
      fill: "#A28FDE"
    },
    width: 5.11,
    height: 21.171
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A28FDE"
    },
    d: "M633.83,899.723h-18.527c-2.195,0-3.975-1.78-3.975-3.975v-59.992 c0-2.195,1.78-3.975,3.975-3.975h18.527c2.195,0,3.975,1.78,3.975,3.975v59.992C637.805,897.943,636.025,899.723,633.83,899.723 z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A28FDE"
    },
    d: "M420.157,1774.1h-44.775V796.578h44.775V1774.1z M378.886,1770.596h37.767V800.081h-37.767 V1770.596z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A28FDE"
    },
    d: "M417.976,851.833h1.208v-1.44l0.174-0.208l-0.174-0.146v-2.423h-43.51v4.217h0.957l18.55,21.716 L377.93,894.11h-1.672v4.217H418.6v-4.217h-1.249l-17.579-20.581L417.976,851.833z M381.239,851.833H413.4l-15.936,18.995 L381.239,851.833z M412.743,894.11h-30.238l14.983-17.859L412.743,894.11z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A28FDE"
    },
    d: "M417.976,898.54h1.208v-1.44l0.174-0.208l-0.174-0.146v-2.423h-43.51v4.217h0.957l18.55,21.716 l-17.251,20.561h-1.672v4.217H418.6v-4.217h-1.249l-17.579-20.581L417.976,898.54z M381.239,898.54H413.4l-15.936,18.995 L381.239,898.54z M412.743,940.817h-30.238l14.983-17.858L412.743,940.817z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A28FDE"
    },
    d: "M417.976,945.247h1.208v-1.44l0.174-0.207l-0.174-0.147v-2.423h-43.51v4.217h0.957l18.55,21.716 l-17.251,20.562h-1.672v4.217H418.6v-4.217h-1.249l-17.579-20.581L417.976,945.247z M381.239,945.247H413.4l-15.936,18.995 L381.239,945.247z M412.743,987.524h-30.238l14.983-17.859L412.743,987.524z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A28FDE"
    },
    d: "M417.976,991.954h1.208v-1.439l0.174-0.208l-0.174-0.146v-2.423h-43.51v4.217h0.957l18.55,21.716 l-17.251,20.562h-1.672v4.217H418.6v-4.217h-1.249l-17.579-20.581L417.976,991.954z M381.239,991.954H413.4l-15.936,18.995 L381.239,991.954z M412.743,1034.231h-30.238l14.983-17.859L412.743,1034.231z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A28FDE"
    },
    d: "M417.976,1038.661h1.208v-1.439l0.174-0.209l-0.174-0.146v-2.423h-43.51v4.218h0.957 l18.55,21.716l-17.251,20.562h-1.672v4.217H418.6v-4.217h-1.249l-17.579-20.581L417.976,1038.661z M381.239,1038.661H413.4 l-15.936,18.994L381.239,1038.661z M412.743,1080.938h-30.238l14.983-17.859L412.743,1080.938z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A28FDE"
    },
    d: "M417.976,1085.368h1.208v-1.439l0.174-0.209l-0.174-0.146v-2.422h-43.51v4.217h0.957 l18.55,21.717l-17.251,20.561h-1.672v4.217H418.6v-4.217h-1.249l-17.579-20.58L417.976,1085.368z M381.239,1085.368H413.4 l-15.936,18.994L381.239,1085.368z M412.743,1127.646h-30.238l14.983-17.859L412.743,1127.646z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A28FDE"
    },
    d: "M417.976,1132.075h1.208v-1.439l0.174-0.209l-0.174-0.146v-2.422h-43.51v4.217h0.957 l18.55,21.717l-17.251,20.561h-1.672v4.217H418.6v-4.217h-1.249l-17.579-20.58L417.976,1132.075z M381.239,1132.075H413.4 l-15.936,18.994L381.239,1132.075z M412.743,1174.353h-30.238l14.983-17.859L412.743,1174.353z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A28FDE"
    },
    d: "M417.976,1178.782h1.208v-1.439l0.174-0.209l-0.174-0.146v-2.422h-43.51v4.217h0.957 l18.55,21.717l-17.251,20.561h-1.672v4.217H418.6v-4.217h-1.249l-17.579-20.58L417.976,1178.782z M381.239,1178.782H413.4 l-15.936,18.994L381.239,1178.782z M412.743,1221.06h-30.238l14.983-17.859L412.743,1221.06z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A28FDE"
    },
    d: "M417.976,1225.489h1.208v-1.439l0.174-0.209l-0.174-0.146v-2.423h-43.51v4.217h0.957 l18.55,21.717l-17.251,20.561h-1.672v4.217H418.6v-4.217h-1.249l-17.579-20.58L417.976,1225.489z M381.239,1225.489H413.4 l-15.936,18.994L381.239,1225.489z M412.743,1267.767h-30.238l14.983-17.858L412.743,1267.767z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A28FDE"
    },
    d: "M417.976,1272.196h1.208v-1.439l0.174-0.208l-0.174-0.146v-2.423h-43.51v4.217h0.957 l18.55,21.717l-17.251,20.561h-1.672v4.217H418.6v-4.217h-1.249l-17.579-20.58L417.976,1272.196z M381.239,1272.196H413.4 l-15.936,18.995L381.239,1272.196z M412.743,1314.474h-30.238l14.983-17.858L412.743,1314.474z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A28FDE"
    },
    d: "M417.976,1318.903h1.208v-1.439l0.174-0.208l-0.174-0.146v-2.423h-43.51v4.217h0.957 l18.55,21.717l-17.251,20.561h-1.672v4.217H418.6v-4.217h-1.249l-17.579-20.58L417.976,1318.903z M381.239,1318.903H413.4 l-15.936,18.995L381.239,1318.903z M412.743,1361.181h-30.238l14.983-17.858L412.743,1361.181z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A28FDE"
    },
    d: "M417.976,1365.61h1.208v-1.439l0.174-0.208l-0.174-0.146v-2.423h-43.51v4.217h0.957l18.55,21.717 l-17.251,20.561h-1.672v4.217H418.6v-4.217h-1.249l-17.579-20.58L417.976,1365.61z M381.239,1365.61H413.4l-15.936,18.995 L381.239,1365.61z M412.743,1407.888h-30.238l14.983-17.858L412.743,1407.888z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A28FDE"
    },
    d: "M417.976,1412.317h1.208v-1.439l0.174-0.208l-0.174-0.146v-2.423h-43.51v4.217h0.957 l18.55,21.717l-17.251,20.561h-1.672v4.217H418.6v-4.217h-1.249l-17.579-20.58L417.976,1412.317z M381.239,1412.317H413.4 l-15.936,18.995L381.239,1412.317z M412.743,1454.595h-30.238l14.983-17.858L412.743,1454.595z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A28FDE"
    },
    d: "M417.976,1459.024h1.208v-1.439l0.174-0.208l-0.174-0.146v-2.423h-43.51v4.217h0.957 l18.55,21.717l-17.251,20.561h-1.672v4.218H418.6v-4.218h-1.249l-17.579-20.58L417.976,1459.024z M381.239,1459.024H413.4 l-15.936,18.995L381.239,1459.024z M412.743,1501.302h-30.238l14.983-17.858L412.743,1501.302z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A28FDE"
    },
    d: "M417.976,1505.731h1.208v-1.439l0.174-0.208l-0.174-0.146v-2.423h-43.51v4.217h0.957 l18.55,21.717l-17.251,20.562h-1.672v4.217H418.6v-4.217h-1.249l-17.579-20.581L417.976,1505.731z M381.239,1505.731H413.4 l-15.936,18.995L381.239,1505.731z M412.743,1548.01h-30.238l14.983-17.858L412.743,1548.01z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A28FDE"
    },
    d: "M417.976,1552.439h1.208V1551l0.174-0.209l-0.174-0.146v-2.422h-43.51v4.217h0.957l18.55,21.717 l-17.251,20.561h-1.672v4.217H418.6v-4.217h-1.249l-17.579-20.58L417.976,1552.439z M381.239,1552.439H413.4l-15.936,18.994 L381.239,1552.439z M412.743,1594.717h-30.238l14.983-17.858L412.743,1594.717z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A28FDE"
    },
    d: "M417.976,1599.146h1.208v-1.439l0.174-0.208l-0.174-0.146v-2.423h-43.51v4.217h0.957 l18.55,21.717l-17.251,20.561h-1.672v4.217H418.6v-4.217h-1.249l-17.579-20.58L417.976,1599.146z M381.239,1599.146H413.4 l-15.936,18.994L381.239,1599.146z M412.743,1641.424h-30.238l14.983-17.858L412.743,1641.424z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A28FDE"
    },
    d: "M417.976,1645.854h1.208v-1.439l0.174-0.208l-0.174-0.146v-2.423h-43.51v4.217h0.957 l18.55,21.717l-17.251,20.561h-1.672v4.217H418.6v-4.217h-1.249l-17.579-20.58L417.976,1645.854z M381.239,1645.854H413.4 l-15.936,18.995L381.239,1645.854z M412.743,1688.131h-30.238l14.983-17.858L412.743,1688.131z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A28FDE"
    },
    d: "M417.976,1692.561h1.208v-1.439l0.174-0.208l-0.174-0.146v-2.423h-43.51v4.217h0.957 l18.55,21.717l-17.251,20.561h-1.672v4.217H418.6v-4.217h-1.249l-17.579-20.58L417.976,1692.561z M381.239,1692.561H413.4 l-15.936,18.995L381.239,1692.561z M412.743,1734.838h-30.238l14.983-17.858L412.743,1734.838z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A28FDE"
    },
    d: "M377.718,693.172v103.406c0,1.935,1.569,3.504,3.504,3.504h12.459 c1.936,0,3.504-1.569,3.504-3.504V693.172c0-1.936-1.569-3.504-3.504-3.504h-12.459 C379.287,689.667,377.718,691.236,377.718,693.172z M393.682,696.676v28.618c0,1.935-1.569,3.504-3.504,3.504h-5.451 c-1.936,0-3.504-1.569-3.504-3.504v-28.618c0-1.935,1.569-3.504,3.504-3.504h5.451 C392.113,693.172,393.682,694.741,393.682,696.676z M393.682,736.39v16.937c0,1.935-1.569,3.504-3.504,3.504h-5.451 c-1.936,0-3.504-1.569-3.504-3.504V736.39c0-1.935,1.569-3.504,3.504-3.504h5.451 C392.113,732.886,393.682,734.455,393.682,736.39z M381.222,793.073v-28.65c0-1.935,1.569-3.504,3.504-3.504h5.451 c1.935,0,3.504,1.569,3.504,3.504v28.65c0,1.936-1.569,3.504-3.504,3.504h-5.451 C382.791,796.578,381.222,795.009,381.222,793.073z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A28FDE"
    },
    d: "M658.634,847.057H229.376c-5.154,0-9.346-4.193-9.346-9.346v-3.066 c0-4.365,3.097-8.206,7.363-9.132l134.43-29.202c0.649-0.142,1.318-0.213,1.984-0.213h294.826c5.153,0,9.346,4.193,9.346,9.346 v32.268C667.979,842.864,663.787,847.057,658.634,847.057z M363.808,801.938c-0.25,0-0.5,0.027-0.744,0.08l-134.431,29.202 c-1.601,0.348-2.762,1.789-2.762,3.425v3.066c0,1.933,1.573,3.505,3.505,3.505h429.257c1.932,0,3.505-1.573,3.505-3.505 v-32.268c0-1.933-1.573-3.505-3.505-3.505H363.808z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A28FDE"
    },
    d: "M658.635,796.093c-313.705,0.087-294.836-0.202-296.814,0.222 c-0.18,0.039-134.21,29.153-134.432,29.201c-4.264,0.923-7.359,4.766-7.359,9.134v3.06c0,5.151,4.194,9.344,9.345,9.344h429.259 c5.151,0,9.345-4.193,9.345-9.344v-32.273C667.979,800.286,663.786,796.093,658.635,796.093z M652.926,819.121l9.121-14.479 c0.175,0.749,0.059-0.815,0.092,30.424C654.521,823.507,651.104,822.012,652.926,819.121z M368.482,819.401 c0.693,0.965,0.733,2.254,0.1,3.26l-9.871,15.669c-10.176-15.19-13.385-16.277-11.561-19.216l9.875-15.663L368.482,819.401z  M370.996,829.787c1.104-1.754,3.633-1.831,4.842-0.148l8.316,11.575h-20.356L370.996,829.787z M603.212,838.332l-11.459-15.951 c-0.693-0.965-0.733-2.254-0.099-3.26l9.872-15.671c10.148,15.154,13.396,16.295,11.558,19.211L603.212,838.332z  M607.626,801.933h18.515l-6.339,10.063c-1.104,1.753-3.633,1.83-4.842,0.147L607.626,801.933z M589.24,811.996 c-1.104,1.753-3.633,1.83-4.842,0.147l-7.335-10.209h18.516L589.24,811.996z M572.649,838.332l-11.459-15.951 c-0.693-0.965-0.733-2.254-0.099-3.26l9.872-15.671l11.459,15.951c0.693,0.965,0.732,2.254,0.099,3.26L572.649,838.332z  M558.677,811.996c-1.104,1.753-3.633,1.83-4.842,0.147l-7.335-10.209h18.516L558.677,811.996z M542.087,838.332 c-10.148-15.154-13.396-16.294-11.559-19.211l9.872-15.671c10.148,15.154,13.396,16.295,11.559,19.211L542.087,838.332z  M528.114,811.996c-1.104,1.753-3.633,1.83-4.842,0.147l-7.335-10.209h18.516L528.114,811.996z M511.523,838.332l-11.459-15.951 c-0.693-0.965-0.733-2.254-0.099-3.26l9.872-15.671c10.148,15.154,13.396,16.295,11.559,19.211L511.523,838.332z  M497.552,811.996c-1.104,1.753-3.633,1.83-4.842,0.147l-7.335-10.209h18.515L497.552,811.996z M480.961,838.332l-11.459-15.951 c-0.693-0.965-0.733-2.254-0.1-3.26l9.872-15.671l11.459,15.951c0.693,0.965,0.732,2.254,0.1,3.26L480.961,838.332z  M466.989,811.996c-1.104,1.753-3.633,1.83-4.842,0.147l-7.335-10.209h18.516L466.989,811.996z M450.398,838.332l-11.459-15.951 c-0.693-0.965-0.732-2.254-0.099-3.26l9.871-15.671l11.46,15.951c0.693,0.965,0.732,2.254,0.099,3.26L450.398,838.332z  M436.426,811.996c-1.104,1.753-3.633,1.83-4.842,0.147l-7.335-10.209h18.515L436.426,811.996z M419.836,838.332 c-10.148-15.154-13.396-16.294-11.558-19.211l9.871-15.671l11.46,15.951c0.693,0.965,0.733,2.254,0.099,3.26L419.836,838.332z  M405.863,811.996c-1.105,1.753-3.633,1.83-4.842,0.147l-7.335-10.209h18.516L405.863,811.996z M387.586,803.45l11.46,15.951 c0.693,0.965,0.732,2.254,0.099,3.26l-9.871,15.67l-11.46-15.951c-0.693-0.965-0.732-2.254-0.099-3.26L387.586,803.45z  M401.558,829.787c1.104-1.754,3.633-1.831,4.842-0.148l8.315,11.575h-20.356L401.558,829.787z M432.121,829.787 c1.104-1.754,3.633-1.831,4.842-0.148l8.316,11.575h-20.357L432.121,829.787z M462.684,829.787 c1.104-1.754,3.633-1.831,4.842-0.148l8.316,11.575h-20.356L462.684,829.787z M493.246,829.787 c1.104-1.754,3.633-1.831,4.842-0.148l8.316,11.575h-20.356L493.246,829.787z M523.809,829.787 c1.104-1.754,3.633-1.831,4.842-0.148l8.315,11.575H516.61L523.809,829.787z M554.372,829.787 c1.105-1.754,3.633-1.831,4.842-0.148l8.315,11.575h-20.356L554.372,829.787z M584.935,829.787 c1.105-1.754,3.633-1.831,4.842-0.148l8.315,11.575h-20.357L584.935,829.787z M615.497,829.787 c1.105-1.754,3.633-1.831,4.842-0.148l8.316,11.575h-20.357L615.497,829.787z M633.853,838.441l-11.538-16.06 c-2.007-2.794,1.212-4.235,9.841-19.04l11.538,16.06C645.702,822.195,642.482,823.637,633.853,838.441z M638.336,801.933h18.515 l-6.338,10.063c-1.104,1.753-3.633,1.83-4.842,0.147L638.336,801.933z M381.639,801.933l-6.338,10.063 c-1.105,1.753-3.633,1.83-4.842,0.147l-7.29-10.147C363.861,801.876,362.818,801.959,381.639,801.933z M349.112,805.04 l-4.38,6.95c-1.098,1.764-3.633,1.834-4.836,0.152l-3.166-4.404L349.112,805.04z M330.517,809.081l7.405,10.326 c0.689,0.958,0.724,2.254,0.093,3.259l-9.872,15.665c-10.103-15.083-13.401-16.286-11.549-19.216l5.116-8.118L330.517,809.081z  M313.417,812.796c-0.666,0.502-1.507,0.666-2.301,0.502L313.417,812.796z M304.072,814.829l3.282,4.579 c0.701,0.958,0.736,2.254,0.105,3.259l-9.871,15.664l-11.458-15.944c-1.353-1.871,0.126-3.574,0.164-3.691L304.072,814.829z  M277.301,820.646c0.324,1.918-0.419,1.563-10.279,17.685l-9.601-13.363L277.301,820.646z M225.871,837.711 c0.196-1.042-1.029-5.665,2.757-6.495l14.273-3.095c-7.815,12.559-7.77,11.954-7.978,13.094h-5.548 C227.448,841.215,225.871,839.638,225.871,837.711z M241.546,841.215l7.195-11.424c1.11-1.752,3.632-1.833,4.847-0.151 l8.305,11.575H241.546z M272.103,841.215l7.207-11.424c1.098-1.752,3.633-1.833,4.836-0.151l8.316,11.575H272.103z  M302.671,841.215l7.195-11.424c1.11-1.752,3.633-1.833,4.848-0.151l8.305,11.575H302.671z M333.227,841.215l7.207-11.424 c1.098-1.752,3.633-1.833,4.836-0.151l8.316,11.575H333.227z M639.008,841.215l7.199-11.428 c1.105-1.754,3.633-1.831,4.842-0.148l8.267,11.508c-0.221,0.044-0.448,0.067-0.682,0.067H639.008z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A28FDE"
    },
    d: "M260.426,952.674h-5.84c-1.989,0-3.602-1.612-3.602-3.602V848.62 c0-1.989,1.612-3.602,3.602-3.602h5.84c1.989,0,3.602,1.613,3.602,3.602v100.453 C264.027,951.062,262.415,952.674,260.426,952.674z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A28FDE"
    },
    d: "M315.422,879.477h-75.145c-3.333,0-6.035-2.702-6.035-6.035v-10.707 c0-3.333,2.702-6.035,6.035-6.035h75.145c3.333,0,6.035,2.702,6.035,6.035v10.707 C321.457,876.774,318.755,879.477,315.422,879.477z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A28FDE"
    },
    d: "M315.422,905.711h-75.145c-3.333,0-6.035-2.702-6.035-6.035v-10.707 c0-3.333,2.702-6.035,6.035-6.035h75.145c3.333,0,6.035,2.702,6.035,6.035v10.707 C321.457,903.009,318.755,905.711,315.422,905.711z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A28FDE"
    },
    d: "M315.422,931.067h-75.145c-3.333,0-6.035-2.702-6.035-6.035v-10.707 c0-3.333,2.702-6.035,6.035-6.035h75.145c3.333,0,6.035,2.702,6.035,6.035v10.707 C321.457,928.365,318.755,931.067,315.422,931.067z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A28FDE"
    },
    d: "M231.712,830.224c-0.807,0-1.612-0.333-2.189-0.987c-1.068-1.208-0.955-3.054,0.255-4.122 l157.151-138.881l244.427,109.431c1.473,0.659,2.131,2.387,1.473,3.858c-0.659,1.472-2.387,2.13-3.859,1.472L387.976,693.102 l-154.331,136.39C233.089,829.982,232.399,830.224,231.712,830.224z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A28FDE"
    },
    d: "M388.961,693.269h-2.336c-0.887,0-1.606-0.719-1.606-1.606v-14.893 c0-0.887,0.719-1.606,1.606-1.606h2.336c0.887,0,1.606,0.719,1.606,1.606v14.893 C390.566,692.55,389.848,693.269,388.961,693.269z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B2B0BE"
    },
    d: "M1388.689,1092.163h2.976v-4.814c0-5.178,4.212-9.391,9.391-9.391s9.391,4.213,9.391,9.391 v4.814h2.976v-4.814c0-6.818-5.548-12.367-12.367-12.367c-6.818,0-12.366,5.549-12.366,12.367V1092.163z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B2B0BE"
    },
    d: "M1391.604,1058.023V986.22c0-5.599,4.48-10.154,9.987-10.154c5.506,0,9.987,4.555,9.987,10.154 v71.803c0,5.599-4.481,10.153-9.987,10.153C1396.084,1068.177,1391.604,1063.622,1391.604,1058.023z M1394.457,986.22v71.803 c0,3.999,3.201,7.253,7.134,7.253s7.133-3.254,7.133-7.253V986.22c0-3.999-3.2-7.252-7.133-7.252 S1394.457,982.222,1394.457,986.22z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B2B0BE"
    },
    d: "M1392.112,1059.723v-25.356c0-3.547,2.884-6.432,6.43-6.432h6.097c3.546,0,6.43,2.885,6.43,6.432 v25.356c0,3.546-2.884,6.431-6.43,6.431h-6.097C1394.997,1066.153,1392.112,1063.269,1392.112,1059.723z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1398.024,
    y: 1055.247,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 2802.29 2136.3535)",
    style: {
      fill: "#B2B0BE"
    },
    width: 6.241,
    height: 25.859
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B2B0BE"
    },
    d: "M1396.578,995.684h22.629c2.681,0,4.855-2.174,4.855-4.855v-73.276 c0-2.681-2.174-4.855-4.855-4.855h-22.629c-2.681,0-4.855,2.174-4.855,4.855v73.276 C1391.723,993.51,1393.896,995.684,1396.578,995.684z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B2B0BE"
    },
    d: "M1555.316,1092.163h2.976v-4.814c0-5.178,4.212-9.391,9.391-9.391s9.391,4.213,9.391,9.391 v4.814h2.976v-4.814c0-6.818-5.547-12.367-12.366-12.367c-6.818,0-12.366,5.549-12.366,12.367V1092.163z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B2B0BE"
    },
    d: "M1558.23,1058.023V986.22c0-5.599,4.481-10.154,9.987-10.154c5.507,0,9.987,4.555,9.987,10.154 v71.803c0,5.599-4.48,10.153-9.987,10.153C1562.712,1068.177,1558.23,1063.622,1558.23,1058.023z M1561.084,986.22v71.803 c0,3.999,3.201,7.253,7.134,7.253s7.134-3.254,7.134-7.253V986.22c0-3.999-3.201-7.252-7.134-7.252 S1561.084,982.222,1561.084,986.22z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B2B0BE"
    },
    d: "M1558.739,1059.723v-25.356c0-3.547,2.884-6.432,6.431-6.432h6.096 c3.547,0,6.431,2.885,6.431,6.432v25.356c0,3.546-2.884,6.431-6.431,6.431h-6.096 C1561.623,1066.153,1558.739,1063.269,1558.739,1059.723z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1564.651,
    y: 1055.247,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 3135.5439 2136.3535)",
    style: {
      fill: "#B2B0BE"
    },
    width: 6.241,
    height: 25.859
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B2B0BE"
    },
    d: "M1563.205,995.684h22.629c2.681,0,4.854-2.174,4.854-4.855v-73.276 c0-2.681-2.173-4.855-4.854-4.855h-22.629c-2.682,0-4.855,2.174-4.855,4.855v73.276 C1558.35,993.51,1560.523,995.684,1563.205,995.684z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B2B0BE"
    },
    d: "M1655.233,870.403V1795h59.351V870.403H1655.233z M1664.174,1787.058V878.346h41.47v908.712 H1664.174z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B2B0BE"
    },
    d: "M1682.463,962.732l-21.472,25.933h-1.525v5.314h51.718v-5.314h-2.042l-21.07-25.909 l22.657-27.365h1.168v-5.313h-53.145v5.313h1.477L1682.463,962.732z M1685.282,959.327l-19.466-23.935h39.283L1685.282,959.327z  M1685.252,966.162l18.301,22.503h-36.933L1685.252,966.162z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B2B0BE"
    },
    d: "M1682.463,1020.739l-21.472,25.138h-1.525v5.151h51.718v-5.151h-2.042l-21.07-25.113 l22.657-26.525h1.168v-5.151h-53.145v5.151h1.477L1682.463,1020.739z M1685.282,1017.438l-19.466-23.2h39.283L1685.282,1017.438 z M1685.252,1024.063l18.301,21.813h-36.933L1685.252,1024.063z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B2B0BE"
    },
    d: "M1682.463,1077.789l-21.472,25.138h-1.525v5.15h51.718v-5.15h-2.042l-21.07-25.113l22.657-26.525 h1.168v-5.151h-53.145v5.151h1.477L1682.463,1077.789z M1685.282,1074.488l-19.466-23.2h39.283L1685.282,1074.488z  M1685.252,1081.113l18.301,21.813h-36.933L1685.252,1081.113z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B2B0BE"
    },
    d: "M1682.463,1134.839l-21.472,25.137h-1.525v5.151h51.718v-5.151h-2.042l-21.07-25.113 l22.657-26.525h1.168v-5.15h-53.145v5.15h1.477L1682.463,1134.839z M1685.282,1131.538l-19.466-23.201h39.283L1685.282,1131.538 z M1685.252,1138.163l18.301,21.813h-36.933L1685.252,1138.163z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B2B0BE"
    },
    d: "M1682.463,1191.888l-21.472,25.138h-1.525v5.15h51.718v-5.15h-2.042l-21.07-25.114l22.657-26.524 h1.168v-5.151h-53.145v5.151h1.477L1682.463,1191.888z M1685.282,1188.587l-19.466-23.2h39.283L1685.282,1188.587z  M1685.252,1195.212l18.301,21.813h-36.933L1685.252,1195.212z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B2B0BE"
    },
    d: "M1682.463,1248.938l-21.472,25.138h-1.525v5.15h51.718v-5.15h-2.042l-21.07-25.114l22.657-26.524 h1.168v-5.151h-53.145v5.151h1.477L1682.463,1248.938z M1685.282,1245.637l-19.466-23.2h39.283L1685.282,1245.637z  M1685.252,1252.262l18.301,21.813h-36.933L1685.252,1252.262z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B2B0BE"
    },
    d: "M1682.463,1305.987l-21.472,25.137h-1.525v5.15h51.718v-5.15h-2.042l-21.07-25.113l22.657-26.525 h1.168v-5.15h-53.145v5.15h1.477L1682.463,1305.987z M1685.282,1302.687l-19.466-23.201h39.283L1685.282,1302.687z  M1685.252,1309.312l18.301,21.813h-36.933L1685.252,1309.312z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B2B0BE"
    },
    d: "M1682.463,1363.036l-21.472,25.138h-1.525v5.15h51.718v-5.15h-2.042l-21.07-25.114l22.657-26.525 h1.168v-5.15h-53.145v5.15h1.477L1682.463,1363.036z M1685.282,1359.735l-19.466-23.201h39.283L1685.282,1359.735z  M1685.252,1366.36l18.301,21.813h-36.933L1685.252,1366.36z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B2B0BE"
    },
    d: "M1682.463,1420.085l-21.472,25.138h-1.525v5.151h51.718v-5.151h-2.042l-21.07-25.113 l22.657-26.525h1.168v-5.15h-53.145v5.15h1.477L1682.463,1420.085z M1685.282,1416.785l-19.466-23.201h39.283L1685.282,1416.785 z M1685.252,1423.41l18.301,21.813h-36.933L1685.252,1423.41z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B2B0BE"
    },
    d: "M1682.463,1477.135l-21.472,25.138h-1.525v5.15h51.718v-5.15h-2.042l-21.07-25.113l22.657-26.525 h1.168v-5.151h-53.145v2.96l-0.213,0.179l0.213,0.254v1.759h1.477L1682.463,1477.135z M1685.282,1473.835l-19.466-23.201h39.283 L1685.282,1473.835z M1685.252,1480.46l18.301,21.813h-36.933L1685.252,1480.46z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B2B0BE"
    },
    d: "M1682.463,1534.185l-21.472,25.138h-1.525v5.15h51.718v-5.15h-2.042l-21.07-25.114l22.657-26.525 h1.168v-5.15h-53.145v2.959l-0.213,0.18l0.213,0.254v1.758h1.477L1682.463,1534.185z M1685.282,1530.884l-19.466-23.201h39.283 L1685.282,1530.884z M1685.252,1537.509l18.301,21.813h-36.933L1685.252,1537.509z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B2B0BE"
    },
    d: "M1682.463,1591.234l-21.472,25.137h-1.525v5.151h51.718v-5.151h-2.042l-21.07-25.113 l22.657-26.525h1.168v-5.15h-53.145v2.959l-0.213,0.18l0.213,0.254v1.758h1.477L1682.463,1591.234z M1685.282,1587.934 l-19.466-23.201h39.283L1685.282,1587.934z M1685.252,1594.559l18.301,21.813h-36.933L1685.252,1594.559z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B2B0BE"
    },
    d: "M1682.463,1648.283l-21.472,25.138h-1.525v5.151h51.718v-5.151h-2.042l-21.07-25.113 l22.657-26.525h1.168v-5.151h-53.145v2.96l-0.213,0.179l0.213,0.254v1.759h1.477L1682.463,1648.283z M1685.282,1644.982 l-19.466-23.2h39.283L1685.282,1644.982z M1685.252,1651.607l18.301,21.813h-36.933L1685.252,1651.607z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B2B0BE"
    },
    d: "M1682.463,1705.333l-21.472,25.138h-1.525v5.15h51.718v-5.15h-2.042l-21.07-25.114l22.657-26.524 h1.168v-5.151h-53.145v2.96l-0.213,0.178l0.213,0.255v1.759h1.477L1682.463,1705.333z M1685.282,1702.032l-19.466-23.2h39.283 L1685.282,1702.032z M1685.252,1708.657l18.301,21.813h-36.933L1685.252,1708.657z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B2B0BE"
    },
    d: "M1682.463,1762.383l-21.472,25.137h-1.525v5.151h51.718v-5.151h-2.042l-21.07-25.113 l22.657-26.525h1.168v-5.15h-53.145v2.959l-0.213,0.179l0.213,0.255v1.758h1.477L1682.463,1762.383z M1685.282,1759.082 l-19.466-23.201h39.283L1685.282,1759.082z M1685.252,1765.707l18.301,21.813h-36.933L1685.252,1765.707z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B2B0BE"
    },
    d: "M1705.12,739.116h-15.219c-2.364,0-4.28,1.916-4.28,4.28v126.303c0,2.364,1.916,4.28,4.28,4.28 h15.219c2.363,0,4.28-1.916,4.28-4.28V743.396C1709.4,741.032,1707.483,739.116,1705.12,739.116z M1694.182,743.396h6.658 c2.363,0,4.28,1.916,4.28,4.28v34.955c0,2.363-1.917,4.28-4.28,4.28h-6.658c-2.363,0-4.28-1.917-4.28-4.28v-34.955 C1689.901,745.313,1691.818,743.396,1694.182,743.396z M1694.182,791.904h6.658c2.363,0,4.28,1.916,4.28,4.28v20.687 c0,2.364-1.917,4.28-4.28,4.28h-6.658c-2.363,0-4.28-1.916-4.28-4.28v-20.687 C1689.901,793.82,1691.818,791.904,1694.182,791.904z M1700.84,869.699h-6.658c-2.363,0-4.28-1.917-4.28-4.28v-34.994 c0-2.364,1.917-4.28,4.28-4.28h6.658c2.363,0,4.28,1.917,4.28,4.28v34.994C1705.12,867.783,1703.203,869.699,1700.84,869.699z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B2B0BE"
    },
    d: "M1354.867,919.94v-39.413c0-6.294,5.12-11.415,11.415-11.415h360.109 c0.814,0,1.631,0.088,2.423,0.261l164.196,35.668c5.211,1.131,8.994,5.822,8.994,11.154v3.745 c0,6.294-5.121,11.415-11.415,11.415h-524.308C1359.987,931.356,1354.867,926.234,1354.867,919.94z M1366.281,876.246 c-2.36,0-4.281,1.92-4.281,4.281v39.413c0,2.361,1.921,4.281,4.281,4.281h524.308c2.36,0,4.281-1.92,4.281-4.281v-3.745 c0-1.999-1.418-3.759-3.373-4.184l-164.198-35.668c-0.298-0.065-0.604-0.097-0.908-0.097H1366.281z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B2B0BE"
    },
    d: "M1354.867,880.521v39.42c0,6.291,5.122,11.413,11.414,11.413h524.31 c6.292,0,11.414-5.122,11.414-11.413v-3.738c0-5.336-3.781-10.029-8.988-11.157c-0.271-0.059-163.979-35.62-164.198-35.667 c-2.415-0.518,20.631-0.165-362.537-0.271C1359.988,869.107,1354.867,874.229,1354.867,880.521z M1362,916.711 c0.041-38.157-0.102-36.246,0.113-37.161l11.14,17.684C1375.478,900.766,1371.306,902.592,1362,916.711z M1734.676,878.096 l12.061,19.131c2.229,3.589-1.691,4.917-14.121,23.47l-12.056-19.139c-0.774-1.228-0.726-2.803,0.121-3.982L1734.676,878.096z  M1726.404,924.22h-24.864l10.157-14.138c1.477-2.056,4.564-1.962,5.914,0.18L1726.404,924.22z M1421.918,901.559 c-2.244-3.563,1.722-4.956,14.118-23.465l12.057,19.141c0.774,1.228,0.726,2.803-0.121,3.981l-13.997,19.483L1421.918,901.559z  M1419.625,888.711c-1.477,2.056-4.565,1.962-5.914-0.18l-7.742-12.291h22.615L1419.625,888.711z M1443.299,876.241h22.615 l-8.959,12.47c-1.477,2.056-4.565,1.962-5.914-0.18L1443.299,876.241z M1459.248,901.559c-0.774-1.228-0.726-2.803,0.121-3.982 l13.997-19.483l12.057,19.141c0.774,1.228,0.726,2.803-0.121,3.981l-13.997,19.483L1459.248,901.559z M1480.629,876.241h22.615 l-8.959,12.47c-1.476,2.056-4.564,1.962-5.914-0.18L1480.629,876.241z M1496.578,901.559 c-2.244-3.563,1.723-4.956,14.118-23.465l12.058,19.141c2.244,3.563-1.723,4.956-14.118,23.465L1496.578,901.559z  M1517.959,876.241h22.615l-8.959,12.47c-1.477,2.056-4.564,1.962-5.914-0.18L1517.959,876.241z M1533.908,901.559 c-2.244-3.563,1.723-4.956,14.118-23.465l12.058,19.141c0.773,1.228,0.726,2.803-0.121,3.981l-13.997,19.483L1533.908,901.559z  M1555.289,876.241h22.616l-8.96,12.47c-1.476,2.056-4.564,1.962-5.913-0.18L1555.289,876.241z M1571.238,901.559 c-0.773-1.228-0.725-2.803,0.121-3.982l13.997-19.483l12.058,19.141c0.773,1.228,0.726,2.803-0.121,3.981l-13.997,19.483 L1571.238,901.559z M1592.62,876.241h22.615l-8.959,12.47c-1.477,2.056-4.565,1.962-5.914-0.18L1592.62,876.241z  M1608.568,901.559c-0.773-1.228-0.725-2.803,0.121-3.982l13.997-19.483l12.058,19.141c0.773,1.228,0.726,2.803-0.121,3.981 l-13.996,19.483L1608.568,901.559z M1629.95,876.241h22.615l-8.959,12.47c-1.477,2.056-4.565,1.962-5.914-0.18L1629.95,876.241z  M1645.898,901.559c-0.773-1.228-0.725-2.803,0.121-3.982l13.997-19.483l12.058,19.141c2.244,3.563-1.723,4.956-14.117,23.465 L1645.898,901.559z M1667.28,876.241h22.615l-8.958,12.47c-1.478,2.056-4.566,1.962-5.915-0.18L1667.28,876.241z  M1709.404,897.234c0.773,1.228,0.727,2.803-0.121,3.981l-13.996,19.483l-12.058-19.141c-0.774-1.228-0.726-2.803,0.121-3.982 l13.996-19.483L1709.404,897.234z M1689.074,924.22h-24.864l10.157-14.138c1.477-2.056,4.564-1.962,5.914,0.18L1689.074,924.22z  M1651.744,924.22h-24.864l10.157-14.138c1.477-2.056,4.564-1.962,5.914,0.18L1651.744,924.22z M1614.414,924.22h-24.865 l10.158-14.138c1.477-2.056,4.564-1.962,5.914,0.18L1614.414,924.22z M1577.084,924.22h-24.865l10.158-14.138 c1.477-2.056,4.564-1.962,5.914,0.18L1577.084,924.22z M1539.753,924.22h-24.864l10.157-14.138 c1.477-2.056,4.565-1.962,5.914,0.18L1539.753,924.22z M1502.423,924.22h-24.864l10.157-14.138 c1.477-2.056,4.565-1.962,5.914,0.18L1502.423,924.22z M1465.093,924.22h-24.864l10.157-14.138 c1.477-2.056,4.565-1.962,5.915,0.18L1465.093,924.22z M1427.763,924.22h-24.864l10.157-14.138 c1.477-2.056,4.565-1.962,5.915,0.18L1427.763,924.22z M1384.529,897.577l14.092-19.617 c10.54,18.083,14.472,19.842,12.021,23.255l-14.092,19.617C1386.01,902.75,1382.077,900.99,1384.529,897.577z M1382.115,888.711 c-1.477,2.056-4.565,1.962-5.914-0.18l-7.742-12.291h22.615L1382.115,888.711z M1727.172,876.316l-8.904,12.394 c-1.478,2.056-4.566,1.962-5.915-0.18l-7.741-12.291C1727.6,876.273,1726.324,876.171,1727.172,876.316z M1759.463,883.331 l-3.867,5.379c-1.469,2.055-4.564,1.969-5.906-0.186l-5.35-8.489L1759.463,883.331z M1777.811,887.312l6.248,9.916 c2.262,3.579-1.766,5.048-14.106,23.47l-12.059-19.133c-0.771-1.227-0.728-2.811,0.114-3.981l9.045-12.612L1777.811,887.312z  M1790.75,890.122c-0.97,0.2-1.997,0-2.811-0.613L1790.75,890.122z M1821.067,896.714c0.046,0.142,1.853,2.223,0.2,4.508 l-13.996,19.475l-12.057-19.132c-0.77-1.227-0.727-2.811,0.129-3.981l4.01-5.593L1821.067,896.714z M1856.335,904.375 l-11.728,16.321c-12.044-19.69-12.951-19.258-12.555-21.6L1856.335,904.375z M1890.59,924.22h-6.776 c-0.253-1.392-0.199-0.653-9.745-15.993l17.436,3.781c4.623,1.013,3.127,6.66,3.366,7.933 C1894.87,922.294,1892.944,924.22,1890.59,924.22z M1850.871,924.22l10.144-14.138c1.483-2.055,4.565-1.955,5.921,0.186 l8.789,13.953H1850.871z M1813.534,924.22l10.158-14.138c1.47-2.055,4.565-1.955,5.907,0.186l8.802,13.953H1813.534z  M1776.213,924.22l10.143-14.138c1.484-2.055,4.566-1.955,5.922,0.186l8.788,13.953H1776.213z M1738.875,924.22l10.158-14.138 c1.47-2.055,4.566-1.955,5.906,0.186l8.804,13.953H1738.875z M1366.28,924.22c-0.285,0-0.563-0.029-0.833-0.083l10.098-14.056 c1.477-2.056,4.565-1.962,5.914,0.18l8.793,13.958H1366.28z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B2B0BE"
    },
    d: "M1852.664,1060.36h7.133c2.43,0,4.399-1.97,4.399-4.399V933.266c0-2.43-1.97-4.399-4.399-4.399 h-7.133c-2.43,0-4.399,1.969-4.399,4.399v122.695C1848.265,1058.391,1850.234,1060.36,1852.664,1060.36z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B2B0BE"
    },
    d: "M1785.49,970.954h91.784c4.071,0,7.371-3.3,7.371-7.371v-13.078c0-4.071-3.3-7.371-7.371-7.371 h-91.784c-4.07,0-7.371,3.3-7.371,7.371v13.078C1778.119,967.654,1781.42,970.954,1785.49,970.954z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B2B0BE"
    },
    d: "M1785.49,1002.997h91.784c4.071,0,7.371-3.3,7.371-7.371v-13.078c0-4.071-3.3-7.371-7.371-7.371 h-91.784c-4.07,0-7.371,3.3-7.371,7.371v13.078C1778.119,999.697,1781.42,1002.997,1785.49,1002.997z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B2B0BE"
    },
    d: "M1785.49,1033.968h91.784c4.071,0,7.371-3.3,7.371-7.371v-13.078c0-4.07-3.3-7.371-7.371-7.371 h-91.784c-4.07,0-7.371,3.301-7.371,7.371v13.078C1778.119,1030.668,1781.42,1033.968,1785.49,1033.968z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B2B0BE"
    },
    d: "M1785.49,1067.48h91.784c4.071,0,7.371-3.3,7.371-7.371v-13.078c0-4.071-3.3-7.371-7.371-7.371 h-91.784c-4.07,0-7.371,3.3-7.371,7.371v13.078C1778.119,1064.181,1781.42,1067.48,1785.49,1067.48z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B2B0BE"
    },
    d: "M1887.735,910.795c0.986,0,1.969-0.407,2.674-1.205c1.306-1.475,1.166-3.729-0.312-5.034 l-191.948-169.634l-298.551,133.662c-1.799,0.804-2.603,2.914-1.799,4.712c0.805,1.798,2.916,2.602,4.713,1.798 l294.358-131.784l188.504,166.591C1886.054,910.5,1886.896,910.795,1887.735,910.795z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B2B0BE"
    },
    d: "M1695.668,743.515h2.854c1.084,0,1.962-0.878,1.962-1.961v-18.19 c0-1.083-0.878-1.962-1.962-1.962h-2.854c-1.083,0-1.961,0.878-1.961,1.962v18.19 C1693.707,742.637,1694.585,743.515,1695.668,743.515z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5E5873"
    },
    d: "M1321.647,1131.544h269.444c6.162,0,11.158-4.995,11.158-11.157v-17.066 c0-6.161-4.996-11.157-11.158-11.157h-269.444c-6.162,0-11.157,4.996-11.157,11.157v17.066 C1310.49,1126.549,1315.486,1131.544,1321.647,1131.544z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5E5873"
    },
    d: "M1143.41,1478.256c29.229,0,58.458,0.058,87.687-0.104c2.526-0.014,5.54-0.845,7.493-2.367 c26.719-20.839,53.245-41.925,79.917-62.823c15.742-12.334,31.758-24.252,48.191-35.721c18.512-12.92,35.29-28.352,52.613-42.938 c8.035-6.766,16.348-13.449,23.184-21.34c14.709-16.98,28.32-34.906,42.883-52.019c3.88-4.56,9.197-8.286,14.529-11.13 c7.886-4.206,19.234,4.168,18.402,13.129c-0.397,4.277-1.774,8.499-1.869,12.765c-1.17,52.527-2.236,105.058-3.223,157.589 c-0.867,46.143-1.605,92.288-2.378,138.433c-0.08,4.772-0.011,9.547-0.011,14.463c1.141,0.134,1.98,0.273,2.824,0.326 c6.742,0.416,7.76,1.439,7.846,8.105c0.055,4.324,0.055,8.648,0.058,12.972c0.008,10.269,0.003,10.265-10.189,10.966 c-0.278,0.02-0.537,0.348-0.976,0.65c0.783,6.172,5.986,8.873,10.021,12.434c7.148,6.31,9.397,15.143,5.66,22.833 c-3.558,7.32-12.852,11.073-22.357,9.026c-8.903-1.916-14.91-8.849-15.309-18.043c1.898-0.333,3.844-0.674,5.887-1.032 c0.596,1.761,0.986,3.075,1.481,4.349c2.161,5.556,6.933,8.844,12.782,8.849c5.686,0.005,10.131-2.831,11.854-7.563 c1.846-5.066,0.275-9.615-4.894-14.135c-0.78-0.682-1.567-1.366-2.406-1.972c-5.235-3.776-9.087-8.456-9.712-15.593 c-2.485,0-4.709-0.105-6.921,0.021c-5.441,0.312-7.341-2.61-6.73-8.526c0.526-5.098,0.36-10.235-0.095-15.341 c-0.466-5.229,1.387-7.946,6.306-8.044c1.369-0.026,2.736-0.176,4.696-0.31c-1.869-94.313-3.735-188.463-5.63-284.08 c-1.92,2.52-2.875,3.709-3.762,4.945c-68.799,95.935-137.567,191.892-206.473,287.749c-2.966,4.127-3.866,7.732-2.744,12.76 c3.604,16.145,6.624,32.419,10.001,49.304h-49.013v13.322h-24.471v16.69c19.597,0,38.779-0.034,57.962,0.01 c21.743,0.05,39.275,17.91,39.267,39.924c-0.008,21.572-17.621,39.273-39.255,39.289c-76.271,0.055-152.541,0.087-228.812,0.065 c-22.203-0.006-39.846-17.889-39.691-39.999c0.153-21.809,17.833-39.246,39.89-39.298c14.355-0.034,28.711,0.001,43.066-0.024 c1.808-0.004,3.616-0.186,5.388-0.283v-16.717h-23.636c0-3.629-0.343-6.605,0.075-9.472c0.745-5.104-1.406-8.26-5.407-11.196 c-14.348-10.531-28.42-21.439-42.752-31.993c-2.862-2.107-3.356-3.933-2.058-7.42c3.812-10.234,7.358-20.583,9.81-31.226 c1.115-4.841,2.828-6.833,7.432-6.926c10.362-0.208,20.717-0.824,31.07-1.365c12.356-0.646,24.708-1.383,37.31-2.095 c0-13.649,0.036-26.775-0.018-39.9c-0.021-5.064-0.305-10.027,4.72-13.464c0.981-0.671,0.992-3.146,1.004-4.791 c0.077-10.895,0.048-21.791,0.021-32.687c-0.022-9.232-0.576-9.959-9.249-12.602v-6.905c10.927-0.388,16.765,5.009,16.994,15.966 c0.261,12.447,0.045,24.904,0.136,37.355c0.012,1.632,0.496,3.291,0.955,4.882c0.971,3.359,2.87,6.657,2.973,10.024 c0.368,12.037,0.144,24.093,0.144,36.792c4.21-1.481,7.736-2.723,11.557-4.066v-80.479 C1139.69,1478.256,1141.55,1478.256,1143.41,1478.256z M1149.605,1611.682h44.436v-114.315h-44.436V1611.682z M1420.671,1340.033 c-0.495-0.491-0.321-0.318-0.815-0.81c-19.48,16.063-38.96,32.125-58.625,48.34c1.053,2.199,2.004,4.182,2.806,5.855 c-6.012,6.297-11.741,12.707-17.898,18.676c-28.037,27.18-56.214,54.217-84.242,81.406c-1.123,1.09-1.999,3.344-1.724,4.82 c1.854,9.963,4.049,19.863,6.386,30.981C1318.47,1465.549,1369.57,1402.791,1420.671,1340.033z M1262.963,1576.215 c-5.278-26.862-10.517-53.526-15.797-80.397h-24.846v80.397H1262.963z M1499.558,1295.558c-0.593,0.866-0.572,2.27-0.553,3.42 c0.561,33.691,1.102,67.383,1.759,101.072c1.118,57.348,2.306,114.692,3.489,172.038c0.094,4.552,0.385,9.1,0.584,13.648 c0.53-0.003,1.061-0.007,1.591-0.011c2.011-102.003,4.021-204.006,6.032-306.009c-0.684-0.228-0.644-0.214-1.328-0.44 C1507.255,1284.69,1503.32,1290.065,1499.558,1295.558z M1079.369,1726.255c-0.105-16.127-13.08-28.872-29.183-28.669 c-16.212,0.206-28.692,12.95-28.599,29.203c0.094,16.213,12.797,28.666,29.137,28.564 C1066.972,1755.252,1079.475,1742.552,1079.369,1726.255z M1301.126,1726.266c-0.171-15.935-13.386-28.864-29.342-28.707 c-16.186,0.159-28.657,12.9-28.603,29.223c0.054,16.203,12.712,28.623,29.129,28.58 C1288.325,1755.318,1301.297,1742.221,1301.126,1726.266z M1190.061,1726.266c-0.17-15.935-13.386-28.864-29.341-28.707 c-16.187,0.159-28.657,12.9-28.604,29.223c0.054,16.203,12.712,28.623,29.129,28.58 C1177.26,1755.318,1190.232,1742.221,1190.061,1726.266z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5E5873"
    },
    d: "M1050.759,1750.18c13.087-0.093,23.538-10.775,23.409-23.93 c-0.128-13.041-10.974-23.655-23.969-23.456c-13.147,0.202-23.5,10.823-23.405,24.014 C1026.887,1739.938,1037.486,1750.275,1050.759,1750.18z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5E5873"
    },
    d: "M1271.96,1750.182c13.06,0.041,23.871-10.582,23.974-23.555 c0.101-12.789-10.871-23.79-23.772-23.834c-13.091-0.046-23.755,10.549-23.79,23.634 C1248.338,1739.601,1258.803,1750.14,1271.96,1750.182z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5E5873"
    },
    d: "M1161.283,1750.182c13.06,0.041,23.871-10.582,23.974-23.555 c0.101-12.789-10.871-23.79-23.772-23.834c-13.091-0.046-23.755,10.549-23.79,23.634 C1137.661,1739.601,1148.126,1750.14,1161.283,1750.182z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 287.453,
    y: 1467.06,
    style: {
      fill: "#6A6482"
    },
    width: 631.428,
    height: 42.602
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.453,
    y: 1467.06,
    style: {
      fill: "#6A6482"
    },
    width: 30.62,
    height: 237.665
  }), /*#__PURE__*/React.createElement("rect", {
    x: 435.034,
    y: 1476.38,
    style: {
      fill: "#6A6482"
    },
    width: 31.447,
    height: 237.276
  }), /*#__PURE__*/React.createElement("rect", {
    x: 302.763,
    y: 1561.814,
    style: {
      fill: "#6A6482"
    },
    width: 607.842,
    height: 33.203
  }), /*#__PURE__*/React.createElement("rect", {
    x: 882.881,
    y: 1497.946,
    style: {
      fill: "#6A6482"
    },
    width: 33.93,
    height: 181.148
  }), /*#__PURE__*/React.createElement("rect", {
    x: 740.128,
    y: 1491.913,
    style: {
      fill: "#6A6482"
    },
    width: 31.924,
    height: 212.811
  }), /*#__PURE__*/React.createElement("rect", {
    x: 575.443,
    y: 1497.946,
    style: {
      fill: "#6A6482"
    },
    width: 31.706,
    height: 206.778
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6A6482"
    },
    d: "M470.728,1523.757h-40.286c-1.502,0-2.718-1.217-2.718-2.718l0,0c0-1.501,1.217-2.719,2.718-2.719 h40.286c1.501,0,2.718,1.218,2.718,2.719l0,0C473.447,1522.54,472.229,1523.757,470.728,1523.757z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6A6482"
    },
    d: "M466.112,1421.235h-35.64c-1.422,0-2.576-1.153-2.576-2.576v-0.285 c0-1.422,1.153-2.575,2.576-2.575h35.64c1.423,0,2.576,1.153,2.576,2.575v0.285 C468.689,1420.082,467.535,1421.235,466.112,1421.235z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6A6482"
    },
    d: "M470.728,1558.126h-40.286c-1.502,0-2.718-1.218-2.718-2.719l0,0c0-1.501,1.217-2.718,2.718-2.718 h40.286c1.501,0,2.718,1.217,2.718,2.718l0,0C473.447,1556.908,472.229,1558.126,470.728,1558.126z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6A6482"
    },
    d: "M470.728,1606.771h-40.286c-1.502,0-2.718-1.217-2.718-2.718l0,0c0-1.501,1.217-2.719,2.718-2.719 h40.286c1.501,0,2.718,1.218,2.718,2.719l0,0C473.447,1605.555,472.229,1606.771,470.728,1606.771z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6A6482"
    },
    d: "M470.728,1657.45h-40.286c-1.502,0-2.718-1.217-2.718-2.718l0,0c0-1.502,1.217-2.719,2.718-2.719 h40.286c1.501,0,2.718,1.217,2.718,2.719l0,0C473.447,1656.233,472.229,1657.45,470.728,1657.45z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.453,
    y: 1415.799,
    style: {
      fill: "#6A6482"
    },
    width: 30.62,
    height: 76.114
  }), /*#__PURE__*/React.createElement("rect", {
    x: 435.034,
    y: 1415.799,
    style: {
      fill: "#6A6482"
    },
    width: 28.688,
    height: 76.114
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6A6482"
    },
    d: "M1013.83,1759.936c-9.06-9.02-13.999-21.04-13.909-33.846 c0.143-19.907,12.308-36.576,29.852-43.53v-20.553H274.212v103.298h746.042 C1017.979,1763.719,1015.829,1761.927,1013.83,1759.936z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#767D92"
    },
    d: "M2431.987,1845.914H274.212V1761.7h2196.479l0,0 C2499.075,1794.777,2475.573,1845.914,2431.987,1845.914z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0087FC"
    },
    d: "M2222.898,642.181l-35.158-15.673c0,0-183.204,146.987-211.268,154.611l22.322,62.598 c0,0,126.574-17.767,201.602-83.813S2222.898,642.181,2222.898,642.181z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7446"
    },
    d: "M2216.539,1717.35c0,0,2.959,19.974-18.494,30.33c-21.453,10.357-40.688,20.713-40.688,32.55 c0,11.836,133.157,7.397,133.157,0s-25.152-70.277-25.152-70.277L2216.539,1717.35z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7446"
    },
    d: "M2369.668,1720.309v42.166c0,0,48.824,33.289,93.949,33.289c0,0,36.249,1.297,36.249-8.229 s-25.216-26.922-55.707-41.85c-30.491-14.927-29.136-49.292-29.136-49.292l-45.355,7.641V1720.309z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#483342"
    },
    d: "M2387.797,1097.433c-14.43-72.497-248.642-48.891-245.234,8.877c0,0,7.397,142.033,22.193,298.862 c14.795,156.828,44.385,319.575,44.385,319.575h64.781c0,0-35.655-503.374-18.239-520.79c4.976-4.976,10.4-6.987,15.611-7.323 c13.322-0.856,24.802,9.435,26.563,22.668l68.113,511.364l59.18-5.919C2425.15,1724.747,2402.227,1169.929,2387.797,1097.433z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.53,
      fill: "#20211F"
    },
    d: "M2387.797,1097.433c-13.33-66.975-214.216-51.926-242.063-3.7 c0.112,0.251,18.195,40.726,79.573,40.726c50.681,0,129.798-7.01,162.988-34.324 C2388.129,1099.178,2387.962,1098.263,2387.797,1097.433z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C0422"
    },
    d: "M2371.492,1032.662c-35.293,39.141-213.239,68.803-230.146,8.813 c-0.052-0.185-0.1-0.387-0.15-0.577c-0.041,14.607-1.084,48.425,4.535,52.823c40.651,31.821,187.143,16.063,224.408-21.202 C2378.602,1064.056,2371.492,1032.662,2371.492,1032.662z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4185BF"
    },
    d: "M2262.073,1111.319h-72.022c-3.432,0-6.214-2.781-6.214-6.213v-34.838 c0-3.432,2.782-6.213,6.214-6.213h72.022c3.432,0,6.214,2.781,6.214,6.213v34.838 C2268.287,1108.538,2265.505,1111.319,2262.073,1111.319z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DDE9F3"
    },
    d: "M2254.609,1103.488h-58.604c-3.432,0-6.213-2.782-6.213-6.214v-17.944 c0-3.432,2.781-6.214,6.213-6.214h58.604c3.432,0,6.214,2.782,6.214,6.214v17.944 C2260.823,1100.706,2258.041,1103.488,2254.609,1103.488z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.53,
      fill: "#20211F"
    },
    d: "M2242.01,1502.803c5.779,95.373,12.981,167.742,20.051,221.944h11.861 c0,0-35.655-503.374-18.239-520.79C2255.683,1203.957,2224.372,1211.786,2242.01,1502.803z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0087FC"
    },
    d: "M2190.639,624.935c-5.91,0-72.561,365.549-54.733,422.691 c18.715,59.99,215.694,30.328,254.762-8.813c40.932-41.008,8.592-161.792,8.592-219.084c0-57.293,53.263-165.512,35.509-187.156 s-63.37-33.531-87.292-33.739C2319.473,598.592,2196.549,624.935,2190.639,624.935z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.56,
      fill: "#0065BD"
    },
    d: "M2300.796,908.662c8.52-0.576,18.571-0.447,25.95,2.133 c9.803,3.428,53.631,30.8,84.635,50.53c-0.138-19.61-2.081-40.541-4.373-60.816c-19.889-10.543-36.093-18.96-37.544-18.96 c-2.983,0-55.453-3.692-79.629-5.404l-69.38-205.824c-3.28-10.666-20.117-22.431-31.421-20.481 c-5.706,0.984-59.065,297.545-55.962,376.199l177.523,6.607c15.465,0.575,26.932-13.756,22.51-28.133L2300.796,908.662z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0065BD"
    },
    d: "M2236.771,645.318c0.639-1.718-0.421-3.566-2.365-4.13c-1.945-0.566-4.035,0.373-4.673,2.089 c-0.302,0.815-30.464,82.578-48.485,177.277c-23.389,122.917-16.697,210.133,19.844,259.481c3.154,0.333,6.379,0.611,9.654,0.847 c-37.97-46.3-45.662-135.854-22.208-259.164C2206.461,727.492,2236.47,646.129,2236.771,645.318z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#001E6E"
    },
    d: "M2288.617,1756.453c0,0,1.723,10.279,6.027,27.792c4.306,17.513,0,33.503,0,33.503 s-179.106-2.284-185.995-8.376c-6.889-6.091-1.938-26.46,0-28.173s24.972-6.473,37.026-12.944 c12.056-6.472,53.388-31.219,66.734-29.315c13.348,1.904,18.944,12.184,44.347,14.848 C2282.159,1756.453,2282.59,1751.123,2288.617,1756.453z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#334B8B"
    },
    d: "M2108.649,1809.372c6.889,6.091,185.995,8.376,185.995,8.376s2.825-10.492,1.609-23.787 c-94.268,11.662-187.604-12.762-187.604-12.762C2106.712,1782.912,2101.761,1803.281,2108.649,1809.372z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6678A8"
    },
    d: "M2296.254,1793.961c-64.434,8.884-134.852,1.947-187.604-12.762 c96.329,20.527,175.4,13.869,169.944,14.093C2278.832,1795.273,2297.438,1793.871,2296.254,1793.961z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#001E6E"
    },
    d: "M2364.756,1755.016c0,0-2.324,10.16-7.652,27.39c-5.327,17.229-1.97,33.445-1.97,33.445 s178.931,8.251,186.166,2.575c7.235-5.677,3.489-26.301,1.656-28.125s-24.548-7.93-36.201-15.099 c-11.654-7.17-51.46-34.304-64.896-33.188s-19.627,11.048-45.143,12.215C2371.202,1755.395,2371.086,1750.049,2364.756,1755.016z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#334B8B"
    },
    d: "M2541.3,1818.425c-7.235,5.676-186.166-2.574-186.166-2.574s-2.202-10.641-0.208-23.841 c93.42,17.186,188.03-1.709,188.03-1.709C2544.789,1792.125,2548.535,1812.749,2541.3,1818.425z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6678A8"
    },
    d: "M2354.926,1792.01c63.8,12.657,134.504,9.873,188.03-1.709 c-97.37,14.828-175.912,3.531-170.478,4.076C2372.24,1794.345,2353.75,1791.851,2354.926,1792.01z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF7446"
    },
    points: "2215.857,545.695 2228.906,651.359 2311.088,604.065 2266.853,526.842  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.68,
      fill: "#FF682B"
    },
    d: "M2276.855,544.757l-10.003-17.915l-50.995,18.854l7.184,58.167 c6.599-1.873,12.585-4.413,17.268-7.625C2253.972,586.861,2267.709,566.574,2276.855,544.757z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF916C"
    },
    d: "M2220.37,415.085c0,0-2.544-1.04-17.11,18.947c-10.382,14.248-16.652,31.274-23.133,47.53 c-9.65,24.21-17.701,50.56-10.428,76.486c3.822,13.627,58.521,17.335,80.54,5.602c22.019-11.733,42.46-49.369,41.161-76.184 C2290.102,460.651,2230.189,409.853,2220.37,415.085z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0B0080"
    },
    d: "M2256.372,545.566c3.37,7.169,9.023,9.148,26.136,9.466c22.002,0.409,43.854-16.272,49.404-46.747 c1.943-10.674,9.709-28.63,9.148-37.541c-4.34-68.896-83.086-79.43-103.191-87.323c-8.516-3.342-15.175-0.582-20.172,4.175 c-8.047,7.657-18.891,11.427-29.855,9.656c-4.796-0.774-17.506-1.077-20.953,6.234c-9.864,20.92-10.131,42.668,27.086,42.668 C2278.314,446.155,2249.874,531.743,2256.372,545.566z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#080060"
    },
    d: "M2195.418,397.611c-2.496,0.165-5.033,0.052-7.577-0.358c-3.365-0.544-10.631-0.855-15.855,1.537 c12.476,9.971,43.851,27.743,81.665,45.765c37.392,17.82,70.627,30.905,86.45,34.493c0.704-3.175,1.103-6.033,0.96-8.303 c-0.026-0.408-0.056-0.812-0.086-1.216c-14.098-10.266-43.566-26.723-78.545-43.393 C2236.678,413.863,2212.897,403.836,2195.418,397.611z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF916C"
    },
    d: "M2246.357,498.967c0,0,1.66-23.581,14.076-19.551c12.416,4.031,17.17,29.318,5.801,34.655 C2254.866,519.409,2246.357,498.967,2246.357,498.967z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6F81A6"
    },
    d: "M1950.208,660.817c0,0,5.622-4.59-8.771-10.098c-8.799-3.368-18.612-4.486-28.309-3.957 c-10.721,0.584-26.589,1.532-31.045,6.983c-0.504,0.615,31.229,161.275,31.229,161.275h77.858L1950.208,660.817z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#53617D"
    },
    d: "M1920.748,653.191c0,0-22.341,0.129-25.004,11.212c-0.871,3.622,37.096,39.739,37.096,39.739 L1920.748,653.191z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0065BD"
    },
    d: "M1895.744,664.404c0,0,35.866,5.81,55.438-6.714l73.694,334.483h-14.934L1895.744,664.404z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F2F9FF"
    },
    d: "M2205.518,664.559c-3.062-10.268-13.328-16.609-23.876-14.732 c-49.294,8.771-183.376,31.522-231.223,28.435c-59.091-3.812-68.335-24.516-68.335-24.516s-8.547,11.809,22.587,142.063 c23.515,98.375,45.216,168.118,54.431,196.364c2.736,8.388,10.406,14.17,19.224,14.508l303.577,11.655 c14.433,0.554,25.133-13.242,21.008-27.082L2205.518,664.559z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2302.91,991.254l-97.393-326.696c-3.062-10.267-13.328-16.608-23.876-14.732 c-49.294,8.771-183.376,31.522-231.223,28.435c-59.092-3.813-68.335-24.516-68.335-24.516s-5.874,8.12,9.859,85.119 c49.487,2.355,180.586-19.895,229.205-28.545c10.549-1.876,20.814,4.465,23.876,14.732l86.859,291.364l50.019,1.921 C2296.335,1018.89,2307.035,1005.094,2302.91,991.254z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0087FC"
    },
    d: "M2531.014,834.287c-3.496-10.485,0-9.32,0-21.747c0-12.427-18.793-19.343-21.453-27.686 c-21.265-66.681-59.764-137.253-74.793-152.281c-8.889-8.889-36.761,144.045-36.761,144.045s39.736,71.721,42.994,96.462 c30.563-3.25,70.953,3.261,101.39,8.467c0,0,7.263-20.855,7.263-30.563C2549.653,841.277,2534.508,844.773,2531.014,834.287z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#339FFD"
    },
    d: "M2425.15,853.316c0,0,3.277,24.837,15.153,26.788c11.876,1.95,101.408,62.734,114.786,64.343 c13.379,1.609,4.694-79.092,2.93-88.412c-1.764-9.32-14.968-10.654-44.094-12.317 C2484.801,842.054,2425.15,817.688,2425.15,853.316z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7446"
    },
    d: "M2563.408,962.959c6.193-41.94-20.266-81.775-61.022-93.449 c-51.331-14.702-121.51-26.736-139.068-31.629c-22.104-6.159-71.208-16.105-88.998-22.459c-17.792-6.354-40.03,6.672-54.327,3.813 c-14.295-2.859-8.26,11.437,4.767,11.437c13.025,0,27.64-4.448,27.64,0c0,4.448-22.557,6.036-39.076,2.542 c-16.521-3.495-16.521-3.498-16.521,1.904c0,5.402,24.146,16.84,56.232,12.71c0,0,7.466,1.429,5.083,3.812 c-2.383,2.383-39.076-4.448-49.242,0c-10.167,4.448-3.813,12.39,20.332,14.296s29.228,0.317,30.816,4.448 c1.589,4.13-35.899-3.177-37.806,2.859c-1.906,6.037,49.879,17.474,59.409,15.885c5.697-0.949,29.63-0.71,47.961-0.364 c7.44,0.141,14.704,2.215,21.101,6.02c40.29,23.966,194.319,112.803,209.769,79.699 C2561.576,972.081,2562.649,968.093,2563.408,962.959z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCB500"
    },
    d: "M2199.291,397.64c18.786-39.416,66.268-55.997,106.053-37.036 c39.787,18.962,56.812,66.287,38.025,105.703c-0.723,1.518-1.503,2.989-2.309,4.438l-143.762-68.516 C2197.916,400.69,2198.568,399.158,2199.291,397.64z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCC332"
    },
    d: "M2229.174,415.623c0.617-1.539,1.27-3.072,1.992-4.589c15.691-32.924,51.405-49.915,85.931-43.568 c-3.657-2.571-7.579-4.872-11.753-6.861c-39.785-18.961-87.267-2.38-106.053,37.036c-0.723,1.518-1.375,3.05-1.992,4.589 l143.762,68.516c0.262-0.473,0.521-0.948,0.778-1.426L2229.174,415.623z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FC9700"
    },
    d: "M2167.923,388.229c1.53-3.21,41.564,12.675,89.419,35.482 c47.854,22.807,85.406,43.899,83.876,47.11c-1.53,3.21-41.563-12.676-89.418-35.482 C2203.945,412.531,2166.393,391.44,2167.923,388.229z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7446"
    },
    d: "M1964.75,900.391c-2.676-5.447-24.029,23.888-25.301,22.604 c-4.444-4.492,28.75-28.66,22.525-33.605c-5.723-4.546-28.396,20.065-29.481,17.857c-1.729-3.523,29.396-21.794,20.156-27.326 c-3.355-2.009-21.054,14.001-23.807,13.644c-0.668-0.086,4.008-11.063,8.425-18.246c3.129-5.088-3.396-6.19-4.667-5.297 c-4.78,3.357-10.203,15.141-11,21.548c-3.417,27.475,20.36,44.987,20.36,44.987C1942.42,937.002,1967.425,905.839,1964.75,900.391 z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#232A55"
    },
    points: "802.875,581.333 811.477,562.278 857.324,562.156 857.324,587.667  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F25C12"
    },
    d: "M1361.19,752.453c0.31-0.29,0.618-0.588,0.921-0.891c3.435-3.435,1.749-11.367-7.245-16.613 c-8.994-5.247-44.469-3.248-44.469-3.248s15.239-21.984,16.738-32.477c1.499-10.493-1.499-24.233-12.991-20.735 c-11.492,3.497-1.749,9.743-9.993,22.734c-8.244,12.991-15.239,11.492-23.483,19.736c-8.244,8.244-4.497,10.992-11.742,26.981 c-7.245,15.989-53.339,30.43-53.339,30.43l-46.156,21.787c0,0,22.259,70.923,34,65.177c11.742-5.746,73.489-45.445,75.238-45.445 c29.416,0,55.71,4.247,70.949-3.997c8.112-4.388,8.295-8.918,6.693-12.195c-1.517-3.102-0.915-6.794,1.349-9.401 c3.878-4.466,3.274-8.501,1.749-11.386c-1.475-2.788-1.387-6.138,0.285-8.811c2.517-4.024,1.604-7.848-0.096-10.79 C1357.544,759.748,1358.19,755.265,1361.19,752.453z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0087FC"
    },
    d: "M1042.808,604.555c0,0,27.745,25.089,31.779,65.859c4.034,40.77,8.694,152.445,23.451,152.445 s121.018-84.123,127.489-47.96c6.162,34.435,15.477,52.733,18.808,74.039c4.143,26.493-105.248,81.568-178.586,85.303 C992.409,937.974,1042.808,604.555,1042.808,604.555z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0065BD"
    },
    d: "M1237.937,823.215c-44.975,36.65-162.838,82.716-183.442,77.005 c-24.123-6.685-11.69-295.563-11.687-295.666l0,0c-9.745,64.451-42.73,333.122,23.209,329.671 c73.337-3.854,182.456-58.828,178.318-85.289C1242.984,840.294,1240.647,832.146,1237.937,823.215z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0087FC"
    },
    d: "M698.254,704.737c53.221-140.504,123.094-138.676,123.094-138.676l125.294-0.319 c0,0,83.176,25.363,96.018,38.205c12.842,12.842,28.453,462.436,28.453,481.596c0,19.16-263.591,32.153-264.639,22.107 c-5.911-56.638-22.001-184.342-24.167-267.97c-0.143,0.161-26.573,30.168-26.573,76.877c0,22.889,25.753,104.688,42.985,164.063 l-57.976,36.383c-30.365-47.334-68.371-108.736-77.615-133.387C647.162,941.039,645.034,845.241,698.254,704.737z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0065BD"
    },
    d: "M1042.133,779.077c-3.699-32.701-31.725-57.182-64.627-56.479l-83.473,1.782 c-11.3-68.023-29.048-124.62-47.958-158.381l-24.728,0.063c0,0-6.757-0.177-17.669,3.805 c8.385,10.339,19.563,30.967,30.143,66.862c11.704,39.711,3.821,82.129-19.201,116.538c-6.809,10.176-10.759,22.417-10.718,35.563 l0.863,277.824c-0.31,1.282-1.042,4.343-1.891,8.119c1.4,12.516,2.635,23.642,3.599,32.878 c0.806,7.72,156.672,1.833,228.791-10.003c0.004-0.249,0.008-0.498,0.012-0.747c5.349-3.584,10.094-7.603,14.075-12.063 C1064.985,1067.319,1052.667,872.206,1042.133,779.077z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0065BD"
    },
    d: "M1003.827,587.662c-19.094-8.109-43.07-16.484-59.285-21.915l-1.604,0.004 c12.674,8.499,49.741,48.964,64.962,199.182c1.003,9.902,9.097,17.445,18.775,17.445l0,0c11.25,0,20.014-10.071,18.769-21.574 C1037.661,688.862,1022.446,626.389,1003.827,587.662z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7446"
    },
    d: "M989.923,1744.181c0,0-2.959,19.974,18.494,30.33c21.453,10.356,40.687,20.713,40.687,32.55 c0,11.836-133.156,7.396-133.156,0c0-7.398,25.152-70.277,25.152-70.277L989.923,1744.181z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7446"
    },
    d: "M836.794,1747.14v42.166c0,0-48.824,33.289-93.949,33.289c0,0-36.248,1.297-36.248-8.229 s25.216-26.923,55.708-41.85c30.491-14.927,29.135-49.292,29.135-49.292l45.355,7.641V1747.14z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#021F6E"
    },
    d: "M799.793,1124.263c14.429-72.496,267.514-48.89,264.106,8.877c0,0-7.397,142.034-22.193,298.862 c-14.795,156.829-21.725,320.719-21.725,320.719l-87.44-1.143c0,0,35.655-503.374,18.239-520.79 c-4.976-4.976-10.401-6.988-15.612-7.323c-13.322-0.856-24.801,9.435-26.563,22.667l-68.112,511.364l-93.267-9.326 C747.226,1748.17,785.363,1196.759,799.793,1124.263z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C0422"
    },
    d: "M834.97,1059.493c35.293,39.141,213.239,68.803,230.146,8.813c0.052-0.186,0.1-0.387,0.15-0.578 c0.042,14.608,1.085,48.426-4.534,52.824c-40.652,31.821-179.611,34.869-231.609-27.027 C827.188,1091.221,834.97,1059.493,834.97,1059.493z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.53,
      fill: "#20211F"
    },
    d: "M964.453,1529.634c-5.78,95.372-12.511,167.903-19.581,222.105l-12.331-0.161 c0,0,35.655-503.374,18.239-520.79C950.78,1230.788,982.09,1238.617,964.453,1529.634z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#001E6E"
    },
    d: "M917.845,1783.283c0,0-1.722,10.279-6.028,27.793c-4.305,17.513,0,33.502,0,33.502 s179.106-2.283,185.995-8.375s1.938-26.46,0-28.174c-1.938-1.713-24.971-6.472-37.026-12.943 c-12.056-6.473-53.388-31.219-66.734-29.315c-13.347,1.903-18.944,12.183-44.346,14.848 C924.303,1783.283,923.873,1777.953,917.845,1783.283z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#334B8B"
    },
    d: "M1097.813,1836.203c-6.889,6.091-185.995,8.375-185.995,8.375s-2.825-10.492-1.609-23.787 c94.268,11.663,187.604-12.762,187.604-12.762C1099.75,1809.743,1104.701,1830.111,1097.813,1836.203z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6678A8"
    },
    d: "M910.208,1820.791c64.434,8.885,134.852,1.947,187.604-12.762 c-96.329,20.528-175.4,13.869-169.943,14.094C927.63,1822.104,909.024,1820.702,910.208,1820.791z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#001E6E"
    },
    d: "M841.707,1781.846c0,0,2.323,10.16,7.651,27.391c5.328,17.229,1.97,33.444,1.97,33.444 s-178.931,8.251-186.166,2.575c-7.235-5.676-3.49-26.3-1.656-28.124c1.833-1.824,24.548-7.93,36.202-15.099 c11.654-7.17,51.459-34.305,64.895-33.189c13.436,1.116,19.628,11.049,45.143,12.215 C835.26,1782.226,835.376,1776.88,841.707,1781.846z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#334B8B"
    },
    d: "M665.162,1845.256c7.235,5.676,186.166-2.574,186.166-2.574s2.203-10.641,0.209-23.842 c-93.419,17.186-188.031-1.708-188.031-1.708C661.673,1818.956,657.927,1839.58,665.162,1845.256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6678A8"
    },
    d: "M851.537,1818.84c-63.8,12.658-134.504,9.873-188.031-1.708 c97.37,14.828,175.913,3.531,170.478,4.075C834.222,1821.176,852.712,1818.682,851.537,1818.84z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#021F6E"
    },
    d: "M1079.397,1078.327c-25.484,28.557-82.297,38.985-128.152,33.234 c-61.855-7.756-116.427-49.281-116.427-49.281l-0.869-279.961c-0.108-34.713,27.609-63.117,62.315-63.857l111.287-2.376 c32.902-0.702,60.928,23.779,64.627,56.48C1082.713,865.696,1095.031,1060.809,1079.397,1078.327z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#99C8F2"
    },
    d: "M488.261,1155.421c0,2.908-2.358,5.266-5.266,5.266c-2.908,0-5.266-2.357-5.266-5.266 s2.357-5.267,5.266-5.267C485.903,1150.154,488.261,1152.513,488.261,1155.421z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.53,
      fill: "#20211F"
    },
    d: "M859.523,731.099c1.577,12.087,3.366,26.708,4.299,34.787 c1.461,12.646,13.411,22.286,27.722,22.286c16.708,0,29.594-12.967,27.666-27.709c-1.706-13.05-3.949-29.243-6.249-42.358 l-16.696,0.356C882.479,718.756,869.797,723.414,859.523,731.099z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.53,
      fill: "#20211F"
    },
    d: "M1009.607,758.828c1.27,8.665,11.51,15.266,23.756,15.266h0 c14.236,0,25.324-8.813,23.75-18.878c-1.693-10.821-3.664-21.397-5.886-31.664c-12.386-4.96-26.809-7.692-42.061-7.467 l-7.438,0.11C1004.676,729.143,1007.334,743.316,1009.607,758.828z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#022687"
    },
    d: "M965.549,570.928c9.122,4.696,40.318,36.207,54.914,180.922c0.907,8.989,8.22,15.837,16.965,15.837 l0,0c10.166,0,18.084-9.143,16.96-19.584c-7.033-65.308-21.936-123.173-38.76-158.329 C997.426,581.413,980.09,575.773,965.549,570.928z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F25C12"
    },
    d: "M888.55,445.267c0,0-1.573,97.327-1.573,121.658c0,24.331,35.625,53.698,54.154,47.825 c18.528-5.873,37.983-26.849,37.983-26.849v-92.292L888.55,445.267z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.68,
      fill: "#FF682B"
    },
    d: "M979.114,533.915v-38.306l-44.22-24.58c-0.846-0.33-1.691-0.692-2.533-1.116 c-1.748-0.88-3.386-1.898-4.92-3.027l-38.892-21.618c0,0-0.017,1.015-0.046,2.839c0.03,0.192,0.046,0.296,0.046,0.296 s3.248,35.958,20.619,58.348C923.146,524.766,954.662,537.935,979.114,533.915z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7446"
    },
    d: "M909.863,328.224c0,0-25.014,52.858-20.845,93.761c4.169,40.902,71.567,94.39,101.445,78.029 c29.877-16.361,20.15-62.927,20.15-73.624c0-10.697,11.364-59.78,1.513-77.399C1002.275,331.37,928.623,311.233,909.863,328.224z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#232A55"
    },
    d: "M988.379,301.165c-40.995-15.102-87.098-7.543-104.225,12.586 c-38.796,45.597,2.822,123.336,2.822,123.336s4.821,33.352,22.192,54.117c17.371,20.766,61.84,34.61,86.159,19.507 c24.319-15.103,16.701-63.593,16.701-63.593s-3.499,11.364-13.227,11.364c-9.728,0-11.579-6.165-15.981-6.922 c-16.02-2.754-22.93,1.258-36.826,6.922c-4.169,1.699-8.963,0.736-13.632-1.444c-13.476-6.293-20.77-19.916-19.28-33.58 l3.729-34.195c20.845-10.697,32.657-26.429,32.657-26.429c7.642,25.17,66.27,19.445,75.041,7.551 C1033.281,358.49,1029.374,316.268,988.379,301.165z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCB500"
    },
    d: "M1011.668,313.423c-16.016-41.827-63.067-62.538-105.091-46.261 c-42.025,16.277-63.111,63.381-47.095,105.207c0.617,1.61,1.295,3.178,2.001,4.725l151.852-58.817 C1012.827,316.654,1012.285,315.034,1011.668,313.423z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCC332"
    },
    d: "M979.808,329.479c-0.507-1.624-1.05-3.244-1.666-4.854c-13.378-34.938-48.41-55.144-84.078-51.365 c3.928-2.344,8.106-4.39,12.513-6.097c42.024-16.278,89.076,4.434,105.091,46.261c0.617,1.61,1.159,3.23,1.666,4.854 l-151.852,58.817C861.253,376.59,979.808,329.479,979.808,329.479z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FC9700"
    },
    d: "M1044.364,306.259c-1.305-3.407-43.339,9.702-93.887,29.281 c-50.547,19.578-90.467,38.212-89.162,41.619c1.305,3.407,43.339-9.703,93.887-29.281 C1005.75,328.3,1045.669,309.667,1044.364,306.259z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7446"
    },
    d: "M903.479,392.745c0,0-7.375-13.04-16.503-9.044c-9.127,3.996-2.718,45.16,8.251,45.16 C906.198,428.86,903.479,392.745,903.479,392.745z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#022687"
    },
    d: "M912.683,763.451c-9.666-87-31.607-161.239-55.358-201.295l-45.847,0.122 c15.631,14.586,45.749,68.817,59.22,206.011c1.108,11.281,10.166,19.882,21.014,19.882 C904.376,788.172,914.144,776.604,912.683,763.451z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#99C8F2"
    },
    cx: 894.118,
    cy: 762.42,
    r: 5.266
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#99C8F2"
    },
    d: "M1045.562,750.349c0,2.908-2.357,5.266-5.266,5.266s-5.266-2.358-5.266-5.266 c0-2.908,2.358-5.266,5.266-5.266S1045.562,747.44,1045.562,750.349z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6F81A6"
    },
    d: "M1036.727,1038.96l-123.734,26.643c-9.37,2.018-13.343,12.369-7.511,19.568l65.365,80.697 c5.966,7.364,18.086,6.428,22.528-1.741l58.368-107.339C1056.863,1047.372,1047.774,1036.581,1036.727,1038.96z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6F81A6"
    },
    d: "M805.823,1205.723c-1.989-0.042-3.958-0.857-5.42-2.428c-2.867-3.081-2.693-7.903,0.388-10.77 l64.045-59.591c6.411-5.966,15.349-8.413,23.906-6.571l22.48,4.864c6.085,1.313,12.348-0.531,16.745-4.944l20.943-21.021 c2.971-2.98,7.795-2.989,10.776-0.02c2.981,2.97,2.991,7.795,0.02,10.776l-20.943,21.021 c-8.077,8.106-19.577,11.506-30.764,9.082l-22.479-4.863c-3.687-0.795-7.541,0.262-10.304,2.832l-64.044,59.592 C809.663,1205.088,807.734,1205.763,805.823,1205.723z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#53617D"
    },
    d: "M959.033,1104.663c-0.814,3.881-2.25,3.415-23.002,24.828 c-8.077,8.107-19.577,11.507-30.764,9.083l-22.479-4.863c-3.687-0.796-7.541,0.262-10.304,2.832l-64.044,59.591 c-2.812,2.618-7.037,2.682-9.916,0.4c-1.538,7.34,7.299,12.127,12.648,7.148l64.044-59.592c2.764-2.57,6.618-3.627,10.304-2.832 l22.479,4.863c11.187,2.424,22.686-0.976,30.764-9.082l20.943-21.021C962.912,1112.802,962.615,1107.502,959.033,1104.663z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8F4800"
    },
    d: "M879.05,1142.682l-66.568,76.237c-7.086,8.113-19.407,8.947-27.521,1.863 c-8.114-7.086-8.949-19.407-1.863-27.521c0.896-1.025,1.962-1.996,3.007-2.788l81.037-60.634 c3.894-2.913,9.413-2.119,12.326,1.775C882.002,1135.001,881.726,1139.62,879.05,1142.682z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8C9AB8"
    },
    d: "M1048.122,1041.392c-2.995-2.262-7.043-3.369-11.396-2.432l-123.734,26.643 c-6.537,1.407-10.446,6.87-10.233,12.49c15.45,14.171,37.507,23.037,61.993,23.037 C1006.527,1101.13,1041.231,1075.323,1048.122,1041.392z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7446"
    },
    d: "M795.845,1082.423c2.709,9.334,10.413,32.671,16.795,47.27c2.283,5.221,5.343,15.246,9.006,19.611 c14.543,17.33,30.546,32.921,27.078,45.752c-5.005,18.518-44.212,51.938-62.114,45.049c-22.566-8.684-17.702-83.627-24.287-93.619 c-7.362-11.172-8.343-11.72-20.266-30.307L795.845,1082.423z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7446"
    },
    d: "M443.86,1771.857c0,0-0.181,1.658-0.181,4.426c-0.002,8.305,1.616,26.602,14.595,40.104 c17.305,18.004,17.408,40.4-0.874,44.227c-18.283,3.826-61.881-1.224-61.881-1.224s-9.857-17.128-3.126-62.878 c6.731-45.749,10.637-95.924,10.637-95.924l49.677-7.757L443.86,1771.857z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#001653"
    },
    d: "M453.595,1791.309c0,0,18.428,25.007,22.741,35.441c4.313,10.434,3.385,36.383,0,39.056 c-29.799,23.525-86.296,2.353-86.296,2.353s-3.884-17.252-5.845-38.425c-1.961-21.173-0.856-40.903,5.845-40.903 c6.702,0,7.878,11.104,23.17,7.968C428.501,1793.661,437.912,1788.172,453.595,1791.309z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7B5119"
    },
    d: "M385.353,1840.278c11.485,4.487,27.08,9.733,41.581,11.804c15.478,2.211,36.317-4.68,52.041-11.603 c0.815,11.092-0.351,23.521-2.638,25.326c-29.799,23.525-86.296,2.353-86.296,2.353S387.381,1856.348,385.353,1840.278z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#957447"
    },
    d: "M385.353,1840.278c42.75,12.843,50.615,15.118,93.622,0.201c-7.16,3.848-14.684,7.04-22.483,9.506 c-16.527,5.121-26.286,4.675-36.596,2.361C407.595,1849.612,396.016,1845.432,385.353,1840.278z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F25C12"
    },
    d: "M940.862,993.621c-12.229,4.6-28.443,11.425-28.443,11.425 c-2.096-5.046,38.271-13.675,43.932-25.962c3.031-6.579-46.322,17.636-49.75,14.75c-1.422-1.197,55.826-19.833,53.185-24.331 c-2.22-3.78-60.191,16.652-60.511,13.824c-0.444-3.93,50.192-14.086,45.659-19.743c-2.322-2.899-63.779,13.725-70.413,14.693 c-8.115,0,21.246-19.943,11.246-22.61c-13.582-3.622-47.691,35.479-50.354,36.031c-7.721,1.601-73.459,9.649-105.646-11.402 c-25.997-17.003-51.221-43.151-57.396-65.666c-6.054-22.074-14.442-53.603-7.272-77.925c-29.282-4.457-57.689-5.479-87.406-1.929 c-1.807,36.524,41.924,181.25,60.208,193.158c40.227,26.199,111.994,19.791,162.591,15.624 c40.779-3.357,80.716-11.391,117.444-30.029c8.209-4.166,19.207-8.833,25.561-16.083 C945.141,995.571,943.195,992.743,940.862,993.621z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FA8E00"
    },
    d: "M646.815,714.11c21.792,22.509,43.798,157.371,35.699,189.515 c-13.984,26.109-77.31,30.615-97.788,43c-47.242-19.424-14.879-106.535-14.879-106.535l-17.222-169.676 C552.625,670.414,605.308,671.236,646.815,714.11z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7446"
    },
    d: "M587.239,1741.698c-6.448,20.274-0.073,42.595,16.456,55.988 c5.706,4.623,12.333,8.956,19.828,12.233c28.938,12.65,66.419,9.806,71.644,35.791c5.225,25.984-183.498-7.293-183.498-7.293 s13.094-63.201,13.941-73.787c0.847-10.585-1.155-49.461-1.155-49.461l72.884-5.232L587.239,1741.698z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#001653"
    },
    d: "M519.334,1793.693c0,0-2.308,10.035-7.593,27.051c-5.285,17.016-1.988,33.04-1.988,33.04 s176.766,8.374,183.921,2.775c7.155-5.599,3.481-25.979,1.672-27.783c-1.809-1.805-24.242-7.864-35.747-14.962 c-11.504-7.099-50.797-33.955-64.072-32.87c-13.275,1.085-19.405,10.891-44.614,12.012S525.595,1788.795,519.334,1793.693z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7B5119"
    },
    d: "M693.674,1856.56c-7.155,5.599-183.921-2.775-183.921-2.775s-2.163-10.516-0.176-23.555 c92.273,17.095,185.768-1.453,185.768-1.453C697.154,1830.58,700.829,1850.961,693.674,1856.56z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#957447"
    },
    d: "M509.577,1830.229c63.016,12.585,132.872,9.922,185.768-1.453 c-96.216,14.528-173.799,3.271-168.431,3.814C526.68,1832.559,508.415,1830.072,509.577,1830.229z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#021F6E"
    },
    d: "M373.06,1129.203c-30.33,110.899,7.326,608.363,7.326,608.363l90.798-6.213 c0,0,20.655-494.881,35.636-509.861c4.385-4.386,9.097-2.995,12.712-0.508c3.65,2.512,6.215,6.305,7.512,10.542 c9.344,30.535,62.751,208.284,51.984,247.208c-11.789,42.62-64.397,270.942-64.397,270.942l76.186,3.044 c0,0,104.456-174.429,104.456-296.2c0-121.772-16.99-283.191-66.35-348.87c-22.466-29.893-133.079-53.02-133.079-53.02 S382.534,1094.562,373.06,1129.203z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#021753"
    },
    d: "M484.313,1161.097c1.465-13.277-8.109-25.229-21.387-26.693 c-79.869-8.02-79.969-10.66-89.108-7.451c-9.174,23.074-11.636,102.491-12.14,127.26c6.281,19.212,23.302,33.971,44.7,36.332l0,0 c29.171,3.22,55.429-17.817,58.649-46.988l4.717-42.732l10.061,1.111L484.313,1161.097z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#021753"
    },
    d: "M537.156,1749.476c0,0,52.607-243.451,64.396-288.896c8.561-33.001-23.453-159.593-41.626-226.441 c-5.457-20.071-29.563-28.148-46.025-15.435l0,0c0,0,76.917,217.41,65.127,260.03c-11.789,42.62-64.397,270.942-64.397,270.942 l76.186,3.044c0,0,0.19-0.317,0.555-0.936L537.156,1749.476z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#021753"
    },
    d: "M391.905,1106.187c-9.734,7.61-16.773,15.439-18.846,23.017 c-30.33,110.899,7.326,608.363,7.326,608.363l22.485-1.539C401.607,1718.035,369.003,1249.796,391.905,1106.187z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#021753"
    },
    d: "M646.363,1137.39c-5.302-11.3-11.104-21.309-17.44-29.738c-2.609-3.473-6.408-6.853-11.083-10.116 c-12.622,6.448-30.075,13.48-54.208,20.901c-72.789,22.383-151.266,10.45-183.875-0.902c-3.313,3.914-5.645,7.824-6.696,11.669 c-2.631,9.619-4.75,22.147-6.427,37.006c16.278,12.108,110.903,41.361,196.998,13.961 C618.271,1162.78,638.636,1152.246,646.363,1137.39z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5D70A2"
    },
    d: "M380.421,1775.233c23.265,7.552,79.261,5.679,92.631,0c12.331-5.237,13.164-51.101,0-53.589 c-18.494-3.494-70.92-3.106-92.631,0C367.159,1723.543,367.679,1771.098,380.421,1775.233z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5D70A2"
    },
    d: "M518.49,1754.744c23.265,7.552,79.261,5.68,92.631,0c12.331-5.237,13.164-51.101,0-53.588 c-18.494-3.495-70.92-3.107-92.631,0C505.228,1703.054,505.747,1750.608,518.49,1754.744z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8F4800"
    },
    d: "M638.925,1069.405c-3.077,9.664-16.977,26.227-79.636,45.652 c-81.58,25.29-170.897,3.527-182.853-7.222c-4.859-4.368-5.934,45.616,0,50.955c23.624,21.253,65.483,25.087,95.809,25.989 c31.462,0.938,62.98-4.125,93.032-13.288c25.563-7.795,63.8-17.571,75.884-44.094 C642.741,1123.93,643.162,1097.337,638.925,1069.405z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#99C8F2"
    },
    d: "M488.261,1155.421c0,2.908-2.358,5.266-5.266,5.266c-2.908,0-5.266-2.357-5.266-5.266 s2.357-5.267,5.266-5.267C485.903,1150.154,488.261,1152.513,488.261,1155.421z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BC9166"
    },
    d: "M401.282,1274.719L401.282,1274.719c-26.372-2.911-45.391-26.649-42.48-53.022l8.439-76.459 l95.503,10.541l-8.44,76.46C451.394,1258.61,427.655,1277.63,401.282,1274.719z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 358.29,
    y: 1175.649,
    transform: "matrix(0.994 0.1097 -0.1097 0.994 132.563 -37.6814)",
    style: {
      fill: "#D2B699"
    },
    width: 100.833,
    height: 20.318
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D2B699"
    },
    d: "M467.664,1194.61l-114.397-12.627l4.075-36.92c1.325-12.003,12.129-20.66,24.132-19.335 l70.931,7.829c12.003,1.325,20.659,12.13,19.335,24.133L467.664,1194.61z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#99C8F2"
    },
    d: "M417.416,1176.549c-0.319,2.891-2.921,4.976-5.811,4.656s-4.976-2.921-4.656-5.812 c0.319-2.891,2.921-4.976,5.811-4.656C415.65,1171.056,417.735,1173.658,417.416,1176.549z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D2B699"
    },
    d: "M397.111,1232.569c-13.74-17.342-0.771-57.135,6.914-83.271l0,0 c1.995-6.783,4.02-13.631,5.918-20.427l-28.468-3.143c-12.003-1.325-22.808,7.332-24.132,19.335l-4.075,36.92l9.799,1.081 l-4.265,38.632c-3.278,29.705,21.088,55.178,50.962,53.213C412.083,1261.618,408.49,1246.93,397.111,1232.569z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCB500"
    },
    d: "M483.803,666.612c0,0-75.717-3.893-106.663,32.778c-30.946,36.671-25.789,397.697-13.263,408.446 c12.526,10.749,106.102,39.035,191.573,13.745c85.471-25.291,90.913-60.011,90.913-60.011s-11.337-230.668-11.337-301.482 C635.026,689.273,565.888,647.56,483.803,666.612z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FA8E00"
    },
    d: "M417.017,1056.853c-6.691-18.604,0.47-77.773,8.086-120.579c5.961,1.14,11.693,2.495,17.109,4.058 c9.147-28.314,17.207-101.8,17.477-147.998c0.508-86.66-43.366-111.864-43.366-111.864c-8.693-1.985-22.601,6.197-44.356,28.843 c-25.129,68.7-19.866,388.417-8.089,398.523c5.02,4.308,23.061,11.433,48.381,16.797 C418.836,1098.792,423.203,1074.049,417.017,1056.853z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCDB86"
    },
    d: "M477.273,667.408c-16.42,15.092-17.693,15.38-0.635,35.182 c17.058,19.801,73.54,42.315,81.595,38.511c19.99-9.438,1.387-40.947-11.92-63.61 C542.158,670.414,493.693,652.316,477.273,667.408z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F25C12"
    },
    d: "M550.661,610.351c0,0,4.421,104.267,0,108.833s-67.788-17.504-73.313-30.442 c-5.526-12.939,23.091-201.431,23.091-201.431L550.661,610.351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#B5450E"
    },
    d: "M552.572,679.105c-11.202-2.018-20.845-4.867-23.677-8.066 c-25.848-29.199-6.479-76.58-8.509-88.901c-4.042-24.521-12.281-44.78-8.15-65.924l38.425,94.137 C550.661,610.351,552.259,648.051,552.572,679.105z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#011037"
    },
    d: "M253.23,1376.866c6.21,0,11.245-5.035,11.245-11.245v-65.8c0-8.205,6.676-14.881,14.88-14.881 h65.897c6.21,0,11.245-5.035,11.245-11.246c0-6.209-5.035-11.244-11.245-11.244h-65.897c-20.607,0-37.371,16.764-37.371,37.371 v65.8C241.984,1371.831,247.02,1376.866,253.23,1376.866z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8C114D"
    },
    d: "M424.332,1539.124H188.955c-8.805,0-15.943-7.137-15.943-15.942v-90.89 c0-8.805,7.138-15.943,15.943-15.943h235.377c8.805,0,15.943,7.139,15.943,15.943v90.89 C440.275,1531.987,433.137,1539.124,424.332,1539.124z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172.624,
    y: 1458.738,
    style: {
      opacity: 0.49,
      fill: "#991354"
    },
    width: 233.004,
    height: 23.919
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#991354"
    },
    d: "M262.743,1331.154c-7.971,0-15.661,2.955-21.59,8.298l-72.307,77.052 c-4.547,4.846-7.077,11.241-7.077,17.886v26.428c0,6.215,5.038,11.254,11.254,11.254h270.931c6.215,0,11.254-5.039,11.254-11.254 v-37.687l1.293-91.977H262.743z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5D0B33"
    },
    d: "M456.499,1331.154H262.743c-7.971,0-15.661,2.955-21.59,8.298l-72.306,77.052 c-0.712,0.759-1.375,1.556-1.986,2.386l288.347,4.241l1.293-91.977H456.499z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7931E"
    },
    d: "M384.049,1539.124h146.563c8.695,0,15.744-7.531,15.744-16.823v-97.781 c0-4.462-1.659-8.741-4.611-11.896l-71.475-76.381c-6.047-6.463-15.817-6.583-22.004-0.272l-75.088,76.61 c-3.111,3.175-4.872,7.571-4.872,12.169v97.552C368.306,1531.593,375.354,1539.124,384.049,1539.124z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BF2604"
    },
    d: "M441.393,1443.974h27.628c3.881,0,7.028-3.146,7.028-7.029v-27.627 c0-3.882-3.147-7.028-7.028-7.028h-27.628c-3.882,0-7.028,3.146-7.028,7.028v27.627 C434.365,1440.827,437.511,1443.974,441.393,1443.974z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCC332"
    },
    d: "M443.853,1441.514h27.628c3.882,0,7.028-3.146,7.028-7.028v-27.628 c0-3.882-3.146-7.028-7.028-7.028h-27.628c-3.882,0-7.028,3.146-7.028,7.028v27.628 C436.824,1438.367,439.971,1441.514,443.853,1441.514z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FA8E00"
    },
    d: "M307.771,1497.946h10.787c2.766,0,5.008-2.242,5.008-5.008v-32.393 c0-2.766-2.242-5.008-5.008-5.008h-10.787c-2.766,0-5.008,2.242-5.008,5.008v32.393 C302.763,1495.704,305.005,1497.946,307.771,1497.946z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FA8E00"
    },
    d: "M210.427,1497.946h10.787c2.766,0,5.008-2.242,5.008-5.008v-32.393 c0-2.766-2.242-5.008-5.008-5.008h-10.787c-2.766,0-5.008,2.242-5.008,5.008v32.393 C205.419,1495.704,207.661,1497.946,210.427,1497.946z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#011037"
    },
    d: "M457.667,1428.538c6.211,0,11.246-5.035,11.246-11.245v-117.472 c0-20.607-16.765-37.371-37.372-37.371h-86.288c-6.211,0-11.245,5.035-11.245,11.244c0,6.211,5.035,11.246,11.245,11.246h86.288 c8.206,0,14.881,6.676,14.881,14.881v117.472C446.421,1423.503,451.457,1428.538,457.667,1428.538z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F25C12"
    },
    d: "M398.758,1056.852c14.977,45.579-37.765,144.168-16.343,175.718 c21.422,31.55,10.643,64.68-15.317,81.104c-25.961,16.425-58.227-6.594-55.625-19.098c2.602-12.504,9.604-46.168,12.806-61.557 c3.202-15.39-57.178-138.683-14.675-213.453c25.221-44.367-12.071-120.73,7.625-170.07 c17.633,32.859,101.094,12.327,96.309,48.385C405.921,928.68,390.34,1031.233,398.758,1056.852z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7446"
    },
    d: "M592.291,472.596c0,0,11.052,38.054,11.052,69.257c0,31.204-0.736,85.24-22.841,85.24 s-53.788-6.088-61.156-50.231c-7.368-44.143,0-92.851,22.104-104.267C563.555,461.18,592.291,472.596,592.291,472.596z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#100062"
    },
    d: "M585.525,503.32c-6.414-2.646-13.046,3.08-11.82,10.101c1.965,11.253,1.481,23.58-9.045,26.15 c-20.263,4.947-29.841,0-33.157,3.425c-3.316,3.425,9.579,21.691,0,25.116s-14.737-29.301-23.21-29.301 c-8.473,0-10.315,47.187,0,57.841c10.315,10.655-1.474,25.116-15.105,25.116c-13.631,0,1.724,17.124-16.638,22.832 c-18.361,5.708-33.098,5.708-38.992-17.505c-5.895-23.213,0-36.151,0-36.151s-18.767-21.945-13.999-43.635 c2.65-12.057,14.85-33.744,14.85-33.744s9.465-25.747,12.043-40.587c2.579-14.841,39.115-29.682,64.135-32.346 c25.021-2.664,12.494-17.885,33.494-17.885s23.885,27.732,23.885,27.732s29.984-17.926,31.376-17.077 c17.451,10.63,2.948,29.301,2.948,29.301s14.368,1.522,17.315,20.169c2.947,18.646-9.21,30.063-28.367,23.974 C591.611,505.691,588.38,504.498,585.525,503.32z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0C004A"
    },
    d: "M606.276,435.502c-3.695,0.529-8.562,1.699-14.39,3.438c-8.972,4.993-19.919,11.538-19.919,11.538 s-39.141,10.954-61.572,21.645c-28.746,13.7-53.937,27.444-70.849,38.274c-0.704,1.992-1.136,3.168-1.136,3.168 s-4.486,7.975-8.609,16.941c17.808-3.891,52.579-17.3,91.364-35.785C564.963,473.846,608.744,437.596,606.276,435.502z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#100062"
    },
    d: "M541.696,535.251c0,0-5.404,62.668,0,68.25c5.403,5.581,23.823-1.269,31.438-9.133 c7.613-7.864,27.502-4.433,27.502-0.881c0,3.552,9.349,59.769-1.949,66.253c-11.298,6.483-59.898,2.148-63.868-7.023 c-28.243-65.248-7.368-121.771-7.368-121.771L541.696,535.251z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7446"
    },
    d: "M521.595,536.247c0,0-10.132-18.654-19.153-8.245c-9.021,10.41-4.284,54.424,9.576,54.424 C525.879,582.425,526.507,548.043,521.595,536.247z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCC332"
    },
    d: "M418.65,681.282c0,0,25.75,19.599,25.287,106.259c-0.246,46.199-13.808,124.477-22.163,152.791 c-34.683-10.961-83.593-11.672-119.01,0c-4.774-37.809,4.866-118.492,10.878-144.559 C328.424,731.67,381.851,666.615,418.65,681.282z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCB500"
    },
    d: "M580.178,440.458c-18.786-39.415-66.268-55.997-106.053-37.035 c-39.786,18.962-56.811,66.286-38.025,105.702c0.724,1.518,1.503,2.989,2.31,4.439l143.761-68.516 C581.553,443.509,580.901,441.977,580.178,440.458z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCC332"
    },
    d: "M550.296,458.442c-0.618-1.539-1.27-3.071-1.993-4.589c-15.691-32.924-51.405-49.915-85.93-43.569 c3.657-2.571,7.579-4.872,11.752-6.86c39.786-18.962,87.268-2.38,106.053,37.035c0.723,1.518,1.375,3.05,1.993,4.589 L438.41,513.564C438.147,513.091,550.296,458.442,550.296,458.442z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FC9700"
    },
    d: "M611.547,431.047c-1.53-3.211-41.564,12.675-89.418,35.482 c-47.854,22.807-85.407,43.899-83.877,47.109c1.53,3.211,41.564-12.675,89.418-35.483 C575.524,455.35,613.077,434.258,611.547,431.047z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1836.402,
    y: 1485.964,
    style: {
      fill: "#5E5873"
    },
    width: 16.74,
    height: 281.56
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#011037"
    },
    d: "M1834.452,1345.343l-108.012,187.081c-5.08,8.8,1.271,19.799,11.431,19.799h216.022 c10.161,0,16.511-10.999,11.431-19.799l-108.012-187.081C1852.232,1336.544,1839.532,1336.544,1834.452,1345.343z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCB500"
    },
    d: "M1737.871,1543.623c-2.396,0-3.584-1.608-3.983-2.3s-1.198-2.523,0-4.6l108.011-187.081 c1.199-2.076,3.186-2.3,3.984-2.3s2.785,0.224,3.982,2.3l108.012,187.081c1.199,2.076,0.399,3.908,0,4.6 c-0.398,0.691-1.586,2.3-3.983,2.3H1737.871z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#011037"
    },
    d: "M1863.993,1444.557c-5.99-0.006-10.87-4.8-10.85-10.659c0.019-5.422,4.521-9.603,10.297-9.561 c5.735,0.043,10.378,4.666,10.269,10.36C1873.607,1439.979,1869.316,1444.89,1863.993,1444.557z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#011037"
    },
    d: "M1898.822,1512.843c-0.182-0.985-0.641-1.925-1.014-2.869c-0.472-1.192-1.369-1.825-2.659-1.892 c-1.2-0.063-2.401-0.179-3.602-0.18c-0.754-0.001-1.151-0.202-1.381-0.99c-1.959-6.731-14.242-8.063-18.452-1.027l-26.535-21.548 c3.979-6.697,7.78-13.154,11.644-19.574c1.819-3.024,2.136-6.096,0.931-9.432c-1.898-5.251-5.157-9.488-9.424-12.979 c-1.127-0.922-2.397-1.923-3.754-2.246c-5.717-1.36-12.051-0.122-23.13-0.041c-2.39,0.018-3.506,1.266-4.426,3.078 c-1.044,2.059-0.901,3.91-2.843,12.117c-0.331,1.396-0.508,2.365-0.775,2.885c-0.246,0.479-0.569,0.902-1.159,0.599l-1.86-1.307 l-6.328-5.107c-0.776-0.627-1.914-0.506-2.542,0.271c-0.627,0.776-0.505,1.915,0.271,2.542l9.687,7.818 c1.378,1.328,2.842,2.785,3.828,3.893c-3.564,1.818-4.933,4.9-4.996,8.583c-0.067,3.835,0.063,7.677,0.193,11.513 c0.455,13.515-6.199,30.813-5.717,33.394c0.344,1.837,1.171,3.315,2.995,4.033c2.11,0.83,4.21,0.655,6.163-0.403 c0.901-0.488,4.981-10.725,6.989-21.427c1.537-8.191,1.211-16.656,1.211-21.233c5.357,6.265,6.297,7.545,11.72,13.971 c1.543,1.829-9.26,21.958-9.803,24.522c-1.221,5.77,5.257,7.192,8.102,4.264c3.498-3.603,11.304-19.867,13.45-23.704 c1.687-3.014-1.064-9.547-1.913-11.395l23.863,19.262c-1.979,0.785-2.963,2.485-4.277,3.82c-0.844,0.856-1.973,1.928-3.02,1.982 c-2.141,0.11-2.888,1.256-3.381,2.983c-0.734,2.575-2.627,1.661-7.109,3.81c-1.923,0.922-3.255,2.482-4.191,4.609 c8.42,0.632,63.127-0.127,66.264-0.575C1910.168,1518.267,1900.277,1520.719,1898.822,1512.843z M1841.92,1468.999 c0,0.695-4.168,7.648-4.801,9.19c-1.645-1.412-3.426-2.942-5.376-4.616C1835.338,1471.957,1838.509,1470.532,1841.92,1468.999z  M1824.338,1450.917h6.678c-2.854,2.898-8.45,8.232-8.593,8.202C1823.055,1456.411,1823.688,1453.704,1824.338,1450.917z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5881A5"
    },
    d: "M637.913,1095.473h-22.35v-18.59h40.94l0,0C656.503,1087.149,648.179,1095.473,637.913,1095.473z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5881A5"
    },
    d: "M668.826,1057.04h-71.436v-34.48h36.955C653.389,1022.56,668.826,1037.997,668.826,1057.04 L668.826,1057.04z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 615.563,
    y: 1076.883,
    style: {
      fill: "#5881A5"
    },
    width: 15.532,
    height: 18.59
  }), /*#__PURE__*/React.createElement("rect", {
    x: 597.391,
    y: 1022.56,
    style: {
      fill: "#5881A5"
    },
    width: 33.704,
    height: 34.48
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5881A5"
    },
    d: "M609.923,1212.86L609.923,1212.86c-7.614,0-13.786-6.172-13.786-13.786V1022.56h27.571v176.515 C623.709,1206.688,617.537,1212.86,609.923,1212.86z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#8F4800"
    },
    points: "625.86,1128.45 588.248,1143.71 588.434,1129.39 626.801,1112.521  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#99C8F2"
    },
    d: "M499.146,1188.212c-3.353,0-6.212-2.806-6.523-6.541c-0.329-3.956,2.329-7.457,5.935-7.817 l38.153-3.813c4.435-0.443,8.447-2.754,11.298-6.508c2.85-3.753,4.197-8.499,3.793-13.365l-0.12-1.436 c-0.404-4.867-2.51-9.269-5.932-12.396c-3.421-3.126-7.75-4.607-12.183-4.16l-38.154,3.813c-3.613,0.344-6.797-2.555-7.125-6.514 c-0.329-3.957,2.329-7.455,5.936-7.816l38.153-3.813c7.929-0.782,15.655,1.85,21.768,7.437c6.113,5.587,9.878,13.45,10.6,22.144 l0.12,1.436c0.722,8.695-1.686,17.175-6.778,23.882c-5.092,6.706-12.261,10.836-20.185,11.627l-38.152,3.813 C499.546,1188.202,499.345,1188.212,499.146,1188.212z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C9E2F4"
    },
    d: "M534.355,1150.706c-1.193-0.179-2.089-1.527-2.091-3.304c-0.002-2.047,1.181-3.888,2.644-4.11 l32.287-4.934c1.464-0.225,2.65,1.255,2.653,3.301c0.002,2.047-1.181,3.889-2.644,4.111l-32.286,4.934 C534.724,1150.733,534.536,1150.733,534.355,1150.706z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg74165494786);
export default __webpack_public_path__ + "static/media/7416549_4786.8a5edf37d8befe3ee49d46dc99f6f837.svg";
export { ForwardRef as ReactComponent };